// GENERATED by scripts/build-legacy.mjs from client/legacy/src. Do not edit.
/* eslint-disable */
// Tiny Town character parts. Body grid is 18x24, drawn inside a 30x32 canvas grid at (6,6).
const GW = 32, GH = 34, OX = 7, OY = 8;

// Master palette. "sampled" colors come straight from the Tiny Town sheets; "added" fill gaps the sheets don't cover.
const PAL = {
  outline:'#171b20',
  skin:'#fcd8a1', skinShade:'#f2b98a', nose:'#f69a6b', coral:'#f5777d', mouth:'#8a3b36', blush:'#fbae94',
  sky:'#a3def4', skyShade:'#7cc0d8', peri:'#a5bbe8', periShade:'#8299d6',
  red:'#db614f', redDeep:'#b4473b', tan:'#d49364', orange:'#eba25e', cream:'#e9cfb5', yellow:'#f9c776', yellowShade:'#e0a94e',
  paleYellow:'#fdecb9', greenLight:'#aed287', teal:'#79af98', tealLight:'#89c9bc', denim:'#4e83ad', mauve:'#917c9a',
  lavender:'#a77daa', lavenderShade:'#86618a', pinkPale:'#fdc9ca', pink:'#f29bb8', pinkShade:'#d67599', brown:'#7a473f', brownDark:'#583937',
  white:'#fbf7ee', whiteShade:'#e3dccb', silver:'#c9ced6', silverShade:'#9aa3ad', shine:'#ffffff',
  green:'#6aa04a', greenShade:'#4e7d36', denimShade:'#3d6a8f', navy:'#3d4a8c', navyShade:'#2c3566',
  khaki:'#cdbb8c', khakiShade:'#a8966a', straw:'#f2c35c', strawShade:'#c98a3a', charcoal:'#3a3436', charcoalShade:'#26232a',
  wood:'#9a6a3e', woodShade:'#6e4a2c', gold:'#f9c776', goldShade:'#c99a3a', string:'#e9e6e0', lens:'#2a2f3a'
};

const SKINS = [
  {id:'porcelain', name:'Porcelain', n:'#fde3c8', S:'#f2c4a6', N:'#f5a283'},
  {id:'peach',     name:'Peach',     n:PAL.skin,  S:PAL.skinShade, N:PAL.nose},
  {id:'tan',       name:'Tan',       n:'#e8b07c', S:'#cf905e', N:'#d0794c'},
  {id:'olive',     name:'Olive',     n:'#cf9a6a', S:'#b07c4f', N:'#a8653d'},
  {id:'brown',     name:'Brown',     n:'#9c6644', S:'#7d4e33', N:'#6a3d26'},
  {id:'deep',      name:'Deep',      n:'#6e4530', S:'#55331f', N:'#43261a'}
];

const HAIR_COLORS = [
  {id:'chestnut', name:'Chestnut', h:'#c78659', H:'#b97355', M:'#ad6a4e', D:'#935746'},
  {id:'ink',      name:'Ink',      h:'#4a454b', H:'#3a3436', M:'#302b2e', D:'#26232a'},
  {id:'cocoa',    name:'Cocoa',    h:'#8a5a46', H:'#7a473f', M:'#6a3e37', D:'#583937'},
  {id:'honey',    name:'Honey',    h:'#fbe08a', H:'#f2c35c', M:'#e3ae4c', D:'#d29a3c'},
  {id:'ginger',   name:'Ginger',   h:'#f0905a', H:'#d9693a', M:'#c95b30', D:'#b04e27'},
  {id:'silver',   name:'Silver',   h:'#f4f2ee', H:'#e2ded7', M:'#cfcac2', D:'#a8a199'},
  {id:'rose',     name:'Rose',     h:'#fdc9ca', H:'#f29bb8', M:'#e488a9', D:'#d67599'},
  {id:'sky',      name:'Sky',      h:'#bfe7f8', H:'#8fc7ec', M:'#7ab2dc', D:'#5b8fc4'},
  {id:'moss',     name:'Moss',     h:'#b6de7c', H:'#8fbf5a', M:'#7dac4c', D:'#6a9a3f'},
  {id:'lilac',    name:'Lilac',    h:'#cdb0de', H:'#a77daa', M:'#966f99', D:'#82658a'}
];

// Bald head and body. n skin, S skin shade, A/a top, L/M legs (skin by default).
const BASE = [
"..................",
"..................",
"....2222222222....",
"...2nnnnnnnnnn2...",
"..2nnnnnnnnnnnn2..",
"..2nnnnnnnnnnnn2..",
".2nnnnnnnnnnnnnn2.",
".2nnnnnnnnnnnnnn2.",
".2nnnnnnnnnnnnnn2.",
".2nnnnnnnnnnnnnn2.",
".2nnnnnnnnnnnnnn2.",
".2nnnnnnnnnnnnnn2.",
"2nSnnnnnnnnnnnnSn2",
"2SSnnnnnnnnnnnnSS2",
".2nnnnnnnnnnnnnn2.",
".2SnnnnnnnnnnnnS2.",
"..222SnnnnnnS222..",
"....2A222222A2....",
"...2AAAAAAAAAa2...",
"..2n2AAAAAAAa2n2..",
"..222AAAAAAAa222..",
"....2aaaaaaaa2....",
"....22LM22LM22....",
".....222..222....."];
const HAND_R = [14, 19], HAND_L = [3, 19];   // body grid

// Hair: front (drawn over the face) and optional back (behind the body). h light, H base, M mid, D dark, S skin shadow, C tie.
const HAIRS = [
  {id:'bob', name:'Bob', front:{y:0, rows:[
    ".......2222..2....",
    ".....222hh2222....",
    "....2hhHHHHhh2....",
    "...2hHHHHHHHHh2...",
    "..2hHHHHHHHHHHh2..",
    "..2HHHHHHHHHHHH2..",
    ".2HHHHHHHHHHHHHH2.",
    ".2MHHHHHHHHHHHHM2.",
    ".2DHHHMHHHHHMHMD2.",
    ".2DHHMHD..DHMHHD2.",
    ".2DHDS......SDHD2.",
    ".2DS..........SD2.",
    "..................",
    "..................",
    ".2D............D2.",
    ".2DS..........SD2."]},
   back:{y:16, rows:[
    "2DD2..........2DD2",
    "2DD2..........2DD2",
    ".22............22."]}},
  {id:'spiky', name:'Spiky', front:{y:0, rows:[
    "......222.22..2...",
    "....22hhH2hh222...",
    "...2hhhhhHhhhhh2..",
    "..2hHHHHHHHHHHh2..",
    "..2HHHHHHHHHHHH2..",
    ".2HHHHHHHHHHHHHH2.",
    ".2HhHHHHHHHHHHHH2.",
    ".2HHHHHHHHHHHHHH2.",
    ".2DHHHHHHHHHHHHD2.",
    ".2DHHH2HHHH2HHHD2.",
    ".2DHHS..H...SHHD2.",
    ".2DS..........SD2.",
    "..................",
    "..................",
    ".2D............D2.",
    ".22S..........S22."]}},
  {id:'topbun', name:'Top bun', front:{y:0, rows:[
    ".......2222.......",
    "......2hHHD2......",
    ".....22DDDD22.....",
    "...22hhHHHHhh22...",
    "..2hhHHHHHHHHhh2..",
    "..2hHHHHHHHHHHH2..",
    ".2HHHHHHHHHHHHHH2.",
    ".2MHHHHHHHHHHHHM2.",
    ".2DHHHHHHHHMMMMD2.",
    ".2DHHHHHMMDD..SD2.",
    ".2DHHMDS......SD2.",
    ".2DS..........SD2."]}},
  {id:'short', name:'Short spikes', front:{y:0, rows:[
    ".....2.22.2.2.....",
    "....2h2hh2h2h2....",
    "...2hHhHHhHhHh2...",
    "..2hHHHHHHHHHHh2..",
    "..2HHHHHHHHHHHH2..",
    ".2HHHHHHHHHHHHHH2.",
    ".2MHHHHHHHHHHHHM2.",
    ".2DHHHHHHHHHHHHD2.",
    ".2DHMDSSSSSSDMHD2.",
    ".2DD..........DD2.",
    ".2D............D2.",
    ".2D............D2."]}},
  {id:'granbun', name:'Granny bun', front:{y:0, rows:[
    "......222222......",
    ".....2hhHHHD2.....",
    "....22DDDDDD22....",
    "...2hhhHHHHhhh2...",
    "..2hHHHHHHHHHHh2..",
    "..2HHHHHHHHHHHH2..",
    ".2HHHHHHHHHHHHHH2.",
    ".2HhHHhHHHhHHhHH2.",
    ".2DHHMHHHHHHMHHD2.",
    ".2DHMSSSSSSSSMHD2.",
    ".2DMS........SMD2.",
    ".2DD..........DD2.",
    "..................",
    "..................",
    ".2D............D2."]}},
  {id:'tufts', name:'Side tufts', front:{y:7, rows:[
    "2hH2..........2Hh2",
    "2HHD2........2DHH2",
    "2HDD2........2DDH2",
    ".2D2..........2D2.",
    ".22............22."]}},
  {id:'long', name:'Long', front:{y:1, rows:[
    ".....22222222.....",
    "....2hhhHHhhh2....",
    "...2hHHHHHHHHh2...",
    "..2hHHHHHHHHHHh2..",
    "..2HHHHHHHHHHHH2..",
    ".2HHHHHHMMHHHHHH2.",
    ".2HHHHHMDDMHHHHH2.",
    ".2MHHHMDSSDMHHHM2.",
    ".2DHHMDS..SDMHHD2.",
    ".2DHDS......SDHD2.",
    ".2DDS........SDD2.",
    "2DD............DD2",
    "2DD............DD2",
    ".2D............D2.",
    ".2DS..........SD2."]},
   back:{y:16, rows:[
    "2DDD2........2DDD2",
    "2DDDD2......2DDDD2",
    "2DDD2........2DDD2",
    ".2D2..........2D2."]}},
  {id:'twintails', name:'Twin tails', front:{y:1, rows:[
    ".....22222222.....",
    "....2hhhhhhhh2....",
    "...2hHHHHHHHHh2...",
    "..2hHHHHHHHHHHh2..",
    "..2HHHHHHHHHHHH2..",
    ".2HHHHHHHHHHHHHH2.",
    ".2HHHHHHHHHHHHHH2.",
    ".2MHHHHHHHHHHHHM2.",
    ".2DMMMMMMMMMMMMD2.",
    ".2DS..........SD2.",
    ".2D............D2."]},
   back:{y:5, x:-3, rows:[
    ".22..................22.",
    "2hH2................2Hh2",
    "2HHD2..............2DHH2",
    "2HHD2..............2DHH2",
    "2HDD2..............2DDH2",
    ".2D2................2D2.",
    "..2..................2.."]}},
  {id:'fluffy', name:'Fluffy', front:{y:0, rows:[
    ".....22.22.22.....",
    "...22hh2hh2hh22...",
    "..2hhHHhHHhHHhh2..",
    ".2hHHHHHHHHHHHHh2.",
    "2hHHhHHHHHHHHhHHh2",
    "2HHHHHHHHHHHHHHHH2",
    "2HHMHHHHHHHHHHMHH2",
    "2HHHHHHHHHHHHHHHH2",
    "2DHHMHHMHHMHHMHHD2",
    "2DHHMD......DMHHD2",
    "2DDMS........SMDD2",
    ".2DDS........SDD2.",
    "2DD............DD2",
    ".2D............D2.",
    ".22............22."]}},
  {id:'crop', name:'Crop', front:{y:2, rows:[
    "....2222222222....",
    "...2hhhhhhhhhh2...",
    "..2hHHHHHHHHHHh2..",
    "..2HHHHHHHHHHHH2..",
    ".2HHHHHHHHHHHHHH2.",
    ".2DHHHHHHHHHHHHD2.",
    ".2DDMSSSSSSSSMDD2.",
    ".2D............D2.",
    ".2D............D2."]}},
  {id:'swept', name:'Side swept', front:{y:1, rows:[
    ".....22222222.....",
    "....2hhhhhHHH2....",
    "...2hhHHHHHHHH2...",
    "..2hHHHHHHHHHHH2..",
    "..2HHHHHHHHHHHH2..",
    ".2HHHHHHHHHHHHHH2.",
    ".2HHHHHHHHHHHHMD2.",
    ".2HHHHHHHHHMDSSD2.",
    ".2HHHHHHMDS....D2.",
    ".2DHHMDS.......D2.",
    ".2DMS..........D2.",
    "..................",
    "..................",
    ".2D............D2."]}},
  {id:'braid', name:'Side braid', front:{y:1, rows:[
    ".....22222222.....",
    "....2hhhHHhhh2....",
    "...2hHHHHHHHHh2...",
    "..2hHHHHHHHHHHh2..",
    "..2HHHHHHHHHHHH2..",
    ".2HHHHHHMMHHHHHH2.",
    ".2HHHHHMDDMHHHHH2.",
    ".2MHHHMDSSDMHHHM2.",
    ".2DHHMDS..SDMHHD2.",
    ".2DHDS......SDHD2.",
    ".2DS..........SD2.",
    "..............2HD2",
    "..............2DH2",
    ".2D...........2HD2",
    ".2DS..........2DH2",
    "..............2HD2",
    ".............2CC2.",
    ".............2HD2.",
    ".............2D2..",
    "..............2..."]}},
  {id:'bald', name:'Bald', front:null}
];

// Expressions from the style guide. [x, y, key] in body grid. E eye, W shine, N nose, R mouth, T tongue, P blush, V sweat.
const EYES = [[5,12,'E'],[5,13,'E'],[12,12,'E'],[12,13,'E']];
const HAPPY_EYES = [[4,13,'E'],[5,12,'E'],[6,13,'E'],[11,13,'E'],[12,12,'E'],[13,13,'E']];
// Mouth: by design, the small pixel pair under the eyes is the mouth.
const MOUTH = [[8,14,'N'],[9,14,'N']];
const MOUTH_SMILE = [[7,14,'N'],[8,15,'N'],[9,15,'N'],[10,14,'N']];
const MOUTH_OPEN = [[8,14,'R'],[9,14,'R'],[8,15,'T'],[9,15,'T']];
const MOUTH_O = [[8,14,'R'],[9,14,'R'],[8,15,'R'],[9,15,'R']];
const MOUTH_FROWN = [[8,14,'N'],[9,14,'N'],[7,15,'N'],[10,15,'N']];
const BLUSH = [[3,14,'P'],[4,14,'P'],[13,14,'P'],[14,14,'P']];
const FACES = [
  {id:'neutral',   name:'Neutral',   px:[...EYES, ...MOUTH]},
  {id:'smile',     name:'Smile',     px:[...EYES, ...MOUTH_SMILE]},
  {id:'happy',     name:'Happy',     px:[...HAPPY_EYES, ...MOUTH_SMILE, ...BLUSH]},
  {id:'laugh',     name:'Laugh',     px:[...HAPPY_EYES, ...MOUTH_OPEN, ...BLUSH]},
  {id:'surprised', name:'Surprised', px:[[5,11,'E'],...EYES,[12,11,'E'], ...MOUTH_O]},
  {id:'sleepy',    name:'Sleepy',    px:[[4,13,'E'],[5,13,'E'],[12,13,'E'],[13,13,'E'], ...MOUTH]},
  {id:'concerned', name:'Concerned', px:[...EYES, [4,11,'E'],[5,11,'E'],[12,11,'E'],[13,11,'E'], ...MOUTH_FROWN, [15,10,'V'],[15,11,'V']]},
  {id:'excited',   name:'Excited',   px:[[5,12,'W'],[6,12,'E'],[5,13,'E'],[6,13,'E'],[11,12,'W'],[12,12,'E'],[11,13,'E'],[12,13,'E'], ...MOUTH_OPEN, ...BLUSH]},
  {id:'angry',     name:'Angry',     px:[...EYES, [5,11,'E'],[6,11,'E'],[11,11,'E'],[12,11,'E'], ...MOUTH_FROWN]},
  {id:'sad',       name:'Sad',       px:[...EYES, [4,11,'E'],[13,11,'E'], [5,14,'V'],[12,14,'V'], ...MOUTH_FROWN]},
  {id:'love',      name:'Love',      px:[[4,11,'H'],[6,11,'H'],[4,12,'H'],[5,12,'H'],[6,12,'H'],[5,13,'H'],[11,11,'H'],[13,11,'H'],[11,12,'H'],[12,12,'H'],[13,12,'H'],[12,13,'H'], ...MOUTH_SMILE, ...BLUSH]},
  {id:'wink',      name:'Wink',      px:[[5,12,'E'],[5,13,'E'],[11,13,'E'],[12,12,'E'],[13,13,'E'], ...MOUTH_SMILE]}
];
const BLINK = [[4,13,'E'],[5,13,'E'],[12,13,'E'],[13,13,'E']];

// Facial hair uses the hair color. H base, D dark.
const FACIAL_HAIR = [
  {id:'none', name:'None', rows:null},
  {id:'mustache', name:'Mustache', side:{y:15, rows:["............DHHH.."]}, y:15, rows:[".....DHHHHHHD....."]},
  {id:'handlebar', name:'Handlebar', side:{y:14, rows:["................D.", "............DHHHD."]}, y:14, rows:["....D........D....", "....DHHHHHHHHD...."]},
  {id:'goatee', name:'Goatee', side:{y:16, rows:["............HH....", "...........2DD2..."]}, y:16, rows:[".......HHHH.......", ".......2DD2......."]},
  {id:'stubble', name:'Stubble', side:{y:15, rows:[".........D.D.D....", "..........D.D.D..."]}, y:15, rows:["...D.D......D.D...", ".....D.D..D.D....."]},
  {id:'beard', name:'Full beard', side:{y:14, rows:[
    ".......2D.........",
    ".......2DHHHHHHHD2",
    "......2DHHHHHHHD2.",
    ".......2DHHHHHD2..",
    ".........2DDDD2..."]}, y:14, rows:[
    ".2D............D2.",
    ".2DHHHHHHHHHHHHD2.",
    "..2DHHHHHHHHHHD2..",
    "...2DHHHHHHHHD2...",
    ".....2DDDDDD2....."]},
  {id:'longbeard', name:'Long beard', side:{y:14, rows:[
    ".......2D.........",
    ".......2DHHHHHHHD2",
    "......2DHHHHHHHD2.",
    ".......2DHHHHHD2..",
    "........2DHHHHD2..",
    ".........2DHHD2...",
    "..........2DD2....",
    "...........22....."]}, y:14, rows:[
    ".2D............D2.",
    ".2DHHHHHHHHHHHHD2.",
    "..2DHHHHHHHHHHD2..",
    "...2DHHHHHHHHD2...",
    "....2DHHHHHHD2....",
    ".....2DHHHHD2.....",
    "......2DHHD2......",
    ".......2DD2.......",
    "........22........"]}
];

// Facial wear. F frame, D dark lens, A/a cloth, W/w white, G gold, K freckle.
const FACIAL_WEAR = [
  {id:'none', name:'None', rows:null},
  {id:'round', name:'Round glasses', y:11, colors:{F:PAL.red}, side:{y:11, rows:[
    "..............F...",
    "........FFFFFF.F..",
    ".............F.F..",
    "..............F..."]}, rows:[
    ".....F......F.....",
    "....F.FFFFFF.F....",
    "....F.F....F.F....",
    ".....F......F....."]},
  {id:'square', name:'Square glasses', y:11, colors:{F:PAL.outline}, side:{y:11, rows:[
    ".............FFF..",
    "........FFFFFF.F..",
    ".............F.F..",
    ".............FFF.."]}, rows:[
    "....FFF....FFF....",
    "....F.FFFFFF.F....",
    "....F.F....F.F....",
    "....FFF....FFF...."]},
  {id:'shades', name:'Sunglasses', y:11, colors:{F:PAL.outline, D:PAL.lens}, side:{y:11, rows:[
    ".............FFF..",
    "........FFFFFDDD..",
    ".............DDD.."]}, rows:[
    "....FFF....FFF....",
    "....DDDFFFFDDD....",
    "....DDD....DDD...."]},
  {id:'eyepatch', name:'Eye patch', y:11, colors:{F:PAL.outline, D:PAL.charcoal}, side:{y:11, rows:[
    "....FFFFFFFFFFFF..",
    ".............DDD..",
    ".............DDD.."]}, rows:[
    ".FFFFFFFFFFFFFF...",
    "...........DDD....",
    "...........DDD...."]},
  {id:'monocle', name:'Monocle', y:11, colors:{G:PAL.gold}, side:{y:11, rows:[
    ".............GGG..",
    ".............G.G..",
    ".............G.G..",
    ".............GGG..",
    "..............G..."]}, rows:[
    "...........GGG....",
    "...........G.G....",
    "...........G.G....",
    "...........GGG....",
    "............G....."]},
  {id:'mask', name:'Bandit mask', y:14, colors:{A:PAL.charcoal, a:PAL.charcoalShade}, side:{y:14, rows:[
    "......2AAAAAAAAA2.",
    "......2aAAAAAAAa2.",
    "......2aaaaaaa2..."]}, rows:[
    ".2AAAAAAAAAAAAAA2.",
    ".2aAAAAAAAAAAAAa2.",
    "...2aaaaaaaaaa2..."]},
  {id:'bandage', name:'Bandage', y:14, colors:{W:PAL.white, w:PAL.whiteShade}, side:{y:14, rows:[
    "............WWW...",
    "............wWw..."]}, rows:[
    "............WWW...",
    "............wWw..."]},
  {id:'freckles', name:'Freckles', y:14, colors:{K:PAL.tan}, side:{y:14, rows:[
    "............K.K..."]}, rows:[
    "...K.K......K.K..."]}
];

// Headwear. clip hides hair rows above it; hideHair hides all hair; hideBack hides back hair.
const HATS = [
  {id:'none', name:'None', rows:null},
  {id:'chef', name:'Chef hat', y:-4, clip:6, fill:'W', colors:{W:PAL.white, w:PAL.whiteShade}, rows:[
    "....222.22.222....",
    "...2WWW2WW2WWW2...",
    "..2WWWWWWWWWWWW2..",
    "..2WWwWWWWWWwWW2..",
    "..2wWWWWWWWWWWw2..",
    "...2wwwwwwwwww2...",
    "..2WWWWWWWWWWWW2..",
    "..2WWWWWWWWWWWW2..",
    "..2wwwwwwwwwwww2..",
    "..22222222222222.."]},
  {id:'baker', name:'Baker cap', y:-1, clip:7, fill:'W', colors:{W:PAL.white, w:PAL.whiteShade, C:PAL.coral}, rows:[
    ".....22222222.....",
    "...22WWWWWWWW22...",
    "..2WWWWWWWWWWWW2..",
    ".2WWWWwWWWWWwWWW2.",
    ".2wWWWWWWWWWWWWw2.",
    ".22wwwwwwwwwwww22.",
    "..2CCCCCCCCCCCC2..",
    "..22222222222222.."]},
  {id:'straw', name:'Straw hat', y:0, clip:7, fill:'A', colors:{A:PAL.straw, a:PAL.strawShade, C:PAL.red}, rows:[
    "......222222......",
    ".....2AAAAAA2.....",
    "....2AAAAAAAA2....",
    "....2CCCCCCCC2....",
    "2AAAAAAAAAAAAAAAA2",
    ".2aaaaaaaaaaaaaa2.",
    "..22222222222222.."]},
  {id:'bucketflower', name:'Garden hat', y:0, clip:8, fill:'A', colors:{A:PAL.green, a:PAL.greenShade, W:PAL.white, G:PAL.yellow}, rows:[
    ".....22222222.....",
    "....2AAAAAAAA2....",
    "...2AAAAAAAAWW2...",
    "...2AAAAAAAWGW2...",
    "..2aaaaaaaaaWWa2..",
    ".2AAAAAAAAAAAAAA2.",
    ".2aaaaaaaaaaaaaa2.",
    "..22222222222222.."]},
  {id:'bucket', name:'Bucket hat', y:0, clip:8, fill:'A', colors:{A:PAL.khaki, a:PAL.khakiShade}, rows:[
    ".....22222222.....",
    "....2AAAAAAAA2....",
    "...2AAAAAAAAAA2...",
    "...2AAAAAAAAAA2...",
    "..2aaaaaaaaaaaa2..",
    ".2AAAAAAAAAAAAAA2.",
    ".2aaaaaaaaaaaaaa2.",
    "..22222222222222.."]},
  {id:'sailor', name:'Sailor cap', y:1, clip:7, fill:'W', colors:{W:PAL.white, w:PAL.whiteShade, B:PAL.denim}, rows:[
    ".....22222222.....",
    "....2WWWWWWWW2....",
    "...2WWWWWWWWWW2...",
    "..2wWWWWWWWWWWw2..",
    "..2BBBBBBBBBBBB2..",
    "..22222222222222.."]},
  {id:'bandana', name:'Bandana', y:1, clip:8, fill:'A', colors:{A:PAL.red, a:PAL.redDeep, W:PAL.white}, rows:[
    ".....22222222.....",
    "....2AAAAAAAA2....",
    "...2AAAWAAAAAA2...",
    "..2AAAAAAAAWAAA2..",
    "..2AWAAAAAAAAAA2A2",
    "..2aaaaaaaaaaaa2A2",
    "..22222222222222a2",
    "................2."]},
  {id:'fedora', name:'Fedora', y:-1, clip:6, fill:'A', colors:{A:PAL.brown, a:PAL.brownDark, C:PAL.cream}, rows:[
    "......222222......",
    ".....2AAAAAA2.....",
    ".....2AAAAAA2.....",
    "....2AAAAAAAA2....",
    "....2CCCCCCCC2....",
    ".2AAAAAAAAAAAAAA2.",
    "..22222222222222.."]},
  {id:'beanie', name:'Beanie', y:-1, clip:8, fill:'A', colors:{A:PAL.coral, a:PAL.red, B:PAL.cream, b:PAL.tan, W:PAL.white}, rows:[
    "........22........",
    ".......2WW2.......",
    ".....22222222.....",
    "....2AAAAAAAA2....",
    "...2AaAaAaAaAa2...",
    "..2AaAaAaAaAaAa2..",
    "..2BBBBBBBBBBBB2..",
    "..2bbbbbbbbbbbb2..",
    "..22222222222222.."]},
  {id:'flower', name:'Flower clip', y:5, clip:0, colors:{C:PAL.coral, G:PAL.yellow}, rows:[
    ".............2C2..",
    "............2CGC2.",
    ".............2C2.."]},
  {id:'knight', name:'Knight helm', y:0, hideHair:true, hideBack:true, fill:'M', colors:{M:PAL.silver, m:PAL.silverShade}, rows:[
    "......222222......",
    "....22MMMMMM22....",
    "...2MMMMMMMMMM2...",
    "..2MmMMMMMMMMMM2..",
    "..2MMMMMMMMMMMm2..",
    ".2MM2M2M2M2M2MMm2.",
    ".2MM2M2M2M2M2MMm2.",
    ".2mmmmmmmmmmmmmm2.",
    ".2M2..........2M2.",
    ".2M2..........2M2.",
    ".2M2..........2M2.",
    ".2M2..........2M2.",
    "2Mm2..........2mM2",
    "2mm2..........2mm2",
    ".22............22."]},
  {id:'wizard', name:'Wizard hat', job:true, y:-5, clip:7, fill:'A', colors:{A:PAL.navy, a:PAL.navyShade, G:PAL.gold}, rows:[
    "...........22.....",
    "..........2A2.....",
    ".........2AA2.....",
    "........2AAA2.....",
    ".......2AAAA2.....",
    "......2AAAAAa2....",
    ".....2AAAAAAAa2...",
    "....2AAAAAAAAAa2..",
    "....2GGGGGGGGGG2..",
    "2AAAAAAAAAAAAAAAA2",
    ".2aaaaaaaaaaaaaa2.",
    "..22222222222222.."]},
  {id:'hood', name:'Hood', job:true, y:1, hideHair:true, hideBack:true, fill:'W', colors:{W:PAL.white, w:PAL.whiteShade, C:PAL.red},
   sideRows:[".....22222222.....", "....2WWWWWWWW2....", "...2WWWWWWWWWW2...", "..2WWWWWWWWWWWW2..", ".2WWWWWWWWWWWWWW2.", ".2WWWWWWWWWWWWWWW2",
     "2WWWWWWWWCCCCCCCC2", "2WWWWWWWWC........", "2WWWWWWWWC........", "2WWWWWWWWC........", "2WWWWWWWWC........", "2WWWWWWWWC........", "2wWWWWWWWC........",
     "2wWWWWWWWC........", "2wWWWWWWWC........", "2wwWWWWWWC........", ".2wwWWWWWC2.......", ".2wwwwwwC2........", "..2wwwwwC2........", "...2wwwC2.........", "....22222........."],
   rows:[
    ".....22222222.....",
    "....2WWWWWWWW2....",
    "...2WWWWWWWWWW2...",
    "..2WWWWWWWWWWWW2..",
    ".2WWWWWWWWWWWWWW2.",
    ".2WWCCCCCCCCCCWW2.",
    ".2WC..........CW2.",
    ".2WC..........CW2.",
    ".2WC..........CW2.",
    ".2WC..........CW2.",
    ".2WC..........CW2.",
    "2WWC..........CWW2",
    "2wWC..........CWw2",
    ".2wwC........Cww2.",
    ".2wwwC......Cwww2.",
    "..22wwC....Cww22.."]},
  {id:'feather', name:'Feather cap', job:true, y:-1, clip:7, fill:'A', colors:{A:PAL.green, a:PAL.greenShade, C:PAL.red}, rows:[
    "............2.....",
    "...........2C2....",
    ".....22222222C2...",
    "....2AAAAAAAAC2...",
    "...2AAAAAAAAAAA2..",
    "..2AAAAAAAAAAAAAA2",
    "..2aaaaaaaaaaaaa2.",
    "..22222222222222.."]},
  {id:'dragon', name:'Dragon helm', job:true, y:-2, hideHair:true, hideBack:true, fill:'A', colors:{A:PAL.denim, a:PAL.denimShade, G:PAL.gold}, rows:[
    "..2............2..",
    "..22..........22..",
    "..2A2.222222.2A2..",
    "...2A2AAAAAA2A2...",
    "...2AAAAAAAAAA2...",
    "..2AAAAAGGAAAAA2..",
    "..2AAAAAAAAAAAA2..",
    ".2AAAAAAAAAAAAAA2.",
    ".2AAAAAAAAAAAAAA2.",
    ".2aaaaaaaaaaaaaa2.",
    ".2A2..........2A2.",
    ".2A2..........2A2.",
    ".2A2..........2A2.",
    ".2A2..........2A2.",
    "2Aa2..........2aA2",
    "2aa2..........2aa2",
    ".22............22."]},
  {id:'headband', name:'Headband', job:true, y:8, clip:0, fill:'C', colors:{C:PAL.red}, rows:[
    ".2CCCCCCCCCCCCCC2C",
    "................2C"]}
];

// Outfits: rows 17-22 overlay the body ('.' keeps the base). Colors A/a main, B/b second, C accent, W/w white, G gold, L/M legs.
const OUTFITS = [
  {id:'tee', name:'T-shirt', colors:{A:PAL.sky, a:PAL.skyShade}, rows:[]},
  {id:'teepants', name:'Tee and pants', colors:{A:PAL.peri, a:PAL.periShade, L:PAL.denim, M:PAL.denimShade}, rows:[]},
  {id:'overalls', name:'Overalls', colors:{A:PAL.sky, a:PAL.skyShade, B:PAL.denim, b:PAL.denimShade, G:PAL.gold, L:PAL.denim, M:PAL.denimShade}, rows:[
    "..................",
    "......B....B......",
    "......BGBBGB......",
    "......BBBBBb......",
    "....2bbbbbbbb2...."]},
  {id:'chef', name:'Chef whites', colors:{A:PAL.white, a:PAL.whiteShade, C:PAL.red, L:PAL.charcoal, M:PAL.charcoalShade}, rows:[
    "..................",
    ".......CCCC.......",
    "........CC........",
    ".......2..2......."]},
  {id:'apron', name:'Apron', colors:{A:PAL.pinkPale, a:PAL.pink, W:PAL.white, w:PAL.whiteShade, L:PAL.brown, M:PAL.brownDark}, rows:[
    "..................",
    "..................",
    "......WWWWWW......",
    "......WWWWWw......",
    "....2awwwwwwa2...."]},
  {id:'dress', name:'Dress', colors:{A:PAL.lavender, a:PAL.lavenderShade, C:PAL.white}, rows:[
    "..................",
    ".......CCCC.......",
    "..................",
    "..................",
    "...2aaaaaaaaaa2..."]},
  {id:'cardigan', name:'Cardigan', colors:{A:PAL.coral, a:PAL.red, B:PAL.white, b:PAL.whiteShade, L:PAL.mauve, M:PAL.lavenderShade}, rows:[
    "..................",
    "........BB........",
    "........BB........",
    "........BB........",
    "....2aaabbaaa2...."]},
  {id:'stripes', name:'Striped shirt', colors:{A:PAL.white, a:PAL.whiteShade, B:PAL.red, b:PAL.redDeep, L:PAL.denim, M:PAL.denimShade}, rows:[
    "..................",
    "...2BBBBBBBBBb2...",
    "..................",
    ".....BBBBBBBb.....",
    "..................",]},
  {id:'vest', name:'Vest', colors:{A:PAL.white, a:PAL.whiteShade, B:PAL.brown, b:PAL.brownDark, L:PAL.charcoal, M:PAL.charcoalShade}, rows:[
    "..................",
    "...2BBBBAABBBb2...",
    ".....BBBAABBb.....",
    ".....BBBAABBb.....",
    "....2bbbbbbbb2...."]},
  {id:'sailor', name:'Sailor shirt', colors:{A:PAL.white, a:PAL.whiteShade, B:PAL.navy, b:PAL.navyShade, C:PAL.red, L:PAL.navy, M:PAL.navyShade}, rows:[
    "....2B222222B2....",
    "...2BBBAAAABBB2...",
    "........CC........"]},
  {id:'hoodie', name:'Hoodie', colors:{A:PAL.greenLight, a:PAL.teal, W:PAL.white, L:PAL.charcoal, M:PAL.charcoalShade}, rows:[
    "..................",
    ".......W..W.......",
    "..................",
    "......aaaaaa......"]},
  {id:'tunic', name:'Adventurer tunic', adventure:true, colors:{A:PAL.green, a:PAL.greenShade, C:PAL.brown, G:PAL.gold, L:PAL.brown, M:PAL.brownDark}, rows:[
    "..................",
    "..................",
    "..................",
    "..................",
    "....2CCCGCCCC2...."]},
  {id:'leather', name:'Leather armor', adventure:true, colors:{A:PAL.tan, a:PAL.brown, C:PAL.brownDark, G:PAL.gold, L:PAL.brownDark, M:PAL.charcoal}, rows:[
    "..................",
    "...2aAAAAAAAAa2...",
    ".....C............",
    "......C...........",
    "....2CCCGCCCC2...."]},
  {id:'plate', name:'Plate armor', adventure:true, colors:{A:PAL.silver, a:PAL.silverShade, W:PAL.shine, C:PAL.denim, L:PAL.silverShade, M:PAL.charcoal}, rows:[
    "..................",
    "...2aAAAAAAAAa2...",
    "......WWAAAAa.....",
    "......WAAAAaa.....",
    "....2CCCCCCCC2...."]},
  {id:'robe', name:'Robe', adventure:true, colors:{A:PAL.navy, a:PAL.navyShade, C:PAL.gold}, rows:[
    "..................",
    "........CC........",
    "........CC........",
    "........CC........",
    "....2CCCCCCCC2....",
    "....2aaaaaaaa2...."]},
  {id:'cloak', name:'Traveler cloak', adventure:true, colors:{A:PAL.tan, a:PAL.brown, B:PAL.greenShade, b:PAL.charcoal, C:PAL.brown, G:PAL.gold, L:PAL.brown, M:PAL.brownDark},
   back:[
    "..2BB........BB2..",
    ".2BBB........BBB2.",
    ".2BBB........BBB2.",
    ".2BBB........BBB2.",
    ".2bbb........bbb2.",
    ".22222......22222."],
   backView:[
    "....2BBBBBBBB2....",
    "...2BBBBBBBBBb2...",
    "..2n2BBBBBBBb2n2..",
    "..222BBBBBBBb222..",
    "....2bBBBBBBb2....",
    "....2bbbbbbbb2...."],
   sideBack:[
    "....2BB2..........",
    "...2BBB2..........",
    "...2BBB2..........",
    "..2BBBB2..........",
    "..2bbbb2..........",
    "..222222.........."],
   rows:[
    "....2G222222G2....",
    "..................",
    "..................",
    "..................",
    "....2CCCGCCCC2...."]}
];

const DYES = [
  {id:'default', name:'Default'},
  {id:'sky', name:'Sky', A:PAL.sky, a:PAL.skyShade},
  {id:'peri', name:'Periwinkle', A:PAL.peri, a:PAL.periShade},
  {id:'coral', name:'Coral', A:PAL.coral, a:PAL.red},
  {id:'butter', name:'Butter', A:PAL.yellow, a:PAL.yellowShade},
  {id:'mint', name:'Mint', A:PAL.greenLight, a:PAL.teal},
  {id:'lilac', name:'Lilac', A:PAL.lavender, a:PAL.lavenderShade},
  {id:'blush', name:'Blush', A:PAL.pinkPale, a:PAL.pink},
  {id:'forest', name:'Forest', A:PAL.green, a:PAL.greenShade},
  {id:'navy', name:'Navy', A:PAL.navy, a:PAL.navyShade},
  {id:'snow', name:'Snow', A:PAL.white, a:PAL.whiteShade},
  {id:'charcoal', name:'Charcoal', A:PAL.charcoal, a:PAL.charcoalShade}
];

// Weapons and tools: no outline in the art, it is added automatically. Anchor = grip pixel, placed just past the hand.
// M/m metal, W shine, w wood, G gold, C accent, R/r gem, L line, P pan.
const WEAPONS = [
  {id:'none', name:'None'},
  {id:'sword', name:'Sword', anchor:[0,7], rows:[
    ".......M",
    "......WM",
    ".....WM.",
    "....WM..",
    "..GWM...",
    "..GG....",
    ".w......",
    "w......."]},
  {id:'dagger', name:'Dagger', anchor:[0,4], rows:[
    "....M",
    "...WM",
    ".GW..",
    ".GG..",
    "w...."]},
  {id:'axe', name:'Axe', anchor:[0,6], rows:[
    "...MM..",
    "..MMMw.",
    "..MMw..",
    "...w...",
    "..w....",
    ".w.....",
    "w......"]},
  {id:'spear', name:'Spear', anchor:[0,9], rows:[
    ".........M",
    "........MM",
    ".......C..",
    "......w...",
    ".....w....",
    "....w.....",
    "...w......",
    "..w.......",
    ".w........",
    "w........."]},
  {id:'staff', name:'Staff', anchor:[0,6], rows:[
    ".....WR",
    ".....Rr",
    "....w..",
    "...w...",
    "..w....",
    ".w.....",
    "w......"]},
  {id:'wand', name:'Star wand', anchor:[0,3], rows:[
    "...G.",
    "..GGG",
    ".w.G.",
    "w...."]},
  {id:'bow', name:'Bow', anchor:[0,4], outline:false, rows:[
    "L22..",
    "L.w2.",
    "L..w2",
    "L..w2",
    "L..w2",
    "L..w2",
    "L..w2",
    "L.w2.",
    "L22.."]},
  {id:'hammer', name:'Hammer', anchor:[0,4], rows:[
    "..MMM",
    "..MMm",
    ".w...",
    "w....",
    "....."]},
  {id:'rod', name:'Fishing rod', anchor:[0,9], rows:[
    ".........w.",
    "........w.L",
    ".......w..L",
    "......w...L",
    ".....w....C",
    "....w......",
    "...w.......",
    "..w........",
    ".w.........",
    "w.........."]},
  {id:'pan', name:'Frying pan', anchor:[0,3], rows:[
    "..PPP",
    "..PPP",
    ".w...",
    "w...."]}
];
const OFFHANDS = [
  {id:'none', name:'None'},
  {id:'round', name:'Round shield', anchor:[2,2], rows:[
    ".MMM.",
    "MCCCM",
    "MCGCm",
    "MCCCm",
    ".Mmm."]},
  {id:'kite', name:'Kite shield', anchor:[2,2], rows:[
    "MMMMM",
    "MCWCM",
    "MWWWm",
    "MCWCm",
    ".mCm.",
    "..m.."]},
  {id:'book', name:'Spellbook', anchor:[1,1], rows:[
    "CCC",
    "CGC",
    "CCC",
    "WWW"]},
  {id:'lantern', name:'Lantern', anchor:[1,0], rows:[
    ".M.",
    "MGM",
    "MGM",
    ".M."]},
  {id:'bouquet', name:'Bouquet', anchor:[1,3], rows:[
    "C.C",
    "CGC",
    ".g.",
    ".g."]},
  {id:'lyre', name:'Lyre', anchor:[2,3], rows:[
    "G.L.G",
    "G.L.G",
    "GGGGG",
    ".GGG."]}
];
const GEAR_COLORS = {'2':PAL.outline, M:PAL.silver, m:PAL.silverShade, W:PAL.shine, w:PAL.wood, G:PAL.gold, C:PAL.red, R:PAL.red, r:PAL.redDeep, L:PAL.string, P:PAL.charcoal, g:PAL.green};

const byId = (list, id) => Math.max(0, list.findIndex(x => x.id === id));

function validateParts(){
  const bad = [];
  const chk = (rows, w, label) => (rows || []).forEach((r, i) => { if (r.length !== w) bad.push(label + ' row ' + i + ' is ' + r.length); });
  chk(BASE, 18, 'base');
  HAIRS.forEach(h => { if (h.front) chk(h.front.rows, 18, 'hair ' + h.id); if (h.back) chk(h.back.rows, h.back.x ? 24 : 18, 'hair back ' + h.id); });
  FACIAL_HAIR.forEach(f => chk(f.rows, 18, 'facial hair ' + f.id));
  FACIAL_WEAR.forEach(f => chk(f.rows, 18, 'facial wear ' + f.id));
  HATS.forEach(h => chk(h.rows, 18, 'hat ' + h.id));
  OUTFITS.forEach(o => { chk(o.rows, 18, 'outfit ' + o.id); chk(o.back, 18, 'outfit back ' + o.id); });
  [...WEAPONS, ...OFFHANDS].forEach(w => { if (w.rows) { const n = w.rows[0].length; chk(w.rows, n, 'gear ' + w.id); } });
  return bad;
}


// Additions: more headwear, neckwear, gear tiers and elite weapon shapes.
Object.assign(PAL, {
  steel:'#e7eef6', steelShade:'#8fa3bd', crystal:'#bfe7f8', crystalShade:'#7ab2dc', ice:'#a3def4',
  dust:'#efe6cf', dustShade:'#d9ccae', plum:'#5d3680', plumShade:'#47285f'
});

// Helmets now let the hair show through openings and below the guards.
HATS.forEach(h => { if (h.id === 'knight' || h.id === 'dragon') { h.hideHair = false; h.hideBack = false; h.fullHelm = true; h.clip = 5; } if (h.id === 'hood') h.fullHelm = true; });

HATS.splice(HATS.findIndex(h => h.id === 'knight') + 1, 0,
  {id:'visorhelm', name:'Visor helm', y:0, hideHair:true, fullHelm:true, fill:'M', colors:{M:PAL.silver, m:PAL.silverShade}, rows:[
    "......222222......",
    "....22MMMMMM22....",
    "...2MMMMMMMMMM2...",
    "..2MmMMMMMMMMMM2..",
    "..2MMMMMMMMMMMm2..",
    ".2MMMMMMMMMMMMMm2.",
    ".2MMMMMMMMMMMMMm2.",
    ".2mmmmmmmmmmmmmm2.",
    ".2MMMMMMMMMMMMMM2.",
    ".2MmMMMMMMMMMMmM2.",
    ".2MMMMMMMMMMMMMM2.",
    ".2mmmmmmmmmmmmmm2.",
    "2Mm222222222222mM2",
    "2mMMMMMMMMMMMMMMm2",
    ".2MMM2M2MM2M2MMM2.",
    ".2mMMMMMMMMMMMMm2.",
    "..22mmmmmmmmmm22.."]});
HATS.splice(HATS.findIndex(h => h.id === 'flower'), 0,
  {id:'sunvisor', name:'Sun visor', y:5, clip:0, fill:'C', colors:{C:PAL.coral, c:PAL.red}, rows:[
    "..2CCCCCCCCCCCC2..",
    ".2cCCCCCCCCCCCCc2.",
    ".22cccccccccccc22."]},
  {id:'goggles', name:'Goggles', y:5, clip:0, fill:'C', colors:{C:PAL.brown, L:PAL.ice, W:PAL.shine},
   backRows:["..................", "..2CCCCCCCCCCCC2..", "..2CCCCCCCCCCCC2.."],
   sideRows:["............222...", "..CCCCCCCCC2LW2...", "..CCCCCCCCC2LL2...", "............222..."], rows:[
    "....222....222....",
    "..C2LW2CCCC2LW2C..",
    "..C2LL2....2LL2C..",
    "....222....222...."]},
  {id:'circlet', name:'Circlet', y:7, clip:0, fill:'G', colors:{G:PAL.gold, R:PAL.red}, tierable:true, rows:[
    "..2GGGGGRRGGGGG2.."]},
  {id:'ribbon', name:'Ribbon', y:-1, clip:0, fill:'C', colors:{C:PAL.coral, c:PAL.red}, rows:[
    ".....22....22.....",
    "....2CC2..2CC2....",
    "....2CCc22cCC2....",
    ".....2Cc22cC2.....",
    "......22..22......"]}
);

// Neckwear: drawn over the outfit. Front, side (facing right) and back rows, all on the body grid.
const NECKWEAR = [
  {id:'none', name:'None'},
  {id:'scarf', name:'Red scarf', colors:{C:PAL.red, c:PAL.redDeep, W:PAL.white},
    front:{y:17, rows:["...2CCCCCCCCCC2...", "...2ccccCCCCcc2...", ".........2CC2.....", ".........2Cc2.....", ".........2WW2.....", "..........22......"]},
    side:{y:17, rows:["......2CCCCCCC2...", "......2ccccccc2...", "....2CC2..........", "....2Cc2..........", "....2WW2.........."]},
    back:{y:17, rows:["...2CCCCCCCCCC2...", "...2cccccccccc2..."]}},
  {id:'bluescarf', name:'Striped scarf', colors:{C:PAL.denim, c:PAL.denimShade, W:PAL.white},
    front:{y:17, rows:["...2CWCWCWCWCW2...", "...2cccccccccc2...", ".........2CW2.....", ".........2WC2.....", ".........2CW2.....", "..........22......"]},
    side:{y:17, rows:["......2CWCWCWC2...", "......2ccccccc2...", "....2CW2..........", "....2WC2..........", "....2CW2.........."]},
    back:{y:17, rows:["...2CWCWCWCWCW2...", "...2cccccccccc2..."]}},
  {id:'kerchief', name:'Neckerchief', colors:{C:PAL.yellow, c:PAL.yellowShade},
    front:{y:17, rows:["....2CCCCCCCC2....", ".....2CCCCCC2.....", "......2CcCC2......", ".......2cc2.......", "........22........"]},
    side:{y:17, rows:["......2CCCCCC2....", "..........2Cc2....", "...........22....."]},
    back:{y:17, rows:["....2CCCCCCCC2...."]}},
  {id:'bowtie', name:'Bow tie', colors:{C:PAL.red, c:PAL.redDeep},
    front:{y:17, rows:[".......CC22CC.....", ".......Cc..cC....."]},
    side:{y:17, rows:["............CC....", "............Cc...."]}},
  {id:'amulet', name:'Amulet', tierable:true, colors:{G:PAL.gold, R:PAL.red},
    front:{y:18, rows:[".......G....G.....", "........G..G......", ".........RR......."]},
    side:{y:18, rows:["...........G......", "............GR...."]}},
  {id:'mantle', name:'Mantle', colors:{C:PAL.navy, c:PAL.navyShade, G:PAL.gold},
    front:{y:17, rows:["..2CCC222222CCC2..", "..2cCCCCCCCCCCc2..", "...2GG......GG2..."]},
    side:{y:17, rows:["....2CCCCCCCCC2...", "....2ccccccccc2..."]},
    back:{y:17, rows:["..2CCCCCCCCCCCC2..", "..2cccccccccccc2..", "...2cccccccccc2..."]}}
];

// Gear tiers. Tier 1 is the original look.
const TIERS = [
  {id:1, name:'Novice', stars:'★'},
  {id:2, name:'Veteran', stars:'★★', gear:{M:PAL.steel, m:PAL.steelShade, w:PAL.brown, R:PAL.denim, r:PAL.denimShade, C:PAL.denim}, deco:'studs',
    metal:[PAL.steel, PAL.steelShade], accent:PAL.denim, gem:PAL.denim},
  {id:3, name:'Elite', stars:'★★★', gear:{M:PAL.gold, m:PAL.goldShade, W:PAL.paleYellow, w:PAL.brownDark, R:PAL.lavender, r:PAL.lavenderShade, G:PAL.white, C:PAL.lavender}, deco:'gold', elite:true,
    metal:[PAL.white, PAL.goldShade], accent:PAL.gold, gem:PAL.lavender},
  {id:4, name:'Legendary', stars:'★★★★', gear:{M:PAL.crystal, m:PAL.crystalShade, W:PAL.shine, w:PAL.paleYellow, R:PAL.pink, r:PAL.pinkShade, G:PAL.gold, C:PAL.pink}, deco:'legend', elite:true, halo:PAL.ice, aura:true,
    metal:[PAL.crystal, PAL.crystalShade], accent:PAL.ice, gem:PAL.pink}
];
const TIER_DECO = {
  studs:["..................", "....G........G....", "..................", "..................", "..................", ".................."],
  gold:["....2G222222G2....", "...2GG......GG2...", "..................", "..................", "....2GGGGGGGG2....", ".................."],
  legend:["....2G222222G2....", "...2GG......GG2...", "........RR........", "..................", "....2GGGGGGGG2....", ".................."]
};
const HELM_CREST = ["........22........", ".......2CC2......."];

// Elite shapes for higher tiers (Elite and Legendary).
const ELITE = {
  sword:{anchor:[0,8], rows:[
    "........W",
    ".......WM",
    "......WMm",
    ".....WMm.",
    "....WMm..",
    "..GWMm...",
    ".GRG.....",
    ".wG......",
    "w........"]},
  dagger:{anchor:[0,4], rows:[
    "....W",
    "...WM",
    "..WM.",
    "GRG..",
    "wG..."]},
  staff:{anchor:[0,7], rows:[
    "....G..G",
    "....GWRG",
    ".....RrG",
    "....GGG.",
    "...w....",
    "..w.....",
    ".w......",
    "w......."]},
  spear:{anchor:[0,9], rows:[
    ".........W",
    "........WM",
    "......GRG.",
    "......w...",
    ".....w....",
    "....w.....",
    "...w......",
    "..w.......",
    ".w........",
    "w........."]},
  axe:{anchor:[0,6], rows:[
    "..MMM.M",
    ".MMMMwM",
    ".MMMw..",
    "..Gw...",
    "..w....",
    ".w.....",
    "w......"]},
  bow:{anchor:[0,4], outline:false, rows:[
    "LG2..",
    "L.w2.",
    "L..w2",
    "L..w2",
    "L..G2",
    "L..w2",
    "L..w2",
    "L.w2.",
    "LG2.."]},
  round:{anchor:[2,2], rows:[
    ".GGGG.",
    "GCCCCG",
    "GCRRCG",
    "GCRRCG",
    "GCCCCG",
    ".GGGG."]},
  kite:{anchor:[2,2], rows:[
    "GGGGG",
    "GMWMG",
    "GWRWG",
    "GMWMG",
    ".GMG.",
    "..G.."]}
};

// Which effect each weapon makes when attacking.
const WEAPON_FX = {none:'impact', sword:'slash', dagger:'slash', axe:'slash', spear:'thrust', staff:'magic', wand:'magic', bow:'arrow', hammer:'impact', rod:'impact', pan:'impact'};

// Props for portraits and town jobs
WEAPONS.push(
  {id:'spoon', name:'Wooden spoon', anchor:[0,5], rows:[
    "....ww",
    "....ww",
    "...w..",
    "..w...",
    ".w....",
    "w....."]});
OFFHANDS.push(
  {id:'bread', name:'Bread', anchor:[1,2], rows:[
    "..BB",
    ".BbB",
    "BbB.",
    "BB.."]});
Object.assign(GEAR_COLORS, {B:'#e0a94e', b:'#fdecb9'});
WEAPON_FX.spoon = 'impact';

// Portrait backgrounds, flat pastels like the Tiny Town sheet
const PORTRAIT_BG = [
  {id:'auto', name:'Match outfit'},
  {id:'sky', name:'Sky', c:'#bfe0f0'}, {id:'peach', name:'Peach', c:'#f8d2b8'}, {id:'butter', name:'Butter', c:'#f7dc9a'},
  {id:'mint', name:'Mint', c:'#cfe6b4'}, {id:'lilac', name:'Lilac', c:'#d9c6e6'}, {id:'rose', name:'Rose', c:'#f6c6cc'}, {id:'slate', name:'Slate', c:'#c9d4de'}
];

// ---------- New jobs: Berserker, Samurai, Druid / Beastmaster ----------
Object.assign(PAL, {bone:'#f4ecd8', boneShade:'#d9ccae', fur:'#efe6cf', furShade:'#d9ccae', leaf:'#8fbf5a', leafDark:'#4e7d36', glow:'#b6de7c'});

HAIRS.splice(HAIRS.length - 1, 0,
  {id:'topknot', name:'Topknot', front:{y:0, rows:[
    "........22........",
    ".......2hD2.......",
    "....2222DD2222....",
    "...2hhhhhhhhhh2...",
    "..2hHHHHHHHHHHh2..",
    "..2HHHHHHHHHHHH2..",
    ".2HHHHHHHHHHHHHH2.",
    ".2DHHHHHHHHHHHHD2.",
    ".2DDMSSSSSSSSMDD2.",
    ".2D............D2.",
    ".2D............D2."]}});

HATS.push(
  {id:'horned', name:'Horned helm', job:true, y:-2, clip:7, fill:'M', colors:{M:PAL.silver, m:PAL.silverShade, W:PAL.bone, w:PAL.boneShade, G:PAL.gold}, rows:[
    ".2..............2.",
    "2W2............2W2",
    "2W2...222222...2W2",
    "2wW222MMMMMM222Ww2",
    ".2wW2MMMMMMMM2Ww2.",
    "..2MmMMMMMMMMMM2..",
    "..2MMMMMMMMMMMm2..",
    ".2MMMMMMMMMMMMMm2.",
    ".2GMGMGMGMGMGMGG2.",
    ".2222222MM2222222.",
    ".......2MM2.......",
    ".......2MM2.......",
    ".......2Mm2.......",
    "........22........"]},
  {id:'kabuto', name:'Kabuto', job:true, y:-3, clip:6, fill:'A', colors:{A:PAL.charcoal, a:PAL.charcoalShade, B:PAL.red, b:PAL.redDeep, G:PAL.gold}, rows:[
    "...G..........G...",
    "...GG........GG...",
    "....GG.2222.GG....",
    ".....GGAAAAGG.....",
    "....2AAGGGGAAA2...",
    "...2AAAAAAAAAA2...",
    "..2AaAAAAAAAAaA2..",
    "..2AAAAAAAAAAAA2..",
    ".2aaaaaaaaaaaaaa2.",
    "2BB2..........2BB2",
    "2bB2..........2Bb2",
    "2BB2..........2BB2",
    "2bB2..........2Bb2",
    ".22............22."]},
  {id:'antlers', name:'Antler crown', job:true, y:-5, clip:0, fill:'G', colors:{W:PAL.bone, w:PAL.boneShade, G:PAL.leaf, g:PAL.leafDark, F:PAL.coral}, rows:[
    "..2..2......2..2..",
    ".2W22W2....2W22W2.",
    ".2WW2W2....2W2WW2.",
    "..2WWW2....2WWW2..",
    "...2W2......2W2...",
    "...2w2......2w2...",
    "..................",
    "..................",
    "..................",
    "..................",
    "..2GgGFgGGgFGgG2.."]});

OUTFITS.push(
  {id:'furvest', name:'Fur vest', adventure:true, colors:{A:PAL.brown, a:PAL.brownDark, W:PAL.fur, w:PAL.furShade, C:PAL.brownDark, G:PAL.gold, L:PAL.brown, M:PAL.brownDark}, rows:[
    "...2WwWwWwWwWwW2..",
    "..2wWw.......wWw2.",
    ".....C............",
    "......C...........",
    "....2CCCGCCCC2...."]},
  {id:'hakama', name:'Kimono and hakama', adventure:true, colors:{A:PAL.white, a:PAL.whiteShade, C:PAL.charcoal, R:PAL.red, B:PAL.navy, b:PAL.navyShade}, rows:[
    "..................",
    "......C....C......",
    ".......C..C.......",
    ".....RRRRRRRR.....",
    "...2BBBBBBBBBB2...",
    "....2BbBBbBBb2...."]},
  {id:'leaftunic', name:'Leaf tunic', adventure:true, colors:{A:PAL.green, a:PAL.greenShade, G:PAL.leaf, g:PAL.leafDark, C:PAL.brown, F:PAL.coral, L:PAL.brown, M:PAL.brownDark}, rows:[
    "....2G222222G2....",
    "....g........g....",
    "........F.........",
    ".....CCCCCCCC.....",
    "....2gGgGgGgG2...."]});

WEAPONS.push(
  {id:'greataxe', name:'Great axe', anchor:[0,8], rows:[
    "...MMM...",
    "..MWMMMw.",
    "..MWMMw..",
    "...MMw...",
    "....w....",
    "...w.....",
    "..w......",
    ".w.......",
    "w........"]},
  {id:'katana', name:'Katana', anchor:[0,8], rows:[
    "........M",
    ".......M.",
    "......WM.",
    ".....WM..",
    "....WM...",
    "...WM....",
    "..GG.....",
    ".PG......",
    "P........"]},
  {id:'druidstaff', name:'Druid staff', anchor:[0,7], rows:[
    "...V..V.",
    "....EE..",
    "...VEvV.",
    "...ww...",
    "...w....",
    "..w.....",
    ".w......",
    "w......."]});
OFFHANDS.push(
  {id:'vikingshield', name:'Viking shield', anchor:[2,2], rows:[
    ".MMMM.",
    "MwwCwM",
    "MwGGwM",
    "MwGGwM",
    "MwwCwM",
    ".MMMM."]});
Object.assign(GEAR_COLORS, {V:PAL.leaf, v:PAL.leafDark, E:PAL.glow});
Object.assign(WEAPON_FX, {greataxe:'slash', katana:'slash', druidstaff:'leaves'});

// Companions: slimes from the Tiny Town creature sheet. Front, side (facing right) and back.
const PETS = [
  {id:'none', name:'None'},
  {id:'slime', name:'Green slime', colors:{G:'#9fd86b', g:'#6aa04a', h:'#d6f2a8', P:PAL.blush}},
  {id:'pinkslime', name:'Pink slime', colors:{G:'#f6a9c0', g:'#d67599', h:'#fde0e8', P:PAL.coral}},
  {id:'blueslime', name:'Blue slime', colors:{G:'#9fd2f0', g:'#5b8fc4', h:'#e1f3fc', P:PAL.blush}}
];
const PET_ART = {
  front:["...2222...", "..2hGGG2..", ".2hGGGGG2.", "2GGGGGGGG2", "2GG2GG2GG2", "2GPGGGGPG2", "2gGGGGGGg2", ".22222222."],
  side:["...2222...", "..2hGGG2..", ".2hGGGGG2.", "2GGGGGGGG2", "2GGGG2G2G2", "2GGGPGGGP2", "2gGGGGGGg2", ".22222222."],
  back:["...2222...", "..2hGGG2..", ".2hGGGGG2.", "2GGGGGGGG2", "2GGGGGGGG2", "2GGGGGGGG2", "2gGGGGGGg2", ".22222222."]
};

// Samurai menpo (face mask). Added to facial wear.
FACIAL_WEAR.push({id:'menpo', name:'Menpo mask', y:15, colors:{R:'#b4473b', r:'#8c3a30', W:PAL.white},   // starts below the eyes (row 13), so they stay visible
  side:{y:15, rows:[".......2RRWRRRRR2.", ".......2rRRRR22R2.", "........2rrRRRR2.."]},
  rows:[".2RRWRRRRRRRRRRR2.", ".2rRRRR2222RRRRr2.", "...2rrRRRRRRrr2..."]});
const PORTRAIT_TILT = [{id:'se', name:'Facing SE', turn:1}, {id:'front', name:'Facing S', turn:0}, {id:'sw', name:'Facing SW', turn:-1}];
// Locked choices. Flip a flag to bring a feature back:
//   portraitAngles: the SE/SW portrait poses (off = every portrait faces front)
//   spriteStyles:   the Chibi/Large portrait-engine sprite previews (off = Classic sprites only)
const FEATURES = {portraitAngles: false, spriteStyles: false};
const FRONT_TILT = 1;
const portraitPose = look => FEATURES.portraitAngles ? (PORTRAIT_TILT[look.portraitTilt == null ? FRONT_TILT : look.portraitTilt] || PORTRAIT_TILT[FRONT_TILT]) : PORTRAIT_TILT[FRONT_TILT];
// Body types and eye shapes: both change the walking sprite and the portrait.
const BODIES = [{id:'standard', name:'Standard'}, {id:'young', name:'Young'}, {id:'old', name:'Old'}, {id:'stout', name:'Stout'}, {id:'tall', name:'Tall'}];
const EYE_SHAPES = [{id:'auto', name:'Auto'}, {id:'round', name:'Round'}, {id:'big', name:'Big'}, {id:'narrow', name:'Narrow'}, {id:'lashes', name:'Lashes'}];
const SOFT_HAIR = ['long', 'bob', 'twintails', 'braid', 'topbun', 'granbun'];
const eyeShapeOf = look => { const s = (EYE_SHAPES[look.eyeShape || 0] || EYE_SHAPES[0]).id; return s !== 'auto' ? s : SOFT_HAIR.includes((HAIRS[look.hair] || HAIRS[0]).id) ? 'lashes' : 'round'; };

// ---------- Portrait headwear recipes ----------
// Each hat's portrait is data: a list of parts drawn in order by one engine (portrait_hf.js).
// A hat with no recipe here gets a portrait built automatically from its in-game sprite rows.
//
// keys:   which of the hat's own colour keys feed the portrait roles [main, shade, trim, accent]
// band:   where the hat sits: a fraction of head height (0.4) or {eyes:-4} (rows above the eyes)
// keepHair: true for pieces that sit on the hair (straps, clips) instead of covering it
//
// Coordinates. x: px from the head's centre, or 'L+3' / 'R-3' (head edges), 'F+2' (face centre),
//   'K-6' (the back edge of the head; + is outward). y: 'T-2' (top of skull), 'B+1' (hat band), 'E-4' (eyes).
//   A third number on a poly point is added in the back direction. turn: px to shift toward the facing.
//   Radii can be 'W+4' (head half-width + 4) or 'W*0.8'.
// Parts:
//   crown  {shapes, grow, flat, rows, pattern}  covers the head above the band (hair under it is flattened)
//   brim   {shapes, cut}                        drawn over the face edge, darker underneath
//   strap  [from, to]                            a band around the head
//   shape  {shapes, tone, mode}                  any extra piece
//   side   {pts:[[u,v,f]], y, x}                 a pair on the sides; follows the 3/4 headgear rule
//   back   {knot, tails, y}                      knot and tails at the back of the head
//   pair   {shapes}                              mirrored left/right copies (antlers)
//   flower {at:[x,y], r}                         petals in trim, centre in accent
//   helm   {band, cheeks, ridge, grille, faceplate, nasal, flaps, ribs}  the shared helmet build
//   detail 'hood' | 'leafRing' | 'star' | 'creases' | 'frontGlint'
// tone: 'hat' | 'trim' | 'acc' (three shades each). rows: [[from, to, role]] relative to the band.
const PORTRAIT_HATS = {
  chef: { keys: ['W', 'w'], band: 0.38, parts: [
    { crown: { grow: 0.8, shapes: [{ rect: ['L+3', 'B-6', 'R-3', 'B+0.5', 1] }, { ell: [-8, 'T-1', 7.5, 6], turn: 1.5 }, { ell: [8, 'T-1', 7.5, 6], turn: 1.5 }, { ell: [0, 'T-4', 9, 7], turn: 1.5 }] }, pattern: 'pleats' },
    { detail: 'creases' }] },
  baker: { keys: ['W', 'w', 'C'], band: 0.4, parts: [
    { crown: { grow: 1.4, shapes: [{ ell: [0, 'T+2', 'W+1', 6], back: 3 }] }, rows: [[-2, -1, 'trim'], [0, 0, 'trimDark']] }] },
  straw: { keys: ['A', 'a', 'C'], band: 0.36, parts: [
    { crown: { grow: 0.8, flat: 0.5 }, pattern: 'weave', rows: [[-4, -4, 'hatDark'], [-3, 0, 'trim']] },
    { brim: { shapes: [{ ell: [0, 'B+1', 'W+6', 2.8], turn: 1.5 }], cut: -0.5 }, pattern: 'weave' }] },
  bucket: { keys: ['A', 'a'], band: 0.4, parts: [
    { crown: { grow: 1.0, flat: -1 }, rows: [[-2, 0, 'hatDark']], flattenAt: 1 },
    { brim: { shapes: [{ poly: [['L-1', 'B-1'], ['R+1', 'B-1'], ['R+4', 'B+3'], ['L-4', 'B+3']], turn: 1.5 }] } }] },
  bucketflower: { keys: ['A', 'a', 'W', 'G'], band: 0.4, parts: [
    { crown: { grow: 1.0, flat: -1 }, rows: [[-2, 0, 'hatDark']], flattenAt: 1 },
    { brim: { shapes: [{ poly: [['L-1', 'B-1'], ['R+1', 'B-1'], ['R+4', 'B+3'], ['L-4', 'B+3']], turn: 1.5 }] } },
    { flower: { at: ['K-5', 'B-4'], r: 2.4 } }] },
  sailor: { keys: ['W', 'w', 'B'], band: 0.4, parts: [
    { crown: { grow: 0.9, flat: 0.5 }, rows: [[-5, -4, 'trim'], [-3, -3, 'trimDark']], flattenAt: 1 },
    { brim: { shapes: [{ rect: ['L-0.5', 'B-1.5', 'R+0.5', 'B+1.5', 1.5] }], roll: true } }] },
  bandana: { keys: ['A', 'a', 'W'], band: 0.44, parts: [
    { crown: { grow: 0.9 }, pattern: 'dots', rows: [[-1, 0, 'hatDark']] },
    { back: { y: 'B-2', tails: [{ poly: [[2, 0], [7, 4], [4, 6]] }, { poly: [[2, 1], [3, 8], [0.5, 7]] }], knot: [{ ell: [1.5, 0, 2.2, 1.8] }] } }] },
  fedora: { keys: ['A', 'a', 'C'], band: 0.38, parts: [
    { crown: { grow: 0.6, shapes: [{ rect: [-11, 'T-3', 11, 'B+0', 4] }], cut: [{ ell: [0, 'T-3.5', 4, 1.6], turn: 2 }] }, rows: [[-3, -2, 'trim'], [-1, -1, 'trimDark']], flattenAt: 1 },
    { brim: { shapes: [{ ell: [0, 'B+0.5', 'W+4', 2.3], turn: 1.5 }], cut: -1 } }] },
  beanie: { keys: ['A', 'a', 'W'], band: 0.42, parts: [
    { crown: { grow: 1.2 }, pattern: 'knit' },
    { shape: { shapes: [{ ell: [0, 'T-2.5', 2.6, 2.4], turn: 1 }] }, tone: 'trim' }] },
  sunvisor: { keys: ['C', 'c'], band: 0.42, keepHair: true, parts: [
    { strap: [-2, 0], rows: [[0, 0, 'hatDark']] },
    { brim: { shapes: [{ ell: [0, 'B+0', 'W*0.8', 4.2], turn: 4 }], cut: -0.5 } }] },
  goggles: { keys: ['C', null, 'L', 'W'], band: 0.36, keepHair: true, parts: [
    { strap: [-1.5, 0.8], rows: [[1, 1, 'hatDark']] },
    { shape: { shapes: [{ ell: ['F-6', 'B-1', 3.3, 3.1] }, { ell: ['F+6', 'B-1', 3.3, 3.1] }] }, tone: 'trim', pattern: 'lens' }] },
  circlet: { keys: ['G', null, null, 'R'], band: 0.42, keepHair: true, parts: [
    { strap: [-1.2, 0.2], grow: 0.9, rows: [[0, 0, 'hatDark']] },
    { shape: { shapes: [{ poly: [['F-2.5', 'B+0'], ['F+0', 'B-5'], ['F+2.5', 'B+0']] }] }, tone: 'hat' },
    { shape: { shapes: [{ ell: ['F+0', 'B-1', 1.6, 1.6] }] }, tone: 'acc', ring: false }] },
  ribbon: { keys: ['C', 'c'], band: 0.4, keepHair: true, parts: [
    { shape: { shapes: [{ poly: [['R-8.5', 'T-1'], ['R-4', 'T+2'], ['R-8.5', 'T+5']], turn: -2 }, { poly: [['R+0.5', 'T-1'], ['R-4', 'T+2'], ['R+0.5', 'T+5']], turn: -2 }, { ell: ['R-4', 'T+2', 1.4, 1.4], turn: -2 }] }, tone: 'hat' }] },
  flower: { keys: ['C', null, null, 'G'], band: 0.4, keepHair: true, parts: [
    { shape: { shapes: [{ ell: ['K-9', 'T+9', 2.6, 1.4] }] }, tone: 'leaf' },
    { flower: { at: ['K-6', 'T+6'], r: 2.8, petal: 2.1, tone: 'hat' } }] },
  knight: { keys: ['M', 'm', 'm', 'C'], band: { eyes: -4 }, parts: [
    { helm: { cheeks: true, ridge: true, grille: true } }] },
  visorhelm: { keys: ['M', 'm', 'm'], band: { eyes: -6 }, parts: [
    { helm: { cheeks: true, ridge: true, band: 6, faceplate: true } }] },
  wizard: { keys: ['A', 'a', 'G'], band: 0.4, parts: [
    { crown: { grow: 0.8, shapes: [{ poly: [[-11, 'B+0'], [-6, 'T-1'], [0, 'T-6', 1], [0, 'T-9', 8], [0, 'T-4', 5], [6, 'T-1'], [11, 'B+0']], turn: 1.5 }] }, rows: [[-3, -2, 'trim'], [-1, -1, 'trimDark']], flattenAt: 1 },
    { brim: { shapes: [{ ell: [0, 'B+0.5', 'W+5', 2.6], turn: 1.5 }], cut: -1 } },
    { detail: 'star', at: [0, 'T+2'], turn: 3.5 }] },
  hood: { keys: ['W', 'w', 'C'], band: 0.4, parts: [{ detail: 'hood' }] },
  feather: { keys: ['A', 'a', 'C'], band: 0.4, parts: [
    { crown: { grow: 1.0, shapes: [{ poly: [[0, 'T-0.5'], ['K+5', 'T+5'], ['K-3', 'B+0']] }] }, rows: [[-1, 0, 'hatDark']] },
    { shape: { shapes: [{ poly: [[0, 'B-3', 4], [0, 'T+1', 6], [0, 'T-6', 11], [0, 'T-9', 14], [0, 'T-3', 12], [0, 'B-4', 7]] }] }, tone: 'trim', pattern: 'vane' }] },
  dragon: { keys: ['A', 'a', 'G', 'a'], band: { eyes: -4 }, parts: [
    { helm: { cheeks: true } },
    { side: { pts: [[0, 1], [5, 8, -2], [3, 3, -1], [6, 4, -3], [0, -2]], y: 'E-6' }, tone: 'trim', pattern: 'fin' },
    { side: { pts: [[-2.6, 0], [2.6, 0, -0.5], [4.5, 7, -2], [5.5, 13, -4], [1.5, 7, -2]], y: 'T+6', x: 0.48 }, tone: 'acc', shade: 'spike', over: true },
    { shape: { shapes: [{ ell: ['F+0', 'E-6', 1.6, 1.4] }] }, tone: 'trim', pattern: 'gem' }] },
  headband: { keys: ['C'], band: 0.42, keepHair: true, parts: [
    { back: { y: 'B-1', tails: [{ line: [0, 0, 7, 7, 1.1] }, { line: [0, 0, 8, 2, 1.1] }] } },
    { strap: [-2, 0.5], rows: [[0, 0, 'hatDark'], [-2, -2, 'hatLight']] },
    { detail: 'frontGlint' }] },
  horned: { keys: ['M', 'm', 'G', 'W'], band: { eyes: -4 }, parts: [
    { helm: { nasal: true, goldRidge: true } },
    { side: { pts: [[-1, 1], [5, 3], [8, 7, 1], [9, 12, 2], [7.5, 17, 3], [6.5, 11, 2], [4.5, 8, 1], [-1, 7]], y: 'B-4' }, tone: 'acc', shade: 'horn' }] },
  kabuto: { keys: ['A', 'a', 'B', 'G'], band: { eyes: -4 }, parts: [
    { helm: { flaps: true, ribs: true } },
    { shape: { shapes: [{ line: ['F+0', 'B-3', 'F-6', 'B-6', 1.1] }, { line: ['F+0', 'B-3', 'F+6', 'B-6', 1.1] }, { line: ['F-6', 'B-6', 'F-10', 'B-12', 1.0] }, { line: ['F+6', 'B-6', 'F+10', 'B-12', 1.0] }] }, tone: 'acc' },
    { shape: { shapes: [{ ell: ['F+0', 'B-3', 2, 1.8] }] }, tone: 'acc', pattern: 'gem' }] },
  antlers: { keys: ['W', 'w', 'G', 'F'], band: 0.36, keepHair: true, parts: [
    { pair: { shapes: [{ line: [8, 'B-1', 12, 'T-2', 1.5] }, { line: [12, 'T-2', 18, 'T-7', 1.2] }, { line: [11.5, 'T-1', 10.5, 'T-8', 1.1] }, { line: [15, 'T-4.5', 15, 'T-10', 1.0] }], turn: 1 }, tone: 'hat', antler: true },
    { detail: 'leafRing' }] },
};
if (typeof HATS !== 'undefined') HATS.forEach(h => { if (PORTRAIT_HATS[h.id]) h.portrait = PORTRAIT_HATS[h.id]; });


// Tiny Town engine: 4 directions, handedness, gear tiers, actions, effects, emotes and portraits.
// Back and side views are derived from the front art by rule; the side body, ear and side accessories are hand-drawn.
const DIRS = ['down', 'left', 'right', 'up'];

const SIDE_BASE = BASE.slice(0, 12).concat([
".2nnnnnnnnnnnnnn2.",
".2nnnnnnnnnnnnnn2.",
".2nnnnnnnnnnnnnn2.",
".2SnnnnnnnnnnnnS2.",
"...222SnnnnnnS22..",
"......2AAAA222....",
".....2AAAAAAa2....",
".....2AAA2AAa2....",
".....2AA2n2Aa2....",
".....2aaa2aaa2....",
".......2LM2.......",
".......22222......"]);
const SIDE_HAND = [9, 20], FAR_HAND = [11, 19];
const SIDE_EAR = [[6,11,'2'],[7,11,'2'],[5,12,'2'],[6,12,'n'],[7,12,'S'],[8,12,'2'],[5,13,'2'],[6,13,'S'],[7,13,'n'],[8,13,'2'],[6,14,'2'],[7,14,'2']];

// Legs (body rows 22-23). Side view: both feet point forward; the far leg is the darker one.
const LEGS = {
  front:{
    stand:["....22LM22LM22....", ".....222..222....."],
    stepL:["....222222LM22....", "..........222....."],
    stepR:["....22LM222222....", ".....222.........."]},
  side:{
    stand:[".......2LM2.......", ".......22222......"],
    stepL:[".....2MM2.2LL2....", ".....2222.2222...."],
    stepR:[".....2LL2.2MM2....", ".....2222.2222...."]}
};

// Emotes: pixel icons in a speech bubble. Picking one also sets a matching face.
const EMOTES = [
  {id:'none', name:'None', emoji:'', icon:null},
  {id:'heart', name:'Love', emoji:'❤️', face:'love', icon:["RR.RR","RRRRR","RRRRR",".RRR.","..R.."]},
  {id:'music', name:'Humming', emoji:'🎵', face:'smile', icon:["..KK.","..K.K","..K..","KKK..","KKK.."]},
  {id:'sleep', name:'Sleepy', emoji:'💤', face:'sleepy', icon:["BBBB.","..B..",".B...","BBBB.","....."]},
  {id:'alert', name:'Alert', emoji:'❗', face:'surprised', icon:["..R..","..R..","..R..",".....","..R.."]},
  {id:'question', name:'Confused', emoji:'❓', face:'concerned', icon:[".KKK.","K...K","...K.",".....","..K.."]},
  {id:'anger', name:'Grumpy', emoji:'💢', face:'angry', icon:[".R.R.","RR.RR",".....","RR.RR",".R.R."]},
  {id:'sweat', name:'Nervous', emoji:'💦', face:'concerned', icon:["..B..",".BBB.","BBBBB","BBWBB",".BBB."]},
  {id:'sparkle', name:'Excited', emoji:'✨', face:'excited', icon:["..Y..",".YYY.","YYYYY",".YYY.","..Y.."]},
  {id:'idea', name:'Idea', emoji:'💡', face:'happy', icon:[".YYY.","YYWYY","YYYYY",".YYY.",".KKK."]},
  {id:'rain', name:'Gloomy', emoji:'🌧️', face:'sad', icon:[".GGG.","GGGGG",".....",".B.B.","B.B.."]},
  {id:'dots', name:'Speechless', emoji:'💬', face:'neutral', icon:[".....",".....","K.K.K",".....","....."]},
  {id:'star', name:'Proud', emoji:'⭐', face:'laugh', icon:["..Y..",".YYY.","YYYYY",".YYY.",".Y.Y."]}
];
const EMOTE_COLORS = {R:'#ec5448', K:'#2f2a26', B:'#4e83ad', Y:'#f9c776', W:'#ffffff', G:'#9aa3ad'};
const BUBBLE = [".2222222.", "2WWWWWWW2", "2WWWWWWW2", "2WWWWWWW2", "2WWWWWWW2", "2WWWWWWW2", ".2W22222.", ".2......."];

// Actions. fx names an effect; 'attack' picks the effect that matches the weapon.
const ACTIONS = [
  {id:'idle', name:'Idle', frames:[{dur:540}, {dur:540, squash:true}]},
  {id:'walk', name:'Walk', frames:[{dur:150, legs:'stepL', fx:'dust', fxf:0}, {dur:150, dy:-1, fx:'dust', fxf:1},
    {dur:150, legs:'stepR', fx:'dust', fxf:0, fxMirror:true}, {dur:150, dy:-1, fx:'dust', fxf:1, fxMirror:true}]},
  {id:'wave', name:'Wave', frames:[{dur:260, arms:'wave', armFrame:0, fx:'hearts', fxf:0}, {dur:260, arms:'wave', armFrame:1, fx:'hearts', fxf:1}]},
  {id:'attack', name:'Attack', frames:[{dur:240, pose:'raise'}, {dur:120, pose:'strike', lunge:1, fx:'attack', fxf:0},
    {dur:140, pose:'strike', lunge:1, fx:'attack', fxf:1}, {dur:160, pose:'strike', fx:'attack', fxf:2}, {dur:380}]},
  {id:'cast', name:'Cast', frames:[{dur:200, pose:'raise', fx:'heal', fxf:0}, {dur:200, pose:'raise', fx:'heal', fxf:1}, {dur:220, pose:'raise', fx:'heal', fxf:2}, {dur:380}]},
  {id:'jump', name:'Jump', frames:[{dur:120, squash:true}, {dur:110, dy:-2, fx:'whoosh', fxf:0}, {dur:220, dy:-4, fx:'whoosh', fxf:1}, {dur:110, dy:-2},
    {dur:110, squash:true, fx:'land', fxf:0}, {dur:150, fx:'land', fxf:1}, {dur:360}]},
  {id:'cheer', name:'Cheer', frames:[{dur:170, arms:'both', fx:'confetti', fxf:0}, {dur:170, arms:'both', dy:-2, fx:'confetti', fxf:1},
    {dur:200, arms:'both', dy:-3, fx:'confetti', fxf:2}, {dur:170, arms:'both', dy:-1, fx:'confetti', fxf:3}, {dur:420, arms:'both'}]},
  {id:'hurt', name:'Hurt', frames:[{dur:90, flash:true, lunge:-1, face:'concerned', fx:'hit', fxf:0, num:0}, {dur:90, lunge:-1, face:'concerned', fx:'hit', fxf:1, num:1},
    {dur:90, flash:true, face:'concerned', fx:'hit', fxf:2, num:2}, {dur:420, face:'concerned', num:3}, {dur:520}]}
];

// Effects library. Cells are [x, y, color key] relative to an anchor, drawn for a character facing right.
const plus = (x, y, k) => [[x,y,'W'],[x+1,y,k],[x-1,y,k],[x,y+1,k],[x,y-1,k]];
const heart = (x, y) => [[x,y,'P'],[x+2,y,'P'],[x,y+1,'P'],[x+1,y+1,'P'],[x+2,y+1,'P'],[x+1,y+2,'P']];
const CONFETTI = [[-7,0,'R'],[-3,-2,'Y'],[1,-3,'B'],[5,-1,'G'],[8,1,'P'],[-9,2,'L'],[3,1,'Y'],[-1,-5,'R']];
const FX = {
  slash:{name:'Slash', anchor:'hand', frames:[
    [[2,-7,'W'],[3,-6,'W'],[4,-5,'S'],[5,-4,'S'],[5,-3,'W']],
    [[2,-7,'S'],[3,-6,'W'],[4,-5,'W'],[5,-4,'W'],[5,-3,'W'],[6,-2,'W'],[6,-1,'S'],[5,0,'W'],[5,1,'S'],[4,2,'W'],[3,3,'S']],
    [[6,-1,'S'],[5,1,'S'],[4,2,'W'],[3,3,'S'],[2,4,'S']]]},
  thrust:{name:'Thrust', anchor:'hand', frames:[
    [[3,-1,'W'],[4,-1,'W'],[5,-1,'S'],[6,-1,'S']],
    [[4,-1,'W'],[5,-1,'W'],[6,-1,'W'],[7,-1,'W'],[8,-1,'S'],[9,-1,'S'],[6,-3,'S'],[7,-3,'S'],[6,1,'S'],[7,1,'S']],
    [[9,-1,'W'],[10,-1,'S'],[11,-1,'S'],[8,-3,'S'],[8,1,'S']]]},
  magic:{name:'Magic burst', anchor:'tip', frames:[
    plus(0, 0, 'Y'),
    [[0,0,'W'],[2,0,'Y'],[-2,0,'Y'],[0,2,'Y'],[0,-2,'Y'],[1,1,'P'],[-1,-1,'P'],[1,-1,'P'],[-1,1,'P'],[3,-3,'W'],[-3,3,'W']],
    [[3,-2,'Y'],[-2,-3,'P'],[2,3,'Y'],[-3,1,'P'],[4,1,'W'],[0,-4,'W']]]},
  heal:{name:'Heal', anchor:'body', frames:[
    [...plus(-7, 3, 'G'), ...plus(7, 1, 'G')],
    [...plus(-7, 0, 'G'), ...plus(7, -2, 'G'), ...plus(0, -9, 'G')],
    [...plus(-7, -3, 'G'), ...plus(7, -5, 'G'), ...plus(0, -12, 'G')]]},
  arrow:{name:'Arrow shot', anchor:'hand', frames:[0, 4, 8].map((o, i) => [[-3+o,-1,'R'],[-2+o,-1,'w'],[-1+o,-1,'w'],[o,-1,'w'],[1+o,-1,'w'],[2+o,-1,'M'],[3+o,-1,'K']]
    .concat(i ? [[-5+o,-1,'W'],[-7+o,-1,'S']] : []))},
  impact:{name:'Impact', anchor:'strike', frames:[
    plus(0, 0, 'Y'),
    [[0,0,'W'],[0,-3,'Y'],[0,3,'Y'],[-3,0,'Y'],[3,0,'Y'],[2,-2,'W'],[-2,2,'W'],[2,2,'W'],[-2,-2,'W'],[0,-2,'W'],[2,0,'W']],
    [[0,-4,'Y'],[0,4,'Y'],[4,0,'Y'],[-4,0,'Y'],[3,-3,'W'],[-3,3,'W']]]},
  hit:{name:'Hit spark', anchor:'body', frames:[
    [...plus(4, -6, 'Y'), [6,-8,'W'], [2,-4,'W']],
    [[4,-9,'Y'],[7,-6,'Y'],[4,-3,'Y'],[1,-6,'Y'],[6,-8,'W'],[6,-4,'W'],[2,-8,'W'],[2,-4,'W']],
    [[8,-7,'W'],[3,-10,'W']]]},
  dust:{name:'Footstep dust', anchor:'feet', under:true, frames:[
    [[-5,0,'D'],[-6,0,'d'],[-6,-1,'D']],
    [[-7,-1,'D'],[-8,0,'d'],[-7,-2,'d']]]},
  whoosh:{name:'Jump whoosh', anchor:'feet', under:true, frames:[
    [[-3,1,'W'],[-3,2,'S'],[3,1,'W'],[3,2,'S'],[0,2,'W']],
    [[-3,3,'S'],[3,3,'S'],[0,4,'S']]]},
  land:{name:'Landing dust', anchor:'feet', under:true, frames:[
    [[-4,0,'D'],[-5,0,'d'],[4,0,'D'],[5,0,'d'],[-4,-1,'D'],[4,-1,'D']],
    [[-6,-1,'d'],[6,-1,'d'],[-7,0,'d'],[7,0,'d']]]},
  confetti:{name:'Confetti', anchor:'head', frames:[0, 3, 6, 9].map((dy, i) => CONFETTI.map(([x, y, k], j) => [x + ((i + j) % 2 ? 1 : -1) * (i > 0 ? 1 : 0), y + dy, k]))},
  hearts:{name:'Hearts', anchor:'head', frames:[heart(8, 1), heart(9, -1)]},
  leaves:{name:'Leaf swirl', anchor:'tip', frames:[
    [[1,-1,'V'],[-1,1,'v'],[2,1,'V'],[0,0,'E']],
    [[3,-2,'V'],[-2,2,'v'],[1,3,'V'],[-3,-1,'v'],[0,0,'E'],[2,-4,'E']],
    [[5,-3,'V'],[-4,3,'v'],[2,5,'V'],[-5,-2,'v'],[4,2,'E']]]},
  aura:{name:'Legendary aura', anchor:'body', frames:[0, 1, 2, 3].map(i => {
    const spots = [[-8,6],[8,3],[-6,-4],[7,-7],[-1,-12],[-9,-1],[9,9]];
    return spots.filter((_, j) => (j + i) % 3 === 0).map(([x, y]) => [[x, y - i, 'S'], [x, y - i - 1, 'W']]).flat();
  })}
};
const FX_COLORS = {V:'#8fbf5a', v:'#4e7d36', E:'#b6de7c', W:'#fbf7ee', S:'#a3def4', Y:'#f9c776', P:'#f29bb8', G:'#8fbf5a', D:'#efe6cf', d:'#d9ccae', R:'#db614f', B:'#4e83ad', L:'#a77daa', K:'#171b20', w:'#9a6a3e', M:'#c9ced6'};
const FX_LIBRARY = [
  {fx:'slash', action:'attack', weapon:'sword', note:'Sword, dagger, axe'},
  {fx:'thrust', action:'attack', weapon:'spear', note:'Spear'},
  {fx:'magic', action:'attack', weapon:'staff', note:'Staff, wand'},
  {fx:'arrow', action:'attack', weapon:'bow', note:'Bow'},
  {fx:'impact', action:'attack', weapon:'hammer', note:'Hammer, tools, fists'},
  {fx:'heal', action:'cast', weapon:'staff', note:'Cast'},
  {fx:'leaves', action:'attack', weapon:'druidstaff', note:'Druid staff'},
  {fx:'hit', action:'hurt', note:'Hurt, with damage number'},
  {fx:'dust', action:'walk', note:'Walk'},
  {fx:'whoosh', action:'jump', note:'Jump take-off'},
  {fx:'land', action:'jump', note:'Jump landing'},
  {fx:'confetti', action:'cheer', note:'Cheer'},
  {fx:'hearts', action:'wave', note:'Wave'},
  {fx:'aura', action:'idle', weapon:'sword', tier:4, note:'Legendary gear, always on'}
];
// Tiny digit font for damage numbers
const DIGITS = {'-':["...","...","KKK","...","..."], '1':[".K.","KK.",".K.",".K.","KKK"], '2':["KK.","..K",".K.","K..","KKK"], '7':["KKK","..K",".K.",".K.",".K."]};

// ---------- helpers ----------
const toGrid = (rows, y0, w, h) => { const g = Array.from({length:h}, () => Array(w).fill(null));
  rows.forEach((r, y) => { const yy = y + y0; if (yy < 0 || yy >= h) return; for (let x = 0; x < r.length && x < w; x++) if (r[x] !== '.') g[yy][x] = r[x]; }); return g; };
const isHairCh = c => c && c !== 'S';
const mirrorRow = r => r.split('').reverse().join('');

function hairBackGrid(hair){
  const hf = toGrid(hair.front.rows, hair.front.y, 18, 24);
  let top = -1, last = -1, firstSolid = -1;
  for (let y = 0; y < 24; y++) {
    const xs = hf[y].map((c, x) => isHairCh(c) ? x : -1).filter(x => x >= 0);
    if (!xs.length) continue;
    if (top < 0) top = y;
    if (xs.some(x => x <= 3 || x >= 14)) last = y;
    if (firstSolid < 0) { const mn = Math.min(...xs), mx = Math.max(...xs); let gap = false; for (let x = mn; x <= mx; x++) if (!hf[y][x]) gap = true; if (!gap) firstSolid = y; }
  }
  const bottom = Math.min(15, last);
  const out = Array.from({length:24}, () => Array(18).fill(null));
  let pmn = 99, pmx = -1;
  for (let y = top; y <= bottom; y++) {
    const xs = hf[y].map((c, x) => isHairCh(c) ? x : -1).filter(x => x >= 0);
    let mn, mx;
    if (xs.length) { mn = Math.min(...xs); mx = Math.max(...xs); } else { mn = 2; mx = 15; }
    // from behind, the back of the head stays covered even where the front only shows a side lock
    if (y >= firstSolid && firstSolid >= 0) { mn = Math.min(mn, pmn); mx = Math.max(mx, pmx); }
    pmn = mn; pmx = mx;
    const shade = x => y <= top + 1 ? 'h' : (x <= mn + 1 || x >= mx - 1) ? 'D' : (y >= bottom - 1 ? 'M' : 'H');
    if (y < firstSolid) { for (let x = mn; x <= mx; x++) if (hf[y][x]) out[y][x] = hf[y][x] === '2' ? '2' : shade(x); continue; }
    for (let x = mn; x <= mx; x++) out[y][x] = (xs.length && (x === mn || x === mx)) ? '2' : shade(x);
  }
  // locks that hang past the head (braids, long side strands) still show from behind, on the mirrored side
  for (let y = bottom + 1; y < 24; y++) for (let x = 0; x < 18; x++) { const c = hf[y][x]; if (c && (isHairCh(c) || c === '2' || c === 'C') && (x <= 3 || x >= 14)) out[y][17 - x] = c; }
  return {grid: out, top, bottom};
}
function hairSideGrid(hair){
  const {grid, bottom} = hairBackGrid(hair);
  const hf = toGrid(hair.front.rows, hair.front.y, 18, 24);
  let fb = -1;
  for (let y = 0; y < 24; y++) for (let x = 5; x <= 12; x++) if (isHairCh(hf[y][x]) && hf[y][x] !== '2') fb = Math.max(fb, y);
  const g = grid.map(r => r.slice());
  for (let y = fb + 1; y <= bottom; y++) {
    if (y < 0) continue;
    for (let x = 9; x < 18; x++) g[y][x] = null;
    if (g[y][8] && g[y][8] !== '2') g[y][8] = 'D';
    if (y === fb + 1 && fb >= 0) for (let x = 9; x <= 14; x++) g[y][x] = 'S';
  }
  const coversEars = !!(hf[12] && (hf[12][1] || hf[12][2]));
  return {grid: g, coversEars};
}
function hatViews(hat){
  const fill = hat.fill || 'A';
  const filled = rows => rows.map((r, i) => {
    if (hat.y + i < 5) return r;
    const a = r.indexOf('2'), b = r.lastIndexOf('2');
    if (a < 0 || b <= a) return r;
    let s = r.split(''); for (let x = a + 1; x < b; x++) if (s[x] === '.') s[x] = fill; return s.join('');
  });
  let back = filled(hat.rows.map(mirrorRow));
  if (hat.fullHelm) back = back.map((r, i) => hat.y + i >= 5 ? r.replace(/[^.2]/g, fill) : r);
  let side = hat.rows.map(mirrorRow);
  if (hat.fullHelm) {
    side = hat.rows.map((r, i) => {
      const y = hat.y + i; const a = r.indexOf('2'), b = r.lastIndexOf('2');
      const hasOpening = a >= 0 && b > a && r.slice(a + 1, b).includes('.') && y >= 6;
      let s = filled([r])[0].split('');
      if (y >= 5) for (let x = 0; x < 8; x++) if (s[x] !== '.' && s[x] !== '2') s[x] = fill;
      if (hasOpening && y <= 15) {
        const edge = r[r.indexOf('.', a + 1) - 1] || fill;
        for (let x = 9; x < b; x++) s[x] = '.';
        s[8] = edge === '2' ? fill : edge;
      }
      return s.join('');
    });
  }
  return {back, side};
}
function outfitRowsFor(rows, outfit, dir){
  if (dir === 'down') return rows;
  if (dir === 'up') return outfit.backView || rows.map(r => { const n = r.replace(/[.2]/g, '').length; return n >= 8 ? r : '..................'; });
  const side = SIDE_BASE.slice(17, 23);
  return side.map((base, i) => {
    const ov = rows[i]; if (!ov) return '..................';
    const chars = ov.replace(/[.2]/g, ''); if (!chars) return '..................';
    const counts = {}; for (const c of chars) counts[c] = (counts[c] || 0) + 1;
    const main = Object.keys(counts).sort((p, q) => counts[q] - counts[p])[0];
    const center = ov[8] !== '.' && ov[8] !== '2' ? ov[8] : (ov[9] !== '.' && ov[9] !== '2' ? ov[9] : main);
    return base.split('').map((c, x) => {
      if (!/[AaLM]/.test(c)) return '.';
      if (chars.length >= 8) return main;
      return x >= 11 ? center : '.';
    }).join('');
  });
}
function sideFace(px){
  const out = [];
  px.forEach(([x, y, k]) => {
    if (k === 'E' || k === 'W' || k === 'H' || k === 'I') { if (x >= 11) out.push([x + 1, y, k]); }
    else if (k === 'R' || k === 'T' || k === 'N') { if (x >= 9) out.push([15, y, k]); }
    else if (k === 'P') { if (x === 13) out.push([12, y, k], [13, y, k]); }
    else if (k === 'V') { if (x >= 12) out.push([14, y, k]); }
  });
  return out;
}
const mergeRows = (base, over) => base.map((r, i) => { const o = over[i]; if (!o) return r; let s = ''; for (let x = 0; x < 18; x++) s += o[x] !== '.' ? o[x] : (r[x] || '.'); return s; });
const tierOf = look => TIERS[Math.max(0, Math.min(3, (look.tier || 1) - 1))];
const gearFor = (item, tier) => (item && item.rows && tier.elite && ELITE[item.id]) ? Object.assign({}, item, ELITE[item.id]) : item;

// ---------- compose ----------
function compose(look, view){
  view = view || {};
  const dir = view.dir || 'down';
  if (dir === 'left') {
    const g = compose(look, Object.assign({}, view, {dir:'right', near:'left', noOverlay:true}));
    const m = g.map(r => r.slice().reverse());
    if (!view.noOverlay) drawOverlays(m, look, view);
    return m;
  }
  const frame = view.frame || {};
  const tier = tierOf(look);
  const hair = HAIRS[look.hair], hc = HAIR_COLORS[look.hairColor], skin = SKINS[look.skin];
  const face = FACES[frame.face ? byId(FACES, frame.face) : look.face];
  const fh = FACIAL_HAIR[look.facialHair], fw = FACIAL_WEAR[look.facialWear];
  const hat = look.hatOff ? HATS[0] : HATS[look.hat];
  const neck = NECKWEAR[look.neck || 0];
  const outfit = OUTFITS[look.outfit];
  const weapon = gearFor(WEAPONS[look.weapon], tier), off = gearFor(OFFHANDS[look.offhand], tier);
  const dye = DYES[look.dye] || DYES[0];

  // colors
  const oc = Object.assign({L:skin.n, M:skin.S}, outfit.colors, dye.A ? {A:dye.A, a:dye.a} : {}, look.outfitColors || {});
  if (outfit.id === 'plate' && tier.metal && !dye.A && !(look.outfitColors && look.outfitColors.A)) { oc.A = tier.metal[0]; oc.a = tier.metal[1]; }
  oc.G = oc.G || PAL.gold; if (outfit.adventure) { oc.G = PAL.gold; oc.R = tier.gem || PAL.red; }
  const hatC = Object.assign({}, hat.colors || {}, look.hatColors || {});
  if (tier.id > 1) {
    if (['knight', 'visorhelm', 'horned'].includes(hat.id)) { hatC.M = tier.metal[0]; hatC.m = tier.metal[1]; }
    if (hat.id === 'kabuto' && tier.id >= 3) { hatC.A = tier.id === 4 ? PAL.navy : PAL.redDeep; hatC.a = tier.id === 4 ? PAL.navyShade : '#8c3a30'; }
    if (hat.id === 'dragon') { hatC.A = tier.metal[0]; hatC.a = tier.metal[1]; hatC.G = tier.gem; }
    if (['hood', 'feather', 'headband'].includes(hat.id)) hatC.C = tier.accent;
    if (hat.id === 'circlet') hatC.R = tier.gem;
    if (hat.id === 'wizard' && tier.id >= 3) { hatC.A = PAL.plum; hatC.a = PAL.plumShade; }
  }
  const gearC = Object.assign({}, GEAR_COLORS, look.gearColors || {}, tier.gear || {});
  const neckC = Object.assign({}, neck.colors || {}); if (neck.tierable && tier.id > 1) neckC.R = tier.gem;
  const hairMap = {h:hc.h, H:hc.H, M:hc.M, D:hc.D, S:skin.S, C:PAL.coral};

  const dx0 = (dir === 'right' ? (frame.lunge || 0) : 0), dy0 = frame.dy || 0;
  const g = Array.from({length:GH}, () => Array(GW).fill(null));
  const set = (x, y, c) => { const gx = x + OX + dx0, gy = y + OY + dy0; if (gx >= 0 && gx < GW && gy >= 0 && gy < GH && c) g[gy][gx] = c; };
  const put = (rows, map, ox, oy, keep) => rows.forEach((row, y) => {
    for (let x = 0; x < row.length; x++) { const ch = row[x]; if (ch === '.') continue; if (keep && !keep(y)) continue;
      set(x + ox, y + oy, ch === '2' ? PAL.outline : map[ch]); }
  });
  const putGrid = (grid, map) => grid.forEach((row, y) => row.forEach((ch, x) => { if (ch) set(x, y, ch === '2' ? PAL.outline : map[ch]); }));
  const outlined = (cells, halo) => {
    const own = new Set(cells.map(([x, y]) => x + ',' + y)), ring = [];
    cells.forEach(([x, y]) => [[1,0],[-1,0],[0,1],[0,-1]].forEach(([ex, ey]) => {
      const nx = x + ex, ny = y + ey; if (own.has(nx + ',' + ny)) return;
      set(nx, ny, PAL.outline); ring.push(nx + ',' + ny); }));
    cells.forEach(([x, y, c]) => set(x, y, c));
    if (halo) { const ringSet = new Set(ring); ring.forEach(k => { const [x, y] = k.split(',').map(Number);
      [[1,0],[-1,0],[0,1],[0,-1]].forEach(([ex, ey]) => { const nx = x + ex, ny = y + ey, key = nx + ',' + ny;
        if (own.has(key) || ringSet.has(key)) return; const gx = nx + OX + dx0, gy = ny + OY + dy0;
        if (gx >= 0 && gx < GW && gy >= 0 && gy < GH && !g[gy][gx]) g[gy][gx] = halo; }); }); }
  };
  const placeGear = (item, slot, pose) => {
    if (!item || !item.rows) return;
    let rows = item.rows.slice(); let [ax, ay] = item.anchor; const w = rows[0].length, h = rows.length;
    if (slot.mirror) { rows = rows.map(mirrorRow); ax = w - 1 - ax; }
    if (pose === 'strike') { rows = rows.slice().reverse(); ay = h - 1 - ay; }
    const pdx = pose === 'raise' ? (slot.mirror ? 1 : -1) : 0, pdy = pose === 'raise' ? -2 : 0;
    const ox = slot.pos[0] + slot.out - ax + pdx, oy = slot.pos[1] - ay + pdy;
    const cells = [];
    rows.forEach((r, y) => { for (let x = 0; x < r.length; x++) if (r[x] !== '.') cells.push([x + ox, y + oy, r[x] === '2' ? PAL.outline : gearC[r[x]]]); });
    if (item.outline === false) cells.forEach(([x, y, c]) => set(x, y, c)); else outlined(cells, tier.halo);
  };

  // hands: main weapon in the main hand, off-hand item in the other, consistent in every direction
  const mainHand = look.leftHanded ? 'left' : 'right', offHand = mainHand === 'right' ? 'left' : 'right';
  const near = view.near || 'right';
  const slotFor = hand => {
    if (dir === 'down') return hand === 'right' ? {pos:HAND_L, out:-1, mirror:true, layer:'front', screen:'L'} : {pos:HAND_R, out:1, mirror:false, layer:'front', screen:'R'};
    if (dir === 'up') return hand === 'right' ? {pos:HAND_R, out:1, mirror:false, layer:'back', screen:'R'} : {pos:HAND_L, out:-1, mirror:true, layer:'back', screen:'L'};
    return hand === near ? {pos:SIDE_HAND, out:1, mirror:false, layer:'front', near:true} : {pos:FAR_HAND, out:1, mirror:false, layer:'back', near:false};
  };
  const mainSlot = slotFor(mainHand), offSlot = slotFor(offHand);
  // raised arms
  const raised = new Set();
  if (frame.arms === 'wave') raised.add(offHand);
  if (frame.arms === 'both') { raised.add('left'); raised.add('right'); }
  const raisedScreens = new Set([...raised].map(h => slotFor(h)).filter(s => s.screen).map(s => s.screen));
  const nearRaised = dir === 'right' && raised.size > 0;
  const hidden = slot => (slot.screen && raisedScreens.has(slot.screen)) || (slot.near && nearRaised);

  // body rows: base, outfit (with tier trim), legs
  let ovFront = outfit.rows;
  if (outfit.adventure && tier.deco) ovFront = mergeRows(TIER_DECO[tier.deco], Array.from({length:6}, (_, i) => outfit.rows[i] || '..................'));
  const ovRows = outfitRowsFor(ovFront, outfit, dir);
  const baseRows = (dir === 'right' ? SIDE_BASE : BASE).slice();
  let body = baseRows.map((row, y) => {
    const ov = y >= 17 ? ovRows[y - 17] : null; if (!ov) return row;
    let r = ''; for (let x = 0; x < 18; x++) r += ov[x] !== '.' ? ov[x] : row[x]; return r;
  });
  const legSet = LEGS[dir === 'right' ? 'side' : 'front'][frame.legs || 'stand'];
  const robe = ovRows[5] && ovRows[5].replace(/[.2]/g, '').length >= 6 ? ovRows[5].replace(/[.2]/g, '')[0] : null;
  body = body.slice(0, 22).concat(legSet.map((r, i) => i === 0 && robe ? r.replace(/[LM]/g, robe) : r));
  const edit = cells => { body = body.map(r => r.split('')); cells.forEach(([x, y, c]) => body[y][x] = c); body = body.map(r => r.join('')); };
  const limbs = [];
  if (dir !== 'right') {
    if (raisedScreens.has('R')) { edit([[14,19,'.'],[15,19,'.'],[14,20,'.'],[15,20,'.']]); limbs.push(...(frame.armFrame ? [[14,17,'A'],[15,16,'A'],[16,15,'n']] : [[14,17,'A'],[15,16,'n']])); }
    if (raisedScreens.has('L')) { edit([[2,19,'.'],[3,19,'.'],[2,20,'.'],[3,20,'.']]); limbs.push(...(frame.armFrame ? [[3,17,'A'],[2,16,'A'],[1,15,'n']] : [[3,17,'A'],[2,16,'n']])); }
  } else if (nearRaised) {
    edit([[9,19,'A'],[8,20,'A'],[9,20,'A'],[10,20,'A'],[9,21,'a']]);
    limbs.push(...(frame.armFrame ? [[10,18,'A'],[11,18,'A'],[12,17,'A'],[13,16,'A'],[14,15,'n']] : [[10,18,'A'],[11,18,'A'],[12,17,'A'],[13,16,'n']]));
  }
  const bodyMap = Object.assign({n:skin.n, S:skin.S}, oc);
  const drawLimbs = () => { if (limbs.length) outlined(limbs.map(([x, y, k]) => [x, y, bodyMap[k]]), null); };
  const fxKind = WEAPON_FX[WEAPONS[look.weapon].id] || 'impact';
  const keepUpright = ['magic', 'arrow', 'thrust', 'leaves'].includes(fxKind);
  const drawGearLayer = layer => {
    const pose = frame.pose === 'strike' && keepUpright ? null : (frame.pose || null);
    if (weapon.rows && !hidden(mainSlot)) { const l = (pose && dir === 'right') ? 'front' : mainSlot.layer; if (l === layer) placeGear(weapon, mainSlot, pose); }
    if (off.rows && !hidden(offSlot) && offSlot.layer === layer) placeGear(off, offSlot, null);
  };
  const hatRows = dir === 'down' ? hat.rows : dir === 'up' ? (hat.backRows || (hat.rows && hatViews(hat).back)) : (hat.sideRows || (hat.rows && hatViews(hat).side));
  const hatExtras = () => {
    if (!hat.rows) return;
    if ((hat.id === 'knight' || hat.id === 'visorhelm') && tier.id >= 3) put(HELM_CREST, {C: tier.id === 4 ? PAL.ice : PAL.red}, 0, hat.y - 2);
    if (hat.id === 'wizard' && tier.id >= 3 && dir !== 'up') [[10,-2],[8,0],[12,1],[6,2]].slice(0, tier.id === 4 ? 4 : 2).forEach(([x, y]) => set(x, y, PAL.paleYellow));
  };

  // ---- back layers ----
  if (dir === 'down') {
    if (outfit.back) put(outfit.back, oc, 0, 17);
    if (hair.back && !hat.hideBack && !hat.hideHair) put(hair.back.rows, hairMap, hair.back.x || 0, hair.back.y);
  } else if (dir === 'right') {
    if (outfit.sideBack) put(outfit.sideBack, oc, 0, 17);
    if (hair.back && !hat.hideBack && !hat.hideHair) {
      const half = hair.back.rows[0].length / 2;
      put(hair.back.rows.map(r => r.slice(0, half) + '.'.repeat(r.length - half)), hairMap, hair.back.x || 0, hair.back.y);
    }
  }
  drawGearLayer('back');
  const pet = PETS[look.pet || 0];
  if (pet && pet.colors) {
    const art = dir === 'up' ? PET_ART.back : dir === 'right' ? PET_ART.side : PET_ART.front;
    const hop = (frame.legs && frame.legs !== 'stand') || frame.squash ? -1 : 0;
    put(art, pet.colors, -6, 16 + hop - (frame.dy || 0));
  }

  // ---- body ----
  put(body, bodyMap, 0, 0);
  if (dir === 'up') {
    if (outfit.backView) put(outfit.backView, oc, 0, 17);
    if (neck.back) put(neck.back.rows, neckC, 0, neck.back.y);
    if (hair.front && !hat.hideHair) putGrid(hairBackGrid(hair).grid, hairMap);
    if (hair.back && !hat.hideBack && !hat.hideHair) put(hair.back.rows, hairMap, hair.back.x || 0, hair.back.y);
    if (hatRows) put(hatRows, hatC, 0, hat.y);
    hatExtras();
    drawLimbs();
  } else {
    const nv = dir === 'right' ? neck.side : neck.front;
    if (nv) put(nv.rows, neckC, 0, nv.y);
    const eyeC = EYE_COLORS[look.eyeColor || 0] || EYE_COLORS[0];
    const fmap = {E:PAL.outline, W:PAL.shine, N:skin.N, R:PAL.mouth, T:PAL.coral, P:PAL.blush, V:PAL.sky, H:PAL.coral, I:eyeC.I};
    let px = eyeStyle(face.px, eyeShapeOf(look));
    if (view.blink && !/happy|laugh|sleepy|love|wink/.test(face.id)) px = px.filter(p => p[2] !== 'E' && p[2] !== 'W' || p[1] < 12).concat(BLINK);
    if (dir === 'right') px = sideFace(px);
    if (!view.noFace) px.forEach(([x, y, k]) => { if (view.noMouth && (k === 'R' || k === 'T')) return; set(x, y, fmap[k]); });
    const fhv = dir === 'right' ? fh.side : fh;
    if (fhv && fhv.rows) put(fhv.rows, {H:hc.H, D:hc.D}, 0, fhv.y);
    const clip = hat.rows ? (hat.clip || 0) : 0;
    if (dir === 'down') {
      if (hair.front && !hat.hideHair) put(hair.front.rows, hairMap, 0, hair.front.y, y => y + hair.front.y >= clip);
    } else {
      let covers = false;
      if (hair.front && !hat.hideHair) { const sv = hairSideGrid(hair); covers = sv.coversEars;
        putGrid(sv.grid.map((r, y) => y >= clip ? r : r.map(() => null)), hairMap); }
      if (!covers && !hat.hideHair) SIDE_EAR.forEach(([x, y, k]) => set(x, y, k === '2' ? PAL.outline : bodyMap[k]));
    }
    const fwv = dir === 'right' ? fw.side : fw;
    if (fwv && fwv.rows) put(fwv.rows, Object.assign({}, fw.colors), 0, fwv.y);
    if (hatRows) put(hatRows, hatC, 0, hat.y);
    hatExtras();
    drawLimbs();
    drawGearLayer('front');
  }
  if (frame.flash) for (let y = 0; y < GH; y++) for (let x = 0; x < GW; x++) if (g[y][x] && g[y][x] !== PAL.outline) g[y][x] = PAL.white;
  if (frame.squash) { for (let y = OY + 21; y > 0; y--) g[y] = g[y - 1].slice(); g[0] = Array(GW).fill(null); }

  // ---- effects ----
  const drawFx = (id, f, mirrorX) => {
    const fx = FX[id]; if (!fx) return; const cells = fx.frames[f % fx.frames.length]; if (!cells) return;
    let ax, ay, mx = mirrorX ? -1 : 1;
    const hand = mainSlot.pos, handSide = (dir === 'down' && mainSlot.screen === 'L') || (dir === 'up' && mainSlot.screen === 'L');
    if (fx.anchor === 'hand' || fx.anchor === 'tip' || fx.anchor === 'strike') {
      [ax, ay] = dir === 'right' ? SIDE_HAND : hand; if (handSide) mx = -mx;
      if (fx.anchor === 'tip') { ax += 6 * mx; ay -= 6; } if (fx.anchor === 'strike') { ax += 4 * mx; ay -= 1; }
    } else if (fx.anchor === 'feet') { [ax, ay] = dir === 'right' ? [9, 23] : [8, 23]; }
    else if (fx.anchor === 'head') { [ax, ay] = [8, -1]; }
    else { [ax, ay] = [8, 14]; }
    const tint = Object.assign({}, FX_COLORS); if (tier.id === 3) tint.S = PAL.gold; if (tier.id === 4) tint.S = PAL.pink;
    cells.forEach(([x, y, k]) => { const gx = ax + x * mx + OX + dx0, gy = ay + y + OY + dy0; if (fx.under && gx >= 0 && gx < GW && gy >= 0 && gy < GH && g[gy][gx]) return; set(ax + x * mx, ay + y, tint[k]); });
  };
  if (frame.fx) drawFx(frame.fx === 'attack' ? (WEAPON_FX[WEAPONS[look.weapon].id] || 'impact') : frame.fx, frame.fxf || 0, frame.fxMirror);
  if (tier.aura && (weapon.rows || outfit.adventure)) drawFx('aura', Math.floor((view.time || 0) / 160));
  bodyShape(g, look, dir);
  if (!view.noOverlay) drawOverlays(g, look, view);
  return g;
}
/* open eyes get the iris colour under a dark lid, like the portrait; the eye shape adds width, lashes or a squint */
function eyeStyle(px, shape){
  const has = (x, y) => px.some(p => p[0] === x && p[1] === y && p[2] === 'E');
  let out = px.slice();
  for (const [x, outer] of [[5, -1], [12, 1]]) {
    if (!(has(x, 12) && has(x, 13)) || px.some(p => p[2] === 'W' && Math.abs(p[0] - x) <= 1)) continue;   // only plain open eyes
    out = out.filter(p => !(p[0] === x && p[1] === 13 && p[2] === 'E'));
    if (shape === 'narrow') { out = out.filter(p => !(p[0] === x && p[1] === 12)); out.push([x, 13, 'E'], [x + outer, 13, 'E']); continue; }
    out.push([x, 13, 'I']);
    if (shape === 'big') out.push([x + outer, 12, 'E'], [x + outer, 13, 'I'], [x, 12, 'W']);
    if (shape === 'lashes') out.push([x + outer, 12, 'E']);
  }
  return out;
}
/* body types reshape the finished sprite: young is shorter, tall is taller, stout is wider, old is shorter and stoops */
function bodyShape(g, look, dir){
  const b = (BODIES[look.body || 0] || BODIES[0]).id; if (b === 'standard') return;
  const cx = OX + 9, rows = g.map(r => r.slice());
  const widen = (row, n) => { let r = row; for (let k = 0; k < n; k++) { const o = r; r = o.map((_, x) => x <= cx - 2 ? (o[x + 1] ?? null) : x >= cx + 1 ? (o[x - 1] ?? null) : o[x]); } return r; };
  let out = rows;
  if (b === 'stout') out = rows.map((r, y) => y >= OY + 17 && y <= OY + 20 ? widen(r, 2) : y >= OY + 8 ? widen(r, 1) : r);
  if (b === 'young') { out = rows.filter((r, y) => y !== OY + 18 && y !== OY + 22); out.unshift(Array(GW).fill(null), Array(GW).fill(null)); }
  if (b === 'tall') { out = []; rows.forEach((r, y) => { out.push(r); if (y === OY + 18 || y === OY + 22) out.push(r.slice()); }); out = out.slice(2); }
  if (b === 'old') {
    out = rows.filter((r, y) => y !== OY + 22); out.unshift(Array(GW).fill(null));
    if (dir === 'right') out = out.map((r, y) => y < OY + 17 + 1 ? [null].concat(r.slice(0, GW - 1)) : r);
  }
  for (let y = 0; y < GH; y++) g[y] = out[y] || Array(GW).fill(null);
  // empty-handed elders get a walking cane
  if (b === 'old' && !(look.weapon > 0) && !(look.offhand > 0) && dir !== 'up') {
    const cx2 = dir === 'right' ? OX + 12 : OX + 16, top = OY + 19;
    for (let y = top; y <= OY + 23; y++) g[y][cx2] = y === top ? PAL.outline : PAL.woodShade;
    g[top][cx2 - 1] = PAL.outline; g[top + 1][cx2 - 1] = PAL.woodShade;
  }
}
function drawOverlays(g, look, view){
  const frame = view.frame || {};
  const dy = frame.dy || 0;
  const em = EMOTES[look.emote || 0];
  if (em && em.icon) {
    const x0 = 22, y0 = Math.max(0, 1 + dy);
    BUBBLE.forEach((r, y) => { for (let x = 0; x < r.length; x++) { if (r[x] === '.') continue; const gx = x0 + x, gy = y0 + y; if (gy < GH && gx < GW) g[gy][gx] = r[x] === '2' ? PAL.outline : '#ffffff'; } });
    em.icon.forEach((r, y) => { for (let x = 0; x < 5; x++) if (r[x] !== '.') g[y0 + 1 + y][x0 + 2 + x] = EMOTE_COLORS[r[x]]; });
  }
  if (frame.num != null) {
    const text = '-12', x0 = 21, y0 = OY - 1 + dy - frame.num * 2;
    const cells = [];
    [...text].forEach((ch, i) => DIGITS[ch].forEach((r, y) => { for (let x = 0; x < 3; x++) if (r[x] !== '.') cells.push([x0 + i * 4 + x, y0 + y]); }));
    const own = new Set(cells.map(([x, y]) => x + ',' + y));
    cells.forEach(([x, y]) => [[1,0],[-1,0],[0,1],[0,-1],[1,1],[-1,-1],[1,-1],[-1,1]].forEach(([ex, ey]) => { const nx = x + ex, ny = y + ey;
      if (!own.has(nx + ',' + ny) && nx >= 0 && nx < GW && ny >= 0 && ny < GH) g[ny][nx] = PAL.outline; }));
    cells.forEach(([x, y]) => { if (x >= 0 && x < GW && y >= 0 && y < GH) g[y][x] = '#ec5448'; });
  }
}
function validateEngine(){
  const bad = [];
  const chk = (rows, w, label) => (rows || []).forEach((r, i) => { if (r.length !== w) bad.push(label + ' row ' + i + ' is ' + r.length); });
  chk(SIDE_BASE, 18, 'side base');
  Object.entries(LEGS).forEach(([k, v]) => Object.entries(v).forEach(([n, rows]) => chk(rows, 18, 'legs ' + k + ' ' + n)));
  FACIAL_WEAR.forEach(f => f.side && chk(f.side.rows, 18, 'side wear ' + f.id));
  FACIAL_HAIR.forEach(f => f.side && chk(f.side.rows, 18, 'side facial hair ' + f.id));
  OUTFITS.forEach(o => { chk(o.backView, 18, 'back ' + o.id); chk(o.sideBack, 18, 'sideBack ' + o.id); });
  HATS.forEach(h => chk(h.rows, 18, 'hat ' + h.id));
  NECKWEAR.forEach(n => ['front', 'side', 'back'].forEach(v => n[v] && chk(n[v].rows, 18, 'neck ' + n.id + ' ' + v)));
  Object.entries(PET_ART).forEach(([k, v]) => chk(v, 10, 'pet ' + k));
  Object.entries(TIER_DECO).forEach(([k, v]) => chk(v, 18, 'tier deco ' + k));
  Object.entries(ELITE).forEach(([k, v]) => chk(v.rows, v.rows[0].length, 'elite ' + k));
  EMOTES.forEach(e => chk(e.icon, 5, 'emote ' + e.id));
  if (SIDE_BASE.length !== 24) bad.push('side base has ' + SIDE_BASE.length + ' rows');
  return bad;
}

// ---------- Portraits ----------
// Portraits are their own style: head only, smoothed with Scale2x (palette colors only), with the face redrawn
// around big anime eyes (top lash and flick, white shine, colored iris).
const EYE_COLORS = [
  {id:'dark', name:'Dark', I:'#6b4a3a', i:'#9c6e58'},
  {id:'blue', name:'Blue', I:'#4e83ad', i:'#8fc7ec'},
  {id:'green', name:'Green', I:'#4e7d36', i:'#8fbf5a'},
  {id:'amber', name:'Amber', I:'#c99a3a', i:'#f9c776'},
  {id:'rose', name:'Rose', I:'#d67599', i:'#f29bb8'},
  {id:'violet', name:'Violet', I:'#86618a', i:'#c7a6d9'},
  {id:'gray', name:'Gray', I:'#6f7680', i:'#b3bac4'}
];
const PORTRAIT = {x:OX - 2, y:OY - 3, w:22, h:22};   // grid crop, drawn at 2x = 44 x 44
const PORTRAIT_BLUSH = '#f8b6a4';
function portraitBg(look){
  const pick = PORTRAIT_BG[look.portraitBg || 0];
  if (pick && pick.c) return pick.c;
  const outfit = OUTFITS[look.outfit], dye = DYES[look.dye] || DYES[0];
  const A = (look.outfitColors && look.outfitColors.A) || dye.A || outfit.colors.A || '#cccccc';
  const [r, gg, b] = [1, 3, 5].map(i => parseInt(A.slice(i, i + 2), 16) / 255);
  const mx = Math.max(r, gg, b), mn = Math.min(r, gg, b), d = mx - mn;
  if (d < 0.12) return byIdC('sky');
  let h = mx === r ? ((gg - b) / d) % 6 : mx === gg ? (b - r) / d + 2 : (r - gg) / d + 4; h = (h * 60 + 360) % 360;
  return byIdC(h < 40 ? 'lilac' : h < 70 ? 'sky' : h < 170 ? 'mint' : h < 250 ? 'butter' : h < 320 ? 'rose' : 'peach');
}
const byIdC = id => PORTRAIT_BG.find(p => p.id === id).c;
function scale2x(g){
  const h = g.length, w = g[0].length, out = Array.from({length:h * 2}, () => Array(w * 2).fill(null));
  const at = (x, y) => (x < 0 || y < 0 || x >= w || y >= h) ? null : g[y][x];
  for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
    const P = g[y][x], A = at(x, y - 1), B = at(x + 1, y), C = at(x - 1, y), D = at(x, y + 1);
    out[2*y][2*x]     = (C === A && C !== D && A !== B) ? A : P;
    out[2*y][2*x+1]   = (A === B && A !== C && B !== D) ? B : P;
    out[2*y+1][2*x]   = (D === C && D !== B && C !== A) ? C : P;
    out[2*y+1][2*x+1] = (B === D && B !== A && D !== C) ? D : P;
  }
  return out;
}
// Eye shapes for the left eye, 4 wide from column 13, top row 33. The right eye is mirrored (x -> 42 - x).
const PEYE = {
  open:    ["KKKK", "KWKK", "KKKK", "IIII", ".ii."],
  sparkle: ["KKKK", "KWKK", "KKWK", "IIII", ".ii."],
  wide:    ["KKKK", "KWWK", "KWKK", "KIIK", ".KK."],
  happy:   ["....", ".KK.", "K..K", "....", "...."],
  closed:  ["....", "....", "KKKK", ".KK.", "...."],
  heart:   [".P.P", "PPPP", "PPPP", ".PP.", "...."]
};
const PFACE = {
  neutral:{eye:'open', brow:'flat', mouth:'small'}, smile:{eye:'open', brow:'flat', mouth:'smile'},
  happy:{eye:'happy', brow:'flat', mouth:'smile', blush:true}, laugh:{eye:'happy', brow:'flat', mouth:'open', blush:true},
  surprised:{eye:'wide', brow:'raised', mouth:'o'}, sleepy:{eye:'closed', brow:'flat', mouth:'small'},
  concerned:{eye:'open', brow:'worried', mouth:'frown'}, excited:{eye:'sparkle', brow:'raised', mouth:'open', blush:true},
  angry:{eye:'open', brow:'angry', mouth:'frown'}, sad:{eye:'open', brow:'worried', mouth:'frown', tear:true},
  love:{eye:'heart', brow:'flat', mouth:'smile', blush:true}, wink:{eye:'open', right:'happy', brow:'flat', mouth:'smile'}
};
const PBROW = {flat:[[13,31],[14,31],[15,31]], raised:[[13,30],[14,29],[15,29],[16,30]], worried:[[13,31],[14,31],[15,30],[16,29]], angry:[[13,29],[14,30],[15,30],[16,31]]};
// Portrait mouths sit where the sprite mouth is (coordinates are 4 rows lower, see paint()).
const PMOUTH = {
  small:[[20,39,'M'],[21,39,'M']],
  smile:[[18,39,'M'],[23,39,'M'],[19,40,'M'],[20,40,'M'],[21,40,'M'],[22,40,'M']],
  open:[[18,38,'M'],[19,38,'M'],[20,38,'M'],[21,38,'M'],[22,38,'M'],[23,38,'M'],[18,39,'M'],[19,39,'D'],[20,39,'D'],[21,39,'D'],[22,39,'D'],[23,39,'M'],
        [19,40,'M'],[20,40,'T'],[21,40,'T'],[22,40,'M'],[20,41,'M'],[21,41,'M']],
  o:[[20,38,'M'],[21,38,'M'],[19,39,'M'],[20,39,'D'],[21,39,'D'],[22,39,'M'],[20,40,'M'],[21,40,'M']],
  frown:[[19,39,'M'],[20,39,'M'],[21,39,'M'],[22,39,'M'],[18,40,'M'],[23,40,'M']]
};
const PMOUTH_FOR = {neutral:'small', smile:'smile', happy:'open', laugh:'open', surprised:'o', sleepy:'small', concerned:'frown', excited:'open', angry:'frown', sad:'frown', love:'open', wink:'smile'};
function composePortrait(look){
  const l = Object.assign({}, look, {emote:0, weapon:0, offhand:0, pet:0});
  const g = compose(l, {dir:'down', noOverlay:true, noFace:true});
  return g.slice(PORTRAIT.y, PORTRAIT.y + PORTRAIT.h).map(r => r.slice(PORTRAIT.x, PORTRAIT.x + PORTRAIT.w));
}
// Three-quarter turn: the head stays upright; columns are remapped so the face center slides toward the turn.
// The back of the head widens and the far side of the face (and far eye) narrows.
const TURN = {L:2, R:41, c:21, shift:7};
function turnMap(turn){
  const {L, R, c} = TURN, c2 = c + turn * TURN.shift;
  const fwd = s => s <= c ? L + (s - L) * (c2 - L) / (c - L) : c2 + (s - c) * (R - c2) / (R - c);
  const back = x => x <= c2 ? L + (x - L) * (c - L) / (c2 - L) : c + (x - c2) * (R - c) / (R - c2);
  return {fwd, back};
}
function composePortraitHD(look, turn){
  turn = turn || 0;
  let g = scale2x(composePortrait(look));
  const tm = turnMap(turn);
  if (turn) {
    const w = g[0].length;
    g = g.map(row => row.map((_, x) => { if (x < TURN.L || x > TURN.R) return row[x]; const s = Math.round(tm.back(x)); return row[Math.max(0, Math.min(w - 1, s))]; }));
  }
  const skin = SKINS[look.skin], hc = HAIR_COLORS[look.hairColor], eye = EYE_COLORS[look.eyeColor || 0] || EYE_COLORS[0];
  const pf = PFACE[FACES[look.face].id] || PFACE.neutral;
  const isSkin = (x, y) => g[y] && (g[y][x] === skin.n || g[y][x] === skin.S);
  // feature coordinates are laid out for a front face 4 rows lower; each source column maps to a range after the turn
  const paint = (x, y, c) => { y -= 4; const a = Math.round(tm.fwd(x)), b = Math.max(a, Math.round(tm.fwd(x + 1)) - 1);
    for (let xx = a; xx <= b; xx++) if (isSkin(xx, y)) g[y][xx] = c; };
  const colors = {K:PAL.outline, W:PAL.shine, I:eye.I, i:eye.i, P:PAL.coral, M:PAL.mouth, D:'#b4473b', T:PAL.coral};
  const drawEye = (shape, mirror) => PEYE[shape].forEach((row, dy) => [...row].forEach((ch, dx) => {
    if (ch === '.') return; const x = mirror ? 42 - (13 + dx) : 13 + dx; paint(x, 33 + dy, colors[ch]); }));
  [[11,38],[12,38],[13,38],[29,38],[30,38],[31,38]].forEach(([x, y]) => paint(x, y, pf.blush ? '#f6a99a' : PORTRAIT_BLUSH));
  drawEye(pf.eye, false); drawEye(pf.right || pf.eye, true);
  if (pf.eye === 'open' || pf.eye === 'sparkle' || pf.eye === 'wide') { paint(12, 33, PAL.outline); paint(11, 32, PAL.outline); paint(30, 33, PAL.outline); paint(31, 32, PAL.outline); }
  PBROW[pf.brow].forEach(([x, y]) => { paint(x, y, hc.D); paint(42 - x, y, hc.D); });
  if (pf.tear) [[14,38],[14,39],[28,38],[28,39]].forEach(([x, y]) => paint(x, y, PAL.sky));
  const fw = FACIAL_WEAR[look.facialWear].id, fh = FACIAL_HAIR[look.facialHair].id;
  if (!['mask', 'menpo'].includes(fw) && !['beard', 'longbeard'].includes(fh)) PMOUTH[PMOUTH_FOR[FACES[look.face].id] || 'small'].forEach(([x, y, k]) => paint(x, y, colors[k]));
  // hair gloss on the crown, following the turn
  let top = -1; for (let y = 0; y < g.length && top < 0; y++) if (g[y].includes(hc.H)) top = y;
  if (top >= 0) [[top + 3, 17, 26], [top + 4, 19, 24]].forEach(([y, a, b]) => { for (let x = Math.round(tm.fwd(a)); x <= Math.round(tm.fwd(b)); x++) if (g[y] && g[y][x] === hc.H) g[y][x] = hc.h; });
  return g;
}

// Final portrait: smoothed once more to 88 x 88, facing SE, front or SW.
function composePortraitTilted(look){
  const pose = portraitPose(look);
  return scale2x(composePortraitHD(look, pose.turn));
}

// ---------- Hero & Friend portraits ----------
// The Hero & Friend Sprite Studio engine (hand-drawn boy, 8 directions), wrapped so its names stay private.
const HF = (() => {
const BASEDATA = {"boy":{"names":["outline","hairDark","hair","hairLight","skin","skinShade","blush","mouth","red","redDark","heart","blue","blueDark","shoe","shoeShade"],"palette":["#160f18","#603c38","#834f40","#a5664a","#fdc58d","#ed9462","#fba17b","#a2413a","#d1262b","#a31c2c","#fcefd4","#4d78b8","#364e9d","#faf8f0","#b2afb8"],"frames":{"S":["...................000................","..................0000................","...........000...00220................","..........0020.0023220..00000000......",".........00320.02222100000222220......","........003220022222100022222200......",".......002321022222212222222220.......",".......002222222222222233222210000....","....00000222222222222222223321220000..","...0000002222222222222332222222223320.","...0222222222222233222233222222222110.","..02222233222323233323223332332222100.",".00012223233223222233221223323322100..",".00002222232223222223222022222232200..","...0232222321222002222220122222222200.","..02232222220022050112216120222222220.",".0022222222155121455112261055112211100",".0222222121555654445500044055012221100","0011212211544444444444444444455011000.","00001221106444444444444442244450110...",".0001111564411244444444442424460110...","...01111564444444444444444444440000...","...01111044444444444444444444440000...","...0011004444404444444444004444000....","...0000004444000444444444004444000....","...00400044440004444444440044440040...","...04550044440004446654440044440540...","...04550044664044446554440066647540...","...04655546666444444444444666647550...","...0066774666644474444224446640550....","....00000544444447777774444444000.....",".....00000044444444444444445000.......",".........005044444444444440500........","...........00000677777000000..........",".............0000777770000............","............009997555799900...........","...........008899900099888800.........","..........0088888888888888880.........",".........008888888888888888800........",".........08889888aa88aa8889880........","........00889988aaaaaaaa8808880.......","........08889988aaaaaaaa8808880.......",".......0088899888aaaaaa888098880......",".......00889098888aaaa8888999880......",".......00889098888aaa888889099000.....","......0047700888888a8888889000400.....","......004440098888888888880054400.....","......00577009999999999999c077500.....",".......005000cbbbbbbbbbbbbc00000......","........00000bbbbbbbbbbbbbc0000.......","...........0cbbbcc000ccbbbc0..........","...........0cbbbcc0.00cbbbb0..........","...........0bbbbb00..0cbbbb0..........","...........0cc0bc00..0bcccc00.........","..........00eeebc00..0cceee00.........","..........0aadeee00..0eeedaa0.........","..........0eaddee00..0eeddae0.........","..........00000000....000000.........."],"SE":["....................000...............","...................0030...............",".................003320...000000......","............00..0232220.00222200......","..........0020002232210032322200......","........00222002222220123322200.......","........0032202222221123332210000000..","........02221122322223333222103330000.","........02222222222222333222223322100.",".....0000222222222222232223322222200..","....0000022222222222223322333222100...","...002222232222223323333322233221000..","...0222222222223233223223222222222000.","..02222332232322233223223321222222200.","..000223333322222222122223111222222200","...00222323322212222012222150112211200","..002222222222212220002222155002220000","..002222222222212225501222654501220...",".0022222222212202205550110544450220...",".0211221222111550044445004444440120...","00111222221200444444444444422240110...","00111221121105444222444444444440000...","0000111112115444144444444444444000....","0000111111110444444444444444444000....","..001111111044444404444444400440......","..001111011144444000444444400040......","..000100001144444000444444400440......","..000004441144444000444454400440......","....0044550144446004444555444660......","....0046554444666644444444446660......",".....004554444466644444446444500......",".....00055544444444447777444400.......","......000005544444444444444400........","........000005555444444445000.........","..........00000077777000000...........",".............00077777000..............","............0099975577900.............","...........00888999999990.............","..........0088888888888800............","..........088889888a88aa00............","..........08888988aaaaaa000...........",".........088889088aaaaaa080...........",".........088880988aaaaaa000...........","........00888909888aaaa80090..........","........008889098888aa8800900.........","........0088909988888d8880000.........","........047770998888888800400.........","........044440999999999000500.........","........054400cccccbbbbb000...........","........00000ccbbbbbcbcb00............",".........000ccbbbc000cbb00............","...........0ccbbbb00ccbb00............","...........0cbbbbb00ccbb00............","..........00bcbbb000cccc000...........","..........00bbccc0d0e0cedd00..........","..........0ecccdd000eeeeaa00..........","..........0eedeedd0000000000..........","..........0eedddd00...00000...........","...........0000000...................."],"E":[".................00................","................0000....00.........","...............02220...0000........","..........00000222000002220........",".........002002222100232220........","........022002322112332220000000...","......002221223222333322102222200..","......002221222223333222222322200..","......02222222222223222222222100...","......0222122122222332233222110....",".....00222222222233233223332100....","...000022222222223332322222222200..","..00222222322233323322322222222200.",".0022222323223222223322222222222200","00222222322332232222222221222211100","00112222222222222222221222022220000","00002222222222222222221225501220...","..002222222222222222221025660120...","..0222222222222122211215044450100..",".00122222212221222111114444400100..",".0212212221222112211004442440010...","0011211222112111121105442444000....","000011122121111111110444444400.....","000011111111111111104444404400.....","...011111111111111105444404400.....","...011111111100001104444404400.....","...001111111104441104444404400.....","...001111111045541104466404400.....",".....0111111045554444666644400.....",".....0111111004654444466644400.....","......00111110444444444444400......","........01111100066444444400.......",".........000111555555664400........","..........0000077750000000.........",".............00777700000...........","............009999700..............","...........0099889990..............","...........00888888800.............","...........009888888a0.............","...........08788880aa00............","..........008788880aaa0............","..........0080888808aa0............","..........00808888088a0............","..........0080888808880............","..........0089988808880............","..........0089097740880............","..........0009044440990............","..........00bc054400bc0............","...........00cc0000cc00............","...........00cc000bb00.............","...........00ccccbbb00.............","...........00ccbbbb000.............","...........00ccbbbb000.............","..........0000bbbbc0000............","..........00e0cccce00d0............","..........0000edaeedd00............","...........000edaeddd0.............",".............000000000............."],"NE":["....................0................","..................0000...............","................000200...00..........","............00.0022200.0000000.......","..........00200022220000022220.......",".........00220022221102222210........","........002220222221122222210.0000...",".......0022211222222222222110000000..",".......0022222222222222222222222220..","....0000022222122222222222222222100..","...0022112211122222223222222222100...","..00222222222222222223222222222100...",".002112222222222222222222222222200...",".0000222232222222223222222222222220..","...002222323222222222222222222222220.","..00122222222222222222222222222211100","..01122222222222222222222222222221000",".001122222222222222222222222222220000",".011222222222222222222222222221220...","00222222222222222222222222112211120..","02112222222222222222222222111210120..","01112122222222222222222212111210100..","00001122122222222222221211111110000..","000011112122222222222211111111000....","...01111212222222222121111111100.....","..000111111222212211111111001100.....","..000011111122112111111111440100.....","..000011111111111111111110450400.....",".....011111111111111111104455440.....",".....001111111111111111105454440.....",".....001111111111111111105454400.....","......0011111111111111115511440......","........0011111111111105555600.......","..........00011111110555550000.......","..........000000011550000000.........",".............00077755000000..........","............009999999900.............","...........00989999888800............","...........098888888888800...........","..........0098888888888880...........","..........0008888888888880...........","..........00088888888888800..........",".........000088888888988880..........",".........0000888888880888800.........",".........0000888888880988800.........",".........0000888888889998800.........",".........00008888888890777700........",".........0000c999999990544400........","..........000cbbbb77cc0054500........","...........00ccbcbbbbcc00000.........","...........00cccc0bbbbcc000..........","...........00bbcc00cbbbc00...........","...........00bbc0000bbbb00...........","...........00cbc0d00bbbb00...........","...........00ddc0d00bbbc00...........","...........0edde0000cccc000..........","...........0ed000000aaeed00..........","...........000000.0eeaeede0..........","...................0000000..........."],"N":[".....................................","....................00...............","..........000000...00200.............","..........02222200.002200...00.......","..........0022333200022300.0000......","...........02233333011232000220......",".....000000002233333222222002200.....","....0222222211233223222222112200.....","....0122223322223222222222222220.....","....0012222333322222222222222200.....","......0122233332222222222222220000...","....0001222333333223222323333222200..","...00022223222333233222233233222220..","..0022222222223323322232332232222200.",".002222222222322333233322322222211100","0011122222222222332223222322222220000","00001222222222222222222222222222100..","00001222222222222222222222222222220..","...022222222222222222222222222222200.","..0021122222222222222222222222121111.","..02111222222222222222222222121111100","..00011111222222222222222222121110000","..0001111222122222222222122112111000.","....011111211122222222211211111110...","....011111121122222212111111111100...","....001111111112222212111111111000...","...0000111111111111111111111111000...","..004601111111111111111111111104400..","..004551111111111111111111111104400..","..004660111111111111111111111055500..","..00065511111111111111111111055450...","...000500111111111111111111055550....",".....000060111111111111111550000.....","........00055511111111155500.........","..........00000001100000000..........","............000055557000.............","...........00999777779900............","..........0888899999988880...........",".........088888888888888880..........","........00888888888888889800.........","........00888888888888887880.........","........088188888888888878800........",".......00890888888888888008800.......",".......08890888888888888098800.......",".......08909888888888888909800.......","......009909888888888888809900.......","......047709888888888888907740.......","......044509999999999999900540.......","......06500cccccccccccccc05550.......",".......0000cbbbbbbbbbbbbc0000........","..........0bbbbbbccbbbcbc00..........","..........0bbbccc000ccbbb0...........","..........0bbbbc0..0cbbbb0...........","..........0bbbbc0..0cbbbb0...........",".........00cbbbc0..00bbbc00..........","........00dabbcc0..00ccce000.........","........00eadade0..0eaaaee00.........",".........0e0dade0..000daee00.........","..........000000....0000000.........."],"NW":["..............000....00.............","..............0000...000............","..............02200..0200...........","......000000..022220.01200..........","......022220000122220022200.000.....","......002222211122222112220.020.....",".......022222222122222222200220.....","..000000012222222222222222202200....","..022222011222222222222222212200....","..001222222222222222211222222200....","...01122223323322222222221222100....","...001122222222222222222222222000...","..00222222233222222222222222222100..",".0222222222222222222222223322333200.","00111222222222222222222222232322222.","011112222222222222222222222222221120","000012222222222222222222222222221000","...02212222222222222222222222222000.","..022122212222222222222222222222200.","..021022112212222222222222222222220.","..0210021112122222222222222222222200","..0005121112212212222222222222211110","...005011111111221222222222212210000","....0401111111112111221122211111000.","....00110001111111112221221111110...","....00410411111111111211121111110...","....00405440111111111111111111100...","....04405445011111111111111111000...","....044474550111111111111111110.....","....044474551111111111111111100.....","....00447750111111111111111100......",".....005555651111111111111100.......","......0005655500111111110000........",".......0000000551111000000..........",".........000007777770000............","............0999997790..............","...........088889999890.............","..........08888888888900............","..........08888888888800............",".........008887888888800............",".........088887888888800............",".........0888878888888090...........","........00888008888888090...........","........08888008888888090...........","........08888008888888000...........",".......047770098888889040...........",".......04445009999990c050...........",".......046400cc99bbbcc00............",".......000000ccbbbcccc0.............","........000ccbbbc00ccc0.............","..........0ccbbbc00ccb0.............","..........0bbbbb00ccbb0.............","..........0bbbbb000cbc00............",".........00ccbbb00eccd00............","........00debbbb00eeee00............","........0ddeaaad0000d000............","........0eeeeeae0000000.............","........000000000..................."],"W":[".................00................",".................00................","........0000000..020...............","........002233000022000.00.........","........0022332300222000000........",".....00000122333211222200200.......","....0000000122332222222202320......","..0023333221222222222222122200.....","..0211233322223322222222222220.....","..0001222333333222222222222200.....","....001222332233222222222222100....","..0002222222333233322222222220000..","..0222222223332233322222222232200..",".022222222222223332332322333232220.","02222222222222233222223322332222200","01112222002222222222222322222221120","00002210552221222222222322222221000","..0021055522022222222222222222220..","..02105566025122221222222222222220.","..01105444005212221122222222222220.","..010044314402112211222222221121110","..000044643443022211112222222121110","...00044444445511111111212221111000","....00444444444011111111111111100..","....00440044444011111111111111100..","....00440044444011000111111111100..","....00440044444010444011111111100..","....0044004444401055440111111000...","....00444466644404554401111110.....","....00444466644444564501111000.....","....0044446664444444001111100......",".....00424444444400001111000.......","......00444444455111110000.........","........00444555570000000..........","........00000005570000.............",".............0777990...............","............097999990..............","...........0088888880..............","...........0888888880..............","..........00a89888980..............","..........00a708888880.............","..........0aa708888080.............",".........00aa808888080.............",".........00a8808888080.............",".........0088008889080.............",".........0088099880980.............",".........0080077790990.............",".........0090044450990.............",".........00b0034450cc0.............","..........0bb00550ccc0.............","...........0bc000ccc0..............","...........00bbccb000..............","...........00bbbbb000..............","...........00bbbbb000..............","...........00bbbbb0000.............","..........0000ccbc00e0.............","..........00aaeccd00e0.............","..........0dddaadee000.............","..........0dddaeee00...............","..........000000000................"],"SW":["...............0000...................","...............00300...00.............",".......00000...0023300.020............","......0000000000023320.02320..........","......00222322001123320023220.........",".......00222322222222220122200........",".......00222322222222222122220........",".00000000022333222222222222220........",".002332222222222222222222222100000....",".0011222233222222222222222222222200...","..0011223322332222222222222222322200..","...0012332233223323333222233222221200.","..00223222222233223323232233222111100.",".00222322222223222322223223322221000..","00022222212222222222222322232222200...","001112211522222112221222232222222200..","0000221156022210012212222222222222200.","...02105555122005012222222222222222200","..002105444122055512222012222222221100","..021004444450044440050012222112111100","..011001244444444444445012211111110000","..00000444444444422244661211111111000.","...00004444444444442444411111111110...","....0004044444444444444411111111110...",".....000044444444004444401111111100...",".....000044444444004444401100011100...",".....00004444444400444441100440100....",".....00404466444400464441107540000....",".....0666446644440066444404754000.....",".....066444444444466664444455400......","......0044434444446664445444450.......","......0004447774444444455000000.......",".......0004444444444446600000.........",".........000444444555500000...........","...........0000077777000..............",".............090555799900.............","............00999999998890............","...........0088999988888800...........","...........0988888888888880...........","..........090aa88aa889888890..........","..........070aaaaaa889088880..........",".........0070aaaaaa8880888800.........",".........0800aaaaaa8880988880.........","........008088aaaa88889088880.........","........0000888aa8888890888800........","........0040888888888890077440........","........0050778888888990044440........","........0050c77999999990654440........","..........00cbbbbbbbbccc085500........","...........0bbcbbbbbbbbcc0000.........","...........0bbbcc00bbbbbc0............","...........0bbbcc00bbbbbc0............","...........0bbbcc0d0bbbbc0............","..........00ecbbc0d0bbbbc0............",".........0eeeeeee000cccbbc0...........",".........0dddeeee000dddcce0...........",".........0000000000daaddee0...........","..........00000...0ddaad000...........","..................00000000............"]}},"cat":{"names":["outline","body","bodyShade","eye","nose"],"palette":["#0c0910","#fcecd3","#eacfa9","#fbf9f4","#f0605d"],"frames":{"S":["..........................................",".........0.....................00.........","........000...................0100........","........0100.................00100........",".......001100...............001120........",".......0211100.............00112200.......",".......01121100...........001122200.......",".......0112110000000000000001122200.......","......00112211000000000000011222110.......","......00112211111111111111111122120.......","......001111111111111111111111111200......","......021111111111111111111111111200......","......011111111111111111111101111100......","......011111111111111111110000011120......","......011110000111111111103333301120......","......0111033330011111110333033001100.....",".....00110333333011111130330003301120.....",".....01110330003001111130300003301120.....",".....01110330000001111110330003301120.....",".....01130330003001111110333333011120.....",".....011303330330010441110033300111200....","....00111103333301104411110000111111200...","..00021111000000111111111111111111111000..",".0001111111100101111011100011111111111100.","000111111111111000000000001111111111111100","001111111111111111001100111111111122211200","00222221111111111110110111111111112200000.",".000000111111111111000011111111112000000..","......021111111111110011111111112200......","......001111111111111111111111111200......","......00111111111111111111111122220.......",".......0111111111111111111111212200.......",".......0111111111111111111111222200.......",".......0012222222211111112222222200.......",".......001122000000000000000022220........","........0012200.............022200........","........001120..............021200........",".........02200..............00220.........",".........0000................000.........."],"SE":["............................0.......","...........................0000.....","........000...............00100.....","........0120.............001100.....",".......001110...........0011210.....",".......0111100.........00111210.....",".......01121100..000000021122200....","......00112211000000000011122200....",".....001112221001111111111112200....",".....001112221111111111111111100....",".....001112111111111111111111100....",".....021111111111111111111111110....","....00111111111111111111111111100...","....01111111111111111111111110000...","...001111111111111111111111000000...","...001111111111000001111111033300...","...0111111111103333001111100300000..","...0111111111033330001111100300000..","...0111111111033300001111103300000..","..00111111111033000003111100300000..","..00111111111033000303110110330000..","..01111111111033333301144411000000..","..02211111111103333011100011111100..","..001111111111100001111111110111000.","..0011111111111111101110000001110000",".00111111111111111100000000111110000","00111111111111111111110110011111000.","0011111221111111111111001011111100..","002222002111111111111110001111100...",".00000022111111111111111111111100...","...00222111111111111111111111120....","....022211111111111111111111120.....","....002211111111111111111111200.....",".....0022111111111111111122220......",".....0002211111221111222022200......",".....0200211112000000000022200......",".....0000221110000000..002220.......","......0000211100.......000000.......",".........021120..........000........",".........000000.....................","..........0000......................"],"E":["..........................","..........00......00......",".........0010....0000.....","........001100..00120.....","........011120..00120.....",".......00111100001110.....",".......011111000111100....",".......011111101111100....","......0011111121111200....",".....00111111111111100....",".....001111111111111100...","....0011111111111111100...","...001111111111111111100..","...001111111111111110010..","...011111111111111100000..","..00111111111111110333300.","..02111111111111100330000.",".001111111111111103300000.",".001111111111111103300000.",".001111111111111100330000.",".0011111111111111100333000","00111111111111111110000000","00111111121111111111001100","00111112211111111111110000","00111110011111111111111000","0011110011111111111111110.","0011110011111211111111110.","0011110011120211111111100.",".001110021200111111111100.",".00111100002111111111110..",".00111112221111111111100..","..001111111111111111120...","...00211111111111111000...","...0002221111111222000....","...000000211111000000.....","...002000011110000220.....","....000.00211100..000.....",".........021110...........",".........002220...........","..........0000............"],"NE":["......................000............",".........000.........00000...........","........00200........00100...........","........001200......001100...........","........011100......0111100..........",".......00111100....00111100..........",".......00111120000001111120..........",".......021111111100011111100.........",".......011111111111111111100.........",".......0111111111111111111200........","......001111111111111111111200.......","......021111111111111111111120.......","......0111111111111111111111120......",".....001111111111111111111111200.....",".....001111111111111111111111000.....",".....001111111111111111111111030.....","....0021111111111111111111111030.....","....0011111111111111111111111030.....","....0011111111111111111111111000.....","....00111111111111111111111111000....","....00111111111111111111111111200....","..00011111111111111111111111111200...",".0001111111111111111111111111111200..","000111111111111111111111111111111100.","0011121111111111111111111111111111100","0022221111111111111111111111111111100",".000000111111111111111111111222222000",".....001111111111111111111112000000..","......02111111111111111111111220.....","......02211111111111111111111220.....","......00211111111111111111122220.....",".......0222111111111111111112200.....",".......002222211111111122112220......",".......002222222222222222222220......","........02222000000000002222200......","........0022200........0022220.......","........002200.........0022220.......",".........00000..........002200.......",".........................0000........"],"N":[".........000...................00..........",".........0000.................0000.........","........00100................00110.........","........001100...............011100........","........0111100.............0011120........",".......00111120............00111120........",".......0011111200000000000002111110........",".......02111112000110000000011111120.......",".......01111111111111111111111111120.......",".......01111111111111111111111111120.......","......001111111111111111111111111120.......","......0211111111111111111111111111100......","......0111111111111111111111111111100......","......0111111111111111111111111111100......",".....00111111111111111111111111111110......",".....021111111111111111111111111111100.....",".....021111111111111111111111111111100.....",".....011111111111111111111111111111100.....",".....011111111111111111111111111111100.....",".....011111111111111111111111111111100.....","....00111111111111111111111111111111100....","..000111111111111111111111111111111111000..",".00011111111111111111111111111111111111000.","0001111111111111111111111111111111111111000","0011111111111111111111111111111111111111100","0021122111111111111111111111111111112111200",".00000011111111111111111111111111111000000.","..000001111111111111111111111111111000000..","......0211111111111111111111111111100......","......0011111111111111111111111111200......",".......01111111111111111111111111120.......",".......00111111111111111111111111200.......",".......00111111111111111111111111200.......",".......0021112000000000000002111120........","........001112000000000000000211200........","........0011120.............021120.........",".........021100.............002220.........",".........002200.............002200.........","..........0000...............0000.........."],"NW":["....................................","............000..........00.........","...........00100........0000........","...........01110.......001100.......","..........0011100.....0011120.......","..........0011110.....0011110.......",".........00111110000000111110.......",".........001111100000001111100......",".........001111112111111111100......","........0011111111111111111100......",".......00111111111111111111120......","......0011111111111111111111100.....","......0011111111111111111111100.....",".....00111111111111111111111120.....",".....00111111111111111111111100.....","....0001111111111111111111111100....","....0000111111111111111111111100....","....0000111111111111111111111120....","....0001111111111111111111111120....","....0001111111111111111111111120....","....00111111111111111111111111200...","...0001111111111111111111111111200..","..001111111111111111111111111122000.",".00111111111111111111111111111222200","001111111111111111111111111112222200","001111111111111111111111111112222200","00211122111111111111111111111200000.",".0000022211111111111111111112200....","..00000211111111111111111112200.....","....002111111111111111111112200.....","....00211111111111111111112220......",".....0211111111111111111222200......",".....002111111111111212222220.......",".....002111122222222222222220.......","......02112200000000000222200.......","......0011220000000...0222200.......","......0011220.........002200........",".......02220...........0000.........","........0000........................"],"W":["..........................",".......00......000........","......0000....00110.......","......01100...01110.......","......011000.0011100......",".....0011100.0111100......",".....001112000111110......",".....0011111011111100.....",".....0011111211111100.....","....00111111111111100.....","...0011111111111111100....","...0011111111111111120....","..001111111111111111100...","..000011111111111111110...","..0030011111111111111100..",".00333301111111111111100..",".00003300111111111111120..",".000033001111111111111100.",".000033301111111111111100.",".000033001111111111111100.","00003330111111111111111200","00003301111111111111111200","00100011111111112111111100","00001111111111111221111100","00011111111111111001111100",".0111111111111111100111100",".0111111111121111100111100",".0011111111100211100111200",".001111111111000120011120.","..01111111111120000111200.","..00111111111111211112200.","..0011111111111111112100..","...00211111111111122220...","....0002222111111222000...","....0000000111112000000...","....00200000111200.0200...",".....000..00111200..000...","..........0011220.........","...........021200.........","...........00000.........."],"SW":["........00..............................",".......0000..................00.........",".......01200................0020........",".......011200..............001200.......","......0011120.............0011120.......","......00121100............0112120.......","......0022211000000......00122120.......",".....00122211200000000000011221200......",".....00122211111111111000112221200......",".....00111111111111111111111221200......",".....00111111111111111111111111220......",".....01111111111111111111111111220......",".....011111111111111111111111111200.....",".....011000001111111111000111111200.....",".....010033300111111100000011111100.....","....0000333330111111103333301111120.....","....0103300030111111033003330111120.....","....01033000301111110300033301111200....","....03033003301111110300033301111200....","....03303333301101110330033301111200....","...001100030011444111033333011111200....","..000111100011100011100333001111112000..",".00121111111111111111110001111111111000.","0011211111100000001100011111111111111000","0211211111113300000000111111111111111120","0022211111111100110111111111111112222220",".00000111111111010011111111111122000000.",".....011111111100011111111111112200000..",".....011111111111111111111111112200.....",".....00111111111111111111111112220......","......0011111111111111111111122200......","......0011111111111111111112222200......","......001122221111111111111222220.......",".......02122000000001222222222200.......",".......0012200000000000000222220........",".......0011200...........0112220........","........00000............0222200........",".........0000.............02220.........","..........................0000.........."]}}};
/* ===== Character engine built on the original sprites =====
   Every character starts from the hand-drawn sheet (palette-role grids, 8 directions).
   Variations are pixel edits on those grids, then roles are mapped to colours. */
const DIRS = ['S','SE','E','NE','N','NW','W','SW'];
const DIR_LABEL = { S:'SOUTH', SE:'SOUTH_EAST', E:'EAST', NE:'NORTH_EAST', N:'NORTH', NW:'NORTH_WEST', W:'WEST', SW:'SOUTH_WEST' };
const FRONT = { S:1, SE:1, SW:1 }, BACK = { N:1, NE:1, NW:1 }, SIDE = { E:1, W:-1 };
const FACING = { S:0, SE:1, E:1, NE:1, N:0, NW:-1, W:-1, SW:-1 };   // which way the nose points on screen

/* ---------- roles ---------- */
const RL = ['outline','hairDark','hair','hairLight','skin','skinShade','blush','mouth','top','topDark','emblem','bottom','bottomDark','shoe','shoeShade',
  'legSkin','legSkinShade','hat','hatDark','white','inner','body','bodyShade','eye','nose','pattern','tongue','mouthDark','pumpkin','pumpkinDark',
  'petal','petalShade','center','leaf','leafDark','stem','cap','capDark','cheek','earInner','hatLight','capSpot','centerDark'];
const R = Object.fromEntries(RL.map((n, i) => [n, i]));
const HAIR = new Set([R.hairDark, R.hair, R.hairLight]);
const SKIN = new Set([R.skin, R.skinShade, R.blush, R.mouth]);
const TOPS = new Set([R.top, R.topDark]);
const LEGS = new Set([R.bottom, R.bottomDark, R.shoe, R.shoeShade, R.legSkin, R.legSkinShade]);
const BODY = new Set([R.body, R.bodyShade, R.pattern]);

/* ---------- colour ---------- */
const hex2rgb = h => [parseInt(h.slice(1,3),16), parseInt(h.slice(3,5),16), parseInt(h.slice(5,7),16)];
const rgb2hex = c => '#' + c.map(v => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2,'0')).join('');
function rgb2hsl([r,g,b]) { r/=255; g/=255; b/=255; const mx=Math.max(r,g,b), mn=Math.min(r,g,b); let h=0,s=0; const l=(mx+mn)/2; if (mx!==mn) { const d=mx-mn; s = l>.5 ? d/(2-mx-mn) : d/(mx+mn); h = mx===r ? (g-b)/d+(g<b?6:0) : mx===g ? (b-r)/d+2 : (r-g)/d+4; h/=6; } return [h,s,l]; }
function hsl2rgb([h,s,l]) { const f = n => { const k=(n+h*12)%12, a=s*Math.min(l,1-l); return 255*(l - a*Math.max(-1, Math.min(k-3, 9-k, 1))); }; return [f(0), f(8), f(4)]; }
const clamp = (v,a,b) => Math.max(a, Math.min(b, v));
/* derive a shade of `newBase` that relates to it the way `origShade` related to `origBase` in the sheet */
function relShade(origBase, origShade, newBase) {
  const o = rgb2hsl(hex2rgb(origBase)), m = rgb2hsl(hex2rgb(origShade)), n = rgb2hsl(hex2rgb(newBase));
  let dh = m[0] - o[0]; if (dh > .5) dh -= 1; if (dh < -.5) dh += 1;
  const sr = o[1] > .02 ? m[1] / o[1] : 1, dl = m[2] - o[2];
  const nl = n[2] < .25 && dl < 0 ? n[2] + dl * .45 : n[2] > .9 && dl < 0 ? n[2] + dl * 1.0 : n[2] + dl;
  return rgb2hex(hsl2rgb([(n[0] + dh + 1) % 1, clamp(n[1] * sr + (n[1] < 0.05 ? m[1] * 0.3 : 0), 0, 1), clamp(nl, 0.04, 0.98)]));
}
const shade = (hex, dl, ds = 0) => { const [h,s,l] = rgb2hsl(hex2rgb(hex)); return rgb2hex(hsl2rgb([h, clamp(s + ds, 0, 1), clamp(l + dl, 0.03, 0.97)])); };
const OUT = '#16101a';
const ORIG = { hair:'#834f40', hairDark:'#603c38', hairLight:'#a5664a', skin:'#fdc58d', skinShade:'#ed9462', blush:'#fba17b', mouth:'#a2413a',
  top:'#d1262b', topDark:'#a31c2c', heart:'#fcefd4', bottom:'#4d78b8', bottomDark:'#364e9d', shoe:'#faf8f0', shoeShade:'#b2afb8',
  body:'#fcecd3', bodyShade:'#eacfa9', eye:'#fbf9f4', nose:'#f0605d' };

function paletteFor(rec) {
  const P = new Array(RL.length).fill('#ff00ff');
  P[R.outline] = OUT; P[R.white] = '#fffdf6'; P[R.mouthDark] = '#5a1f24'; P[R.tongue] = '#f0707a';
  P[R.pumpkin] = '#f6a43a'; P[R.pumpkinDark] = '#d9761c'; P[R.petal] = '#fffdf6'; P[R.petalShade] = '#e3ddcf'; P[R.center] = '#f4c430'; P[R.centerDark] = '#d99b14';
  P[R.leaf] = '#6fc35f'; P[R.leafDark] = '#4f9a49'; P[R.stem] = '#7d8c3c'; P[R.cap] = '#d9443a'; P[R.capDark] = '#a8302c'; P[R.capSpot] = '#fff6e6';
  P[R.cheek] = '#f6a091'; P[R.eye] = ORIG.eye;
  if (rec.kind === 'human') {
    const hc = rec.hairColor, sk = rec.skin, tp = rec.topColor, bt = rec.bottomColor, sh = rec.shoeColor, ht = rec.hatColor;
    P[R.hair] = hc; P[R.hairDark] = relShade(ORIG.hair, ORIG.hairDark, hc); P[R.hairLight] = relShade(ORIG.hair, ORIG.hairLight, hc);
    P[R.skin] = sk; P[R.skinShade] = relShade(ORIG.skin, ORIG.skinShade, sk);
    P[R.blush] = rec.blush ? relShade(ORIG.skin, ORIG.blush, sk) : sk; P[R.mouth] = relShade(ORIG.skin, ORIG.mouth, sk);
    P[R.legSkin] = sk; P[R.legSkinShade] = P[R.skinShade];
    P[R.top] = tp; P[R.topDark] = relShade(ORIG.top, ORIG.topDark, tp);
    P[R.emblem] = rec.emblemColor; P[R.inner] = rec.emblemColor;
    P[R.bottom] = bt; P[R.bottomDark] = relShade(ORIG.bottom, ORIG.bottomDark, bt);
    P[R.shoe] = sh; P[R.shoeShade] = relShade(ORIG.shoe, ORIG.shoeShade, sh);
    P[R.hat] = ht; P[R.hatDark] = shade(ht, -0.12, 0.03); P[R.hatLight] = shade(ht, 0.1);
  } else {
    const bc = rec.color;
    P[R.body] = bc; P[R.bodyShade] = relShade(ORIG.body, ORIG.bodyShade, bc);
    P[R.pattern] = rec.patternColor; P[R.nose] = ORIG.nose; P[R.earInner] = relShade(ORIG.body, ORIG.bodyShade, bc);
  }
  return P;
}

/* ---------- grids & masks ---------- */
class G {
  constructor(w, h, px) { this.w = w; this.h = h; this.px = px || new Int16Array(w * h).fill(-1); }
  get(x, y) { return x < 0 || y < 0 || x >= this.w || y >= this.h ? -1 : this.px[y * this.w + x]; }
  set(x, y, v) { x = Math.round(x); y = Math.round(y); if (x >= 0 && y >= 0 && x < this.w && y < this.h) this.px[y * this.w + x] = v; }
  clone() { return new G(this.w, this.h, this.px.slice()); }
}
const N4 = [[1,0],[-1,0],[0,1],[0,-1]], N8 = [[1,0],[-1,0],[0,1],[0,-1],[1,1],[1,-1],[-1,1],[-1,-1]];
function maskOf(g, fn) { const m = new Uint8Array(g.w * g.h); for (let y = 0; y < g.h; y++) for (let x = 0; x < g.w; x++) if (fn(g.px[y*g.w+x], x, y)) m[y*g.w+x] = 1; return m; }
function morph(m, w, h, r, grow) {
  const out = new Uint8Array(w * h), offs = [];
  for (let dy = -Math.ceil(r); dy <= Math.ceil(r); dy++) for (let dx = -Math.ceil(r); dx <= Math.ceil(r); dx++) if (dx*dx + dy*dy <= r*r + 0.01) offs.push([dx, dy]);
  for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
    let hit = grow ? 0 : 1;
    for (const [dx, dy] of offs) { const nx = x + dx, ny = y + dy; const v = nx < 0 || ny < 0 || nx >= w || ny >= h ? 0 : m[ny*w+nx]; if (grow && v) { hit = 1; break; } if (!grow && !v) { hit = 0; break; } }
    out[y*w+x] = hit;
  }
  return out;
}
const dilate = (m, w, h, r) => morph(m, w, h, r, true);
const erode = (m, w, h, r) => morph(m, w, h, r, false);
const mAnd = (a, b) => a.map((v, i) => v & b[i]);
const mOr = (a, b) => a.map((v, i) => v | b[i]);
const mSub = (a, b) => a.map((v, i) => v & (b[i] ^ 1));
function bbox(m, w, h) { let x0 = 1e9, y0 = 1e9, x1 = -1, y1 = -1; for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) if (m[y*w+x]) { x0 = Math.min(x0, x); x1 = Math.max(x1, x); y0 = Math.min(y0, y); y1 = Math.max(y1, y); } return { x0, y0, x1, y1, w: x1 - x0 + 1, h: y1 - y0 + 1, cx: (x0 + x1) / 2, cy: (y0 + y1) / 2 }; }
function comps(m, w, h) {
  const lab = new Int32Array(w * h), out = []; let k = 0;
  for (let i = 0; i < w * h; i++) {
    if (!m[i] || lab[i]) continue; k++; const cells = [], st = [i]; lab[i] = k;
    while (st.length) { const j = st.pop(); cells.push(j); const x = j % w, y = (j / w) | 0; for (const [dx, dy] of N4) { const nx = x + dx, ny = y + dy; if (nx < 0 || ny < 0 || nx >= w || ny >= h) continue; const q = ny*w+nx; if (m[q] && !lab[q]) { lab[q] = k; st.push(q); } } }
    out.push(cells);
  }
  return out;
}
/* shape rasteriser (grid coordinates, pixel centres) */
function inside(s, px, py) {
  switch (s.t) {
    case 'e': { const dx = (px - s.cx) / s.rx, dy = (py - s.cy) / s.ry; return dx*dx + dy*dy <= 1; }
    case 'r': { if (px < s.x0 || px > s.x1 || py < s.y0 || py > s.y1) return false; const r = Math.min(s.r || 0, (s.x1 - s.x0) / 2, (s.y1 - s.y0) / 2); const qx = Math.max(s.x0 + r - px, 0, px - (s.x1 - r)), qy = Math.max(s.y0 + r - py, 0, py - (s.y1 - r)); return qx*qx + qy*qy <= r*r + 1e-6; }
    case 'p': { let c = false; const p = s.pts; for (let i = 0, j = p.length - 1; i < p.length; j = i++) if (((p[i][1] > py) !== (p[j][1] > py)) && (px < (p[j][0] - p[i][0]) * (py - p[i][1]) / (p[j][1] - p[i][1]) + p[i][0])) c = !c; return c; }
    case 'c': { const vx = s.x1 - s.x0, vy = s.y1 - s.y0, L = vx*vx + vy*vy; let t = L ? ((px - s.x0) * vx + (py - s.y0) * vy) / L : 0; t = clamp(t, 0, 1); const dx = px - (s.x0 + vx*t), dy = py - (s.y0 + vy*t); return dx*dx + dy*dy <= s.r*s.r; }
    case 'below': return py > s.y;
    case 'above': return py < s.y;
  }
  return false;
}
function raster(w, h, shapes) {
  const m = new Uint8Array(w * h);
  for (const s of shapes) { if (!s) continue; const v = s.op === 'sub' ? 0 : 1; for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) if (inside(s, x + .5, y + .5)) m[y*w+x] = v; }
  return m;
}
const Ell = (cx, cy, rx, ry, op) => ({ t:'e', cx, cy, rx, ry: ry ?? rx, op });
const Rect = (x0, y0, x1, y1, r, op) => ({ t:'r', x0, y0, x1, y1, r, op });
const Poly = (pts, op) => ({ t:'p', pts, op });
const Line = (x0, y0, x1, y1, r) => ({ t:'c', x0, y0, x1, y1, r });

/* paint a mask onto a grid with a role function and an outline ring.
   mode 'over' paints everywhere; 'behind' only on empty pixels. */
function paint(g, m, roleAt, mode = 'over', ring = true, ringProtect) {
  const w = g.w, h = g.h, put = new Uint8Array(w * h);
  for (let i = 0; i < w * h; i++) {
    if (!m[i]) continue;
    if (mode === 'behind' && g.px[i] >= 0) continue;
    put[i] = 1;
  }
  if (ring) for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
    const i = y*w+x; if (m[i]) continue;
    let adj = false; for (const [dx, dy] of N4) { const nx = x + dx, ny = y + dy; if (nx >= 0 && ny >= 0 && nx < w && ny < h && put[ny*w+nx]) adj = true; }
    if (!adj) continue;
    if (mode === 'behind' && g.px[i] >= 0) continue;
    if (ringProtect && ringProtect(g.px[i], x, y)) continue;
    g.px[i] = R.outline;
  }
  for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) { const i = y*w+x; if (put[i]) g.px[i] = roleAt(x, y, m); }
}
/* turn silhouette-edge pixels into outline and drop outline pixels that float on their own */
function reoutline(g, rows) {
  const w = g.w, h = g.h, [ya, yb] = rows || [0, h - 1];
  for (let pass = 0; pass < 2; pass++) for (let y = ya; y <= yb; y++) for (let x = 0; x < w; x++) {
    const v = g.get(x, y); if (v < 0 || v === R.outline) continue;
    if (N4.some(([dx, dy]) => g.get(x + dx, y + dy) < 0)) g.set(x, y, R.outline);
  }
  for (let y = ya; y <= yb; y++) for (let x = 0; x < w; x++) {
    if (g.get(x, y) !== R.outline) continue;
    if (!N4.some(([dx, dy]) => g.get(x + dx, y + dy) < 0)) continue;
    if (!N8.some(([dx, dy]) => { const v = g.get(x + dx, y + dy); return v >= 0 && v !== R.outline; })) g.set(x, y, -1);
  }
}
const hairTex = (x, y, m, w) => {   // falling strands in the sheet's three hair tones, darker underside and right edge
  const at = (xx, yy) => xx >= 0 && yy >= 0 && xx < w && yy * w + xx < m.length && m[yy * w + xx];
  if (!at(x, y + 1) || !at(x, y + 2) && (x % 2)) return R.hairDark;
  if (!at(x + 1, y)) return R.hairDark;
  if (!at(x, y - 1) && !at(x - 1, y)) return R.hairLight;
  const c = (x + Math.floor(y / 6)) % 5;
  return c === 0 ? R.hairLight : c === 3 ? R.hairDark : R.hair;
};
const jagged = (m, w, h) => {   // strand tips along the bottom edge of a hair panel
  for (let x = 0; x < w; x++) { let yb = -1; for (let y = h - 1; y >= 0; y--) if (m[y * w + x]) { yb = y; break; } if (yb < 0) continue; if (x % 3 === 1) m[yb * w + x] = 0; if (x % 3 === 1 && yb > 0) {} }
  return m;
};

/* ---------- base sprites ---------- */
let BASE = null;
function loadBase(data) {
  const mapBoy = [R.outline, R.hairDark, R.hair, R.hairLight, R.skin, R.skinShade, R.blush, R.mouth, R.top, R.topDark, R.emblem, R.bottom, R.bottomDark, R.shoe, R.shoeShade];
  const mapCat = [R.outline, R.body, R.bodyShade, R.eye, R.nose];
  BASE = { boy: {}, cat: {} };
  for (const [k, map] of [['boy', mapBoy], ['cat', mapCat]]) for (const dir of DIRS) {
    const rows = data[k].frames[dir], h = rows.length, w = rows[0].length, g = new G(w, h);
    for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) { const ch = rows[y][x]; g.px[y*w+x] = ch === '.' ? -1 : map[parseInt(ch, 16)]; }
    BASE[k][dir] = g;
  }
}

/* ================================ HUMAN ================================ */
const HL = {};   // landmarks per direction (from the untouched sheet)
function humanLandmarks(dir) {
  if (HL[dir]) return HL[dir];
  const g = BASE.boy[dir], w = g.w, h = g.h;
  let shoulder = 0; for (let y = 0; y < h; y++) { let n = 0; for (let x = 0; x < w; x++) if (TOPS.has(g.get(x, y))) n++; if (n >= 2) { shoulder = y; break; } }
  let hip = h - 8; for (let y = shoulder; y < h; y++) { let n = 0; for (let x = 0; x < w; x++) if (g.get(x, y) === R.bottom || g.get(x, y) === R.bottomDark) n++; if (n >= 3) { hip = y; break; } }
  let shoeTop = h - 3; for (let y = hip; y < h; y++) { let n = 0; for (let x = 0; x < w; x++) if (g.get(x, y) === R.shoe || g.get(x, y) === R.shoeShade) n++; if (n >= 2) { shoeTop = y; break; } }
  const headReg = maskOf(g, (v, x, y) => v >= 0 && y < shoulder);
  const blob = dilate(erode(headReg, w, h, 3), w, h, 3);
  let skull = erode(blob, w, h, 1.5);
  const hairM = maskOf(g, v => HAIR.has(v));
  // eyes: small outline islands surrounded by skin
  const eyes = [];
  const outl = maskOf(g, (v, x, y) => v === R.outline && y < shoulder);
  for (const cells of comps(outl, w, h)) {
    if (cells.length > 16) continue;
    let ok = true, skinN = 0;
    const set = new Set(cells);
    for (const j of cells) { const x = j % w, y = (j / w) | 0; for (const [dx, dy] of N4) { const q = (y + dy) * w + x + dx; if (set.has(q)) continue; const v = g.get(x + dx, y + dy); if (v === R.skin || v === R.skinShade || v === R.blush) skinN++; else if (!HAIR.has(v)) ok = false; } }
    const ys = cells.map(j => (j / w) | 0); if (!ok || skinN < 3 || Math.max(...ys) - Math.min(...ys) < 1) continue;
    const xs = cells.map(j => j % w);
    eyes.push({ cells, x0: Math.min(...xs), x1: Math.max(...xs), y0: Math.min(...ys), y1: Math.max(...ys) });
  }
  // keep the real eyes: the biggest island and anything level with it (max two)
  eyes.sort((a, b) => b.cells.length - a.cells.length);
  if (eyes.length) { const y0 = (eyes[0].y0 + eyes[0].y1) / 2; const keep = eyes.filter(e => Math.abs((e.y0 + e.y1) / 2 - y0) <= 2 && e.cells.length >= 3).slice(0, 2); eyes.length = 0; eyes.push(...keep); }
  eyes.sort((a, b) => a.x0 - b.x0);
  const eyeMask = new Uint8Array(w * h); for (const e of eyes) for (const j of e.cells) eyeMask[j] = 1;
  const face = maskOf(g, (v, x, y) => y < shoulder && (SKIN.has(v) || eyeMask[y*w+x]));
  // the skull always contains the whole face (ears aside)
  skull = mOr(skull, mAnd(dilate(skull, w, h, 2), face));
  const sb = bbox(skull, w, h);
  // mouth: the lowest cluster of mouth-coloured pixels below the eyes
  const mouthAll = maskOf(g, (v, x, y) => v === R.mouth && y < shoulder);
  const mouthM = new Uint8Array(w * h);
  const eyeBottom = eyes.length ? Math.max(...eyes.map(e => e.y1)) : 0;
  let bestC = null; for (const c of comps(mouthAll, w, h)) { const my = c.reduce((a, j) => a + ((j / w) | 0), 0) / c.length; if (my < eyeBottom) continue; if (!bestC || my > bestC.my) bestC = { c, my }; }
  if (bestC) for (const j of bestC.c) mouthM[j] = 1;
  const mb = bbox(mouthM, w, h);
  const em = maskOf(g, v => v === R.emblem), eb = bbox(em, w, h);
  let chin = shoulder - 1;
  const eyeRow = eyes.length ? Math.round(eyes.reduce((a, e) => a + e.y0, 0) / eyes.length) : Math.round(sb.y0 + sb.h * 0.55);
  // torso centre from the hip row
  let bx = []; for (let x = 0; x < w; x++) if (g.get(x, hip) === R.bottom || g.get(x, hip) === R.bottomDark) bx.push(x);
  const bodyCx = bx.length ? (Math.min(...bx) + Math.max(...bx)) / 2 : w / 2;
  HL[dir] = { shoulder, hip, shoeTop, skull, sb, blob, hairM, eyes, eyeMask, face, mouth: mouthM.some(v => v) ? mb : null, emblem: em.some(v => v) ? eb : null, chin, eyeRow, bodyCx, coreL: bx.length ? Math.min(...bx) : 0, coreR: bx.length ? Math.max(...bx) : w - 1 };
  return HL[dir];
}

const BALD = {};
function baldHead(dir) {
  if (BALD[dir]) return BALD[dir].clone();
  const base = BASE.boy[dir], L = humanLandmarks(dir), g = base.clone(), w = g.w;
  const nearHair = (x, y) => N8.some(([dx, dy]) => HAIR.has(base.get(x + dx, y + dy)));
  const nearSkinOut = (x, y) => N8.some(([dx, dy]) => { const v = base.get(x + dx, y + dy); return SKIN.has(v) && !L.skull[(y + dy) * w + x + dx]; });
  for (let y = 0; y < L.shoulder; y++) for (let x = 0; x < w; x++) {
    const i = y*w+x, v = base.px[i];
    if (v < 0 || L.eyeMask[i]) continue;
    if (L.skull[i]) {
      if (HAIR.has(v)) g.px[i] = R.skin;
      else if (v === R.outline && !L.eyeMask[i] && nearHair(x, y)) g.px[i] = R.skin;
    } else {
      if (HAIR.has(v)) g.px[i] = -1;
      else if (v === R.outline && !nearSkinOut(x, y) && nearHair(x, y)) g.px[i] = -1;
    }
  }
  // fill any gap between the skull and the remaining face
  for (let i = 0; i < w * g.h; i++) if (L.skull[i] && g.px[i] < 0) g.px[i] = R.skin;
  reoutline(g, [0, L.shoulder]);
  BALD[dir] = g;
  return g.clone();
}

function addHair(g, rec, dir, L) {
  const st = rec.hair, w = g.w, h = g.h, base = BASE.boy[dir], sb = L.sb;
  if (st === 'spiky') return base.clone();       // the original, untouched
  g = baldHead(dir);
  const skull = L.skull, protect = mOr(L.face, maskOf(base, (v, x, y) => y >= L.shoulder));
  const fromSheet = (x, y, m) => { const v = base.get(x, y); return HAIR.has(v) && L.hairM[y * w + x] && y < L.eyeRow - 1 ? v : hairTex(x, y, m, w); };
  const back = !!BACK[dir], side = SIDE[dir] || 0, fac = FACING[dir];
  let HM = new Uint8Array(w * h);
  const close = mAnd(L.hairM, dilate(skull, w, h, 1.6));        // the sheet's hair trimmed to the scalp
  const extra = [];
  const over = (m) => extra.push({ m, mode: 'over' }), behind = (m) => extra.push({ m, mode: 'behind' });
  // a smooth version: the head's rounded volume minus the face, so the sheet's hairline and bangs survive but the spikes go
  const smooth = mSub(erode(L.blob, w, h, 0.6), mSub(L.face, L.hairM));
  if (st === 'short') HM = close;
  if (st === 'bob' || st === 'long' || st === 'ponytail' || st === 'buns' || st === 'pigtails' || st === 'neat') HM = smooth;
  if (st === 'bald') { if (rec.age === 'elder' || rec.facial !== 'none') HM = mAnd(close, raster(w, h, [{ t:'below', y: sb.y0 + sb.h * 0.42 }])); }
  if (st === 'curly') {
    const big = dilate(skull, w, h, 2.6), sc = [];
    for (let a = 0; a < 360; a += 30) { const t = a * Math.PI / 180; sc.push(Ell(sb.cx + Math.cos(t) * (sb.w / 2 + 2), sb.cy + Math.sin(t) * (sb.h / 2 + 2), 2.4)); }
    HM = mOr(big, raster(w, h, sc));
    if (!back) HM = mAnd(HM, raster(w, h, [{ t:'above', y: L.eyeRow + 4 }]));
    HM = mSub(HM, mSub(L.face, L.hairM));
  }
  if (st === 'bob' || st === 'long') {
    const yb = st === 'bob' ? L.shoulder - 2 : L.shoulder + 8;
    const panel = jagged(raster(w, h, [Rect(sb.x0 - 1.5, L.eyeRow - 3, sb.x1 + 1.5, yb, st === 'bob' ? 3 : 2.5)]), w, h);
    if (back) over(panel);
    else {
      behind(panel);
      // side locks framing the face
      if (!side) {
        const lock = raster(w, h, [Rect(sb.x0 - 1.2, L.eyeRow - 4, sb.x0 + 2.4, L.chin - 1, 1.5), Rect(sb.x1 - 2.4, L.eyeRow - 4, sb.x1 + 1.2, L.chin - 1, 1.5)]);
        over(mSub(lock, dilate(L.eyeMask, w, h, 1.5)));
      } else {
        const bx = fac > 0 ? sb.x0 : sb.x1;
        over(mSub(raster(w, h, [Rect(Math.min(bx, sb.cx) - 1, L.eyeRow - 3, Math.max(bx, sb.cx) + 1, yb - (st === 'bob' ? 1 : 4), 2)]), L.face));
      }
    }
  }
  if (st === 'ponytail') {
    if (side) behind(raster(w, h, [Ell(fac > 0 ? sb.x0 - 1.5 : sb.x1 + 1.5, L.eyeRow + 1, 3.2, 6)]));
    else if (back) over(raster(w, h, [Ell(sb.cx, sb.y1 - 2, 3.4, 6.5)]));
    else behind(raster(w, h, [Ell(sb.cx + (fac || 0) * -sb.w * 0.35, sb.y1 - 4, 3.2, 5.5)]));
  }
  if (st === 'pigtails') {
    for (const s of [-1, 1]) {
      const m = raster(w, h, [Ell(s < 0 ? sb.x0 - 2 : sb.x1 + 2, L.eyeRow + 2, 3, 5.5)]);
      if (side && s === fac) continue;
      behind(m);
    }
  }
  if (st === 'buns') for (const s of [-1, 1]) {
    if (side && s === fac) continue;
    over(raster(w, h, [Ell(s < 0 ? sb.x0 + 3 : sb.x1 - 3, sb.y0 + 0.5, 3.6, 3.4)]));
  }
  // paint: behind pieces first, then the hair that sits over the head as one shape with one outline
  for (const e of extra.filter(e => e.mode === 'behind')) paint(g, e.m, (x, y, m) => hairTex(x, y, m, w), 'behind');
  for (const e of extra.filter(e => e.mode === 'over')) HM = mOr(HM, mSub(e.m, L.eyeMask));
  if (HM.some(v => v)) paint(g, HM, fromSheet, 'over', true, (v, x, y) => protect[y*w+x] && !SKIN.has(v) || L.eyeMask[y*w+x]);
  if (st === 'ponytail' || st === 'pigtails') {   // hair ties
    if (side && st === 'ponytail') { const tx = fac > 0 ? sb.x0 - 1 : sb.x1 + 1; for (const dy of [-5, -4]) g.set(tx, L.eyeRow + 1 + dy, R.hat); }
  }
  return g;
}

function faceEdits(g, rec, dir, L, blink) {
  const w = g.w;
  for (const e of L.eyes) {
    const narrow = e.x1 === e.x0;
    const clear = () => { for (const j of e.cells) g.px[j] = R.skin; };
    const isClosed = blink || rec.eyes === 'happy' || rec.eyes === 'sleepy';
    if (isClosed) {
      clear();
      if (rec.eyes === 'happy') { const cx = e.x0, y = e.y0 + 1; if (narrow) { g.set(cx, y, R.outline); g.set(cx - FACING[dir], y + 1, R.outline); } else { g.set(e.x0 - 1, y + 1, R.outline); g.set(e.x0, y, R.outline); g.set(e.x1, y, R.outline); g.set(e.x1 + 1, y + 1, R.outline); } }
      else for (let x = e.x0; x <= e.x1; x++) g.set(x, e.y1, R.outline);
      continue;
    }
    if (rec.eyes === 'lashes') {
      const outer = (e.x0 + e.x1) / 2 < L.sb.cx ? -1 : 1;
      g.set(outer < 0 ? e.x0 - 1 : e.x1 + 1, e.y0, R.outline);
    } else if (rec.eyes === 'sparkle' && !narrow) g.set(e.x0, e.y0, R.white);
  }
  if (rec.freckles && L.eyes.length) for (const e of L.eyes) { const y = e.y1 + 2; for (const dx of [-1, 1, 2]) { const x = e.x0 + dx; if (g.get(x, y) === R.skin) g.set(x, y, R.skinShade); } }
  if (L.mouth && (rec.facial === 'mustache' || rec.facial === 'beard')) {
    const m = L.mouth;
    for (let x = m.x0 - 1; x <= m.x1 + 1; x++) { const v = g.get(x, m.y0 - 1); if (v === R.skin || v === R.skinShade || v === R.blush) g.set(x, m.y0 - 1, x === m.x0 - 1 || x === m.x1 + 1 ? R.hairDark : R.hair); }
    if (rec.facial === 'beard') for (let y = m.y1 + 1; y < L.shoulder; y++) for (let x = 0; x < w; x++) {
      const v = g.get(x, y); if (!(v === R.skin || v === R.skinShade || v === R.blush)) continue;
      g.set(x, y, y === L.shoulder - 1 || !SKIN.has(g.get(x, y + 1)) && g.get(x, y + 1) !== R.hair ? R.hairDark : (x + y) % 4 === 0 ? R.hairLight : R.hair);
    }
  }
  if (rec.glasses && L.eyes.length) {
    const rims = [];
    for (const e of L.eyes) {
      const x0 = e.x0 - 1, x1 = e.x1 + 1, y0 = e.y0 - 1, y1 = e.y1 + 1;
      for (let x = x0 + 1; x <= x1 - 1; x++) { if (g.get(x, y0) >= 0 && !L.eyeMask[y0*w+x]) g.set(x, y0, R.outline); if (g.get(x, y1) >= 0 && !L.eyeMask[y1*w+x]) g.set(x, y1, R.outline); }
      for (let y = y0 + 1; y <= y1 - 1; y++) for (const x of [x0, x1]) if (g.get(x, y) >= 0 && !L.eyeMask[y*w+x]) g.set(x, y, R.outline);
      if (e.x1 > e.x0) { const gx = x1 - 1, gy = y0 + 1; if (SKIN.has(g.get(gx, gy))) g.set(gx, gy, R.white); }
      rims.push({ x0, x1, y0 });
    }
    if (rims.length === 2) for (let x = rims[0].x1 + 1; x < rims[1].x0; x++) g.set(x, rims[0].y0 + 1, R.outline);
    else if (rims.length === 1 && SIDE[dir]) { const r = rims[0], f = FACING[dir]; for (let k = 1; k <= 4; k++) { const x = f > 0 ? r.x0 - k : r.x1 + k; const v = g.get(x, r.y0 + 1); if (v >= 0 && v !== R.outline && !HAIR.has(v)) g.set(x, r.y0 + 1, R.outline); } }
  }
}

function addHat(g, rec, dir, L) {
  if (rec.hat === 'none') return g;
  const w = g.w, h = g.h, sb = L.sb, fac = FACING[dir], back = !!BACK[dir], side = SIDE[dir] || 0;
  const band = Math.round(sb.y0 + sb.h * (rec.hat === 'sunhat' ? 0.34 : rec.hat === 'cap' ? 0.44 : 0.42));
  const crown = mAnd(dilate(L.skull, w, h, rec.hat === 'beanie' ? 1.2 : 0.7), raster(w, h, [{ t:'above', y: band + 0.5 }]));
  // flatten hair poking out above the hat line
  for (let y = 0; y < band; y++) for (let x = 0; x < w; x++) { const v = g.get(x, y); if ((HAIR.has(v) || v === R.outline) && !crown[y*w+x]) g.set(x, y, -1); }
  if (rec.hat === 'cap') {
    const hb = bbox(crown, w, h); paint(g, crown, (x, y, m) => y >= band - 1 || !m[y * w + x + 1] ? R.hatDark : (y <= hb.y0 + 2 && x <= hb.cx - 1 && x >= hb.cx - 4) ? R.hatLight : R.hat);
    const hb2 = bbox(crown, w, h);
    if (!side) for (let y = hb2.y0 + 1; y < band - 1; y++) { const x = Math.round(hb2.cx + fac * 1.5); if (g.get(x, y) === R.hat || g.get(x, y) === R.hatLight) g.set(x, y, R.hatDark); }
    g.set(Math.round(hb2.cx + fac * 1.5), hb2.y0 - 1, R.outline); g.set(Math.round(hb2.cx + fac * 1.5), hb2.y0, R.hatLight);
    if (!back) {
      const bw = side ? 5.5 : 0, cx = side ? (fac > 0 ? sb.x1 + 1 : sb.x0 - 1) : sb.cx + fac * 2;
      const brim = raster(w, h, [Rect(cx - (side ? bw / 2 : sb.w * 0.36 + (fac ? 1 : 0)) + (side ? fac * 1.5 : 0), band - 0.5, cx + (side ? bw / 2 : sb.w * 0.36 + (fac ? 1 : 0)) + (side ? fac * 1.5 : 0), band + 1.5, 1)]);
      paint(g, brim, (x, y) => y > band ? R.hatDark : R.hat, 'over', true, (v, x, y) => L.eyeMask[y*w+x]);
    }
  } else if (rec.hat === 'beanie') {
    paint(g, crown, (x, y, m) => y >= band - 2 ? ((x % 2) ? R.hatDark : R.hat) : !m[y * w + x + 1] ? R.hatDark : (x % 3 === 0 ? R.hatDark : R.hat));
    paint(g, raster(w, h, [Ell(sb.cx + fac * 1, sb.y0 - 2.5, 2.6, 2.4)]), () => R.hatLight);
  } else if (rec.hat === 'sunhat') {
    paint(g, crown, (x, y) => y >= band - 1 ? R.emblem : R.hat);
    paint(g, raster(w, h, [Ell(sb.cx + fac * 1.5, band + 1, sb.w / 2 + 5, 2.4)]), (x, y) => y > band + 1 ? R.hatDark : R.hat, 'over', true, (v, x, y) => L.eyeMask[y*w+x]);
  } else if (rec.hat === 'bow') {
    const bx = sb.x1 - 4 - (fac > 0 ? 2 : 0), by = sb.y0 + 2;
    if (!(side && fac > 0)) paint(g, raster(w, h, [Poly([[bx - 4.5, by - 3], [bx, by], [bx - 4.5, by + 3]]), Poly([[bx + 4.5, by - 3], [bx, by], [bx + 4.5, by + 3]]), Ell(bx, by, 1.4)]), (x, y) => y > by + 1 ? R.hatDark : R.hat);
  }
  return g;
}

const STAR = ['..#..','.###.','#####','.#.#.'];
function outfitEdits(g, rec, dir, L) {
  const w = g.w, h = g.h, top = rec.top;
  const front = !!FRONT[dir] || dir === 'S';
  // emblem
  if (L.emblem) {
    if (rec.emblem !== 'heart' || top === 'cardigan') for (let y = L.emblem.y0; y <= L.emblem.y1; y++) for (let x = L.emblem.x0; x <= L.emblem.x1; x++) if (g.get(x, y) === R.emblem) g.set(x, y, R.top);
    if (rec.emblem === 'star' && top !== 'cardigan') { const ox = Math.round(L.emblem.cx - 2), oy = L.emblem.y0; STAR.forEach((row, j) => [...row].forEach((c, i) => { if (c === '#' && TOPS.has(g.get(ox + i, oy + j))) g.set(ox + i, oy + j, R.emblem); })); }
  }
  // short sleeves: arms below the elbow show skin
  if (top === 'tshirt' || top === 'dress') {
    const cut = L.shoulder + (top === 'dress' ? 3 : 5);
    for (let y = cut; y <= L.hip + 4; y++) for (let x = 0; x < w; x++) {
      if (x >= L.coreL && x <= L.coreR && !SIDE[dir]) continue;
      if (SIDE[dir]) continue;
      const v = g.get(x, y); if (v === R.top) g.set(x, y, R.skin); else if (v === R.topDark) g.set(x, y, R.skinShade);
    }
  }
  if (top === 'hoodie') {
    if (BACK[dir]) {
      const hm = raster(w, h, [Ell(L.bodyCx, L.shoulder + 1.5, (L.coreR - L.coreL) * 0.42 + 1, 3.2)]);
      paint(g, mAnd(hm, maskOf(g, v => v >= 0)), (x, y) => y > L.shoulder + 2 ? R.topDark : R.top);
    } else if (L.emblem && FRONT[dir]) {
      const cx = Math.round(L.emblem.cx);
      for (const dx of (dir === 'S' ? [-2, 2] : [-1, 2])) for (let j = 0; j < 3; j++) if (TOPS.has(g.get(cx + dx, L.shoulder + 1 + j))) g.set(cx + dx, L.shoulder + 1 + j, R.white);
      const py = L.hip - 3; for (let x = L.coreL + 1; x <= L.coreR - 1; x++) if (TOPS.has(g.get(x, py))) g.set(x, py, R.topDark);
    }
  }
  if (top === 'cardigan' && L.emblem && FRONT[dir]) {
    const cx = Math.round(L.emblem.cx);
    for (let y = L.shoulder + 1; y < L.hip - 1; y++) { if (TOPS.has(g.get(cx, y))) g.set(cx, y, R.inner); if (TOPS.has(g.get(cx - 1, y))) g.set(cx - 1, y, R.inner); if ((y - L.shoulder) % 3 === 2 && TOPS.has(g.get(cx + 1, y))) g.set(cx + 1, y, R.outline); }
  }
  // lower body
  const legRow0 = L.hip;
  if (top === 'dress' || rec.bottom === 'skirt') {
    const skirtRole = top === 'dress' ? [R.top, R.topDark] : [R.bottom, R.bottomDark];
    const len = 4;
    for (let y = legRow0; y < h; y++) for (let x = 0; x < w; x++) {
      const v = g.get(x, y);
      if (y < legRow0 + len) { if (v === R.bottom) g.set(x, y, y === legRow0 + len - 1 ? skirtRole[1] : skirtRole[0]); else if (v === R.bottomDark) g.set(x, y, skirtRole[1]); }
      else if (y < L.shoeTop) { if (v === R.bottom) g.set(x, y, R.legSkin); else if (v === R.bottomDark) g.set(x, y, R.legSkinShade); }
    }
    // flare: widen the skirt one pixel each side on its lower rows
    for (let y = legRow0 + 1; y < legRow0 + len; y++) {
      const xs = []; for (let x = 0; x < w; x++) if (g.get(x, y) === skirtRole[0] || g.get(x, y) === skirtRole[1]) xs.push(x);
      if (!xs.length) continue;
      const a = Math.min(...xs), b = Math.max(...xs), grow = y >= legRow0 + 2 ? 2 : 1;
      for (let k = 1; k <= grow; k++) { if (g.get(a - k + 1, y) === R.outline || g.get(a - k + 1, y) < 0) g.set(a - k + 1, y, skirtRole[y === legRow0 + len - 1 ? 1 : 0]); if (g.get(b + k - 1, y) === R.outline || g.get(b + k - 1, y) < 0) g.set(b + k - 1, y, skirtRole[y === legRow0 + len - 1 ? 1 : 0]); }
      g.set(a - grow, y, R.outline); g.set(b + grow, y, R.outline);
    }
    const yb = legRow0 + len; for (let x = 0; x < w; x++) if (skirtRole.includes(g.get(x, yb - 1)) && g.get(x, yb) < 0) g.set(x, yb, R.outline);
    // gap between the legs below the skirt stays open
    for (let x = 0; x < w; x++) if (g.get(x, yb) === R.outline && g.get(x, yb + 1) < 0 && g.get(x - 1, yb) !== R.legSkin && g.get(x + 1, yb) !== R.legSkin) {}
  } else if (rec.bottom === 'shorts') {
    for (let y = legRow0 + 3; y < L.shoeTop; y++) for (let x = 0; x < w; x++) { const v = g.get(x, y); if (v === R.bottom) g.set(x, y, R.legSkin); else if (v === R.bottomDark) g.set(x, y, R.legSkinShade); }
    for (let x = 0; x < w; x++) if ((g.get(x, legRow0 + 2) === R.bottom) && g.get(x, legRow0 + 3) === R.legSkin) g.set(x, legRow0 + 2, R.bottomDark);
  }
  if (rec.shoes === 'boots') for (let y = L.shoeTop - 3; y < L.shoeTop; y++) for (let x = 0; x < w; x++) { const v = g.get(x, y); if (LEGS.has(v) && v !== R.shoe && v !== R.shoeShade) g.set(x, y, (x % 3 === 0) ? R.shoeShade : R.shoe); }
  return g;
}

/* body length and width: duplicate rows / columns of the sheet so the line work stays intact */
function reshape(g, rec, L) {
  const AGE = { kid: [0, 0], teen: [2, 3], adult: [3, 6], elder: [3, 4] }[rec.age] || [0, 0];
  const rowsAdd = [];
  const torsoRow = L.shoulder + Math.floor((L.hip - L.shoulder) * 0.55);
  const legRow = Math.max(L.hip + 4, Math.floor((L.hip + L.shoeTop) / 2));
  for (let k = 0; k < AGE[0]; k++) rowsAdd.push(torsoRow);
  for (let k = 0; k < AGE[1]; k++) rowsAdd.push(legRow);
  let out = g;
  if (rowsAdd.length) {
    const nh = g.h + rowsAdd.length, ng = new G(g.w, nh); let y2 = 0;
    for (let y = 0; y < g.h; y++) {
      const reps = 1 + rowsAdd.filter(r => r === y).length;
      for (let r = 0; r < reps; r++) { for (let x = 0; x < g.w; x++) ng.px[y2 * g.w + x] = g.px[y * g.w + x]; y2++; }
    }
    out = ng;
  }
  const extraCols = rec.build === 'broad' ? 2 : 0;
  if (extraCols) {
    const cx = Math.round(L.bodyCx), ng = new G(out.w + extraCols, out.h);
    for (let y = 0; y < out.h; y++) for (let x = 0; x < ng.w; x++) {
      let sx;
      if (y < L.shoulder) sx = x - extraCols / 2;
      else sx = x <= cx ? x : x - extraCols <= cx ? cx : x - extraCols;
      ng.px[y * ng.w + x] = sx >= 0 && sx < out.w ? out.px[y * out.w + sx] : -1;
    }
    out = ng;
  }
  return out;
}

function humanGrid(rec, dir, blink) {
  const L = humanLandmarks(dir);
  let g = addHair(BASE.boy[dir].clone(), rec, dir, L);
  faceEdits(g, rec, dir, L, blink);
  g = addHat(g, rec, dir, L);
  g = outfitEdits(g, rec, dir, L);
  g = reshape(g, rec, L);
  return g;
}

/* =============================== CREATURE =============================== */
const CL = {};
function catLandmarks(dir) {
  if (CL[dir]) return CL[dir];
  const g = BASE.cat[dir], w = g.w, h = g.h;
  const runs = y => { const out = []; let s = -1; for (let x = 0; x <= w; x++) { const on = x < w && g.get(x, y) >= 0; if (on && s < 0) s = x; if (!on && s >= 0) { out.push([s, x - 1]); s = -1; } } return out; };
  let maxW = 0; for (let y = 0; y < h; y++) for (const [a, b] of runs(y)) maxW = Math.max(maxW, b - a + 1);
  let topRow = 0;
  for (let y = 0; y < h; y++) { const r = runs(y); if (r.length === 1 && r[0][1] - r[0][0] + 1 > maxW * (SIDE[dir] ? 0.7 : 0.55)) { topRow = y; break; } }
  let footTop = h; for (let y = h - 1; y >= 0; y--) { if (runs(y).length >= 2) footTop = y; else break; }
  const tr = runs(topRow)[0] || [0, w - 1];
  // body box: widest single run below the arms
  const coreRow = Math.max(topRow + 2, footTop - 2), cr = runs(coreRow), core = cr.length ? [cr[0][0], cr[cr.length - 1][1]] : [0, w - 1];
  const eyeM = maskOf(g, v => v === R.eye);
  const eyes = [];
  for (const cells of comps(eyeM, w, h)) {
    const xs = cells.map(j => j % w), ys = cells.map(j => (j / w) | 0);
    const b = { x0: Math.min(...xs), x1: Math.max(...xs), y0: Math.min(...ys), y1: Math.max(...ys) };
    const hit = eyes.find(o => !(b.x0 > o.x1 + 2 || b.x1 < o.x0 - 2 || b.y0 > o.y1 + 2 || b.y1 < o.y0 - 2));
    if (hit) { hit.x0 = Math.min(hit.x0, b.x0); hit.x1 = Math.max(hit.x1, b.x1); hit.y0 = Math.min(hit.y0, b.y0); hit.y1 = Math.max(hit.y1, b.y1); }
    else eyes.push(b);
  }
  for (const e of eyes) { e.cx = (e.x0 + e.x1) / 2; e.cy = (e.y0 + e.y1) / 2; }
  const big = eyes.filter(e => e.x1 - e.x0 >= 1 && e.y1 - e.y0 >= 2);
  const noseM = maskOf(g, v => v === R.nose), nb = noseM.some(v => v) ? bbox(noseM, w, h) : null;
  // mouth: interior outline strokes below the eyes
  const eyeZone = dilate(raster(w, h, big.map(e => Rect(e.x0 - 0.5, e.y0 - 0.5, e.x1 + 1.5, e.y1 + 1.5, 0))), w, h, 1.5);
  const interior = maskOf(g, (v, x, y) => v === R.outline && N4.every(([dx, dy]) => g.get(x + dx, y + dy) >= 0) && !eyeZone[y*w+x]);
  const eyeBottom = big.length ? Math.max(...big.map(e => e.y1)) : topRow + 8;
  const mouthM = mAnd(interior, raster(w, h, [Rect(-1, eyeBottom - 1, w + 1, eyeBottom + 8, 0)]));
  if (SIDE[dir]) { const fac = FACING[dir]; const ex = big.length ? big[0].cx : w / 2; for (let i = 0; i < w * h; i++) if (mouthM[i] && ((i % w) - ex) * fac < -4) mouthM[i] = 0; }
  const mb = mouthM.some(v => v) ? bbox(mouthM, w, h) : null;
  const mouthAll = mb ? mAnd(dilate(mouthM, w, h, 1), maskOf(g, v => v === R.outline || v === R.nose ? false : v >= 0)) : null;
  CL[dir] = { topRow, topRun: tr, footTop, core, eyes: big, nose: nb, noseM, mouth: mb, mouthM, cx: (tr[0] + tr[1]) / 2, w, h };
  return CL[dir];
}

function creatureGrid(rec, dir, blink) {
  const L = catLandmarks(dir), base = BASE.cat[dir];
  let g = base.clone(); const w = g.w, h = g.h, fac = FACING[dir], side = SIDE[dir] || 0, back = !!BACK[dir];
  const bodyRole = (x, y) => R.body;
  // --- ears & silhouette ---
  if (rec.ears !== 'cat') {
    for (let y = 0; y < L.topRow; y++) for (let x = 0; x < w; x++) g.set(x, y, -1);
    // the top row becomes the new outline; soften its corners
    reoutline(g, [0, L.topRow + 1]);
  }
  if (rec.shape === 'round' || rec.shape === 'oval') {
    const r = rec.shape === 'round' ? 6 : 9, x0 = L.topRun[0], x1 = L.topRun[1], y0 = L.topRow;
    const keep = raster(w, h, [Rect(x0 - 0.5, y0 - (rec.ears === 'cat' ? 30 : 0) , x1 + 1.5, h + 5, 0)]);
    const corner = raster(w, h, [Rect(x0 - 0.5, y0, x1 + 1.5, h + 20, r)]);
    for (let y = y0; y < y0 + r; y++) for (let x = 0; x < w; x++) { const i = y*w+x; if (g.px[i] >= 0 && keep[i] && !corner[i]) { if (rec.ears === 'cat' && y < L.topRow) continue; g.px[i] = -1; } }
    if (rec.shape === 'oval') {   // trim the lower corners above the feet too
      const yb = L.footTop - 1, corner2 = raster(w, h, [Rect(L.core[0] - 0.5, -20, L.core[1] + 1.5, yb + 0.5, 5)]);
      for (let y = yb - 5; y <= yb; y++) for (let x = 0; x < w; x++) { const i = y*w+x; if (g.px[i] >= 0 && !corner2[i] && x > L.core[0] - 3 && x < L.core[1] + 3) g.px[i] = -1; }
    }
    reoutline(g);
  }
  const topY = rec.ears === 'cat' || rec.shape === 'cat' ? L.topRow : L.topRow;
  const tcx = L.cx + (side ? -fac * 1 : 0);
  if (rec.ears === 'bunny' || rec.ears === 'bear') {
    const ears = [];
    for (const s of [-1, 1]) {
      if (side && s !== -fac && rec.ears === 'bear') continue;
      const ex = side ? tcx + s * 2 - fac * 2 : (s < 0 ? L.topRun[0] + 5 : L.topRun[1] - 5);
      ears.push(rec.ears === 'bunny' ? Ell(ex, topY - 5.5, 2.6, 7) : Ell(ex, topY, 3.4, 3.2));
    }
    const em = raster(w, h, ears);
    paint(g, em, () => R.body, 'behind');
    if (!back) for (const e of ears) { if (rec.ears === 'bunny') for (let y = Math.round(e.cy - 4); y <= Math.round(e.cy + 2); y++) { const x = Math.round(e.cx); if (g.get(x, y) === R.body) g.set(x, y, R.earInner); } else { const x = Math.round(e.cx), y = Math.round(e.cy - 1); if (g.get(x, y) === R.body) g.set(x, y, R.earInner); } }
  }
  // --- face ---
  const faceOn = !back;
  const clearBox = (x0, y0, x1, y1) => { for (let y = y0; y <= y1; y++) for (let x = x0; x <= x1; x++) { const v = g.get(x, y); if (v < 0) continue; const edge = N4.some(([dx, dy]) => g.get(x + dx, y + dy) < 0); if (edge) continue; g.set(x, y, R.body); } };
  if (faceOn) {
    const eyesStyle = rec.eyes;
    for (const e of L.eyes) {
      const narrow = e.x1 - e.x0 < 4, cx = Math.round(e.cx), cy = Math.round(e.cy);
      if (blink || eyesStyle === 'happy' || eyesStyle === 'dot' || eyesStyle === 'sleepy') {
        clearBox(e.x0 - 1, e.y0 - 1, e.x1 + 1, e.y1 + 1);
        if (blink && eyesStyle !== 'happy') { const pts = narrow ? [[-1,0],[0,1],[1,1]] : [[-3,0],[-2,1],[-1,1],[0,1],[1,1],[2,0]]; for (const [dx, dy] of pts) g.set(cx + dx, cy + dy, R.outline); }
        else if (eyesStyle === 'happy') { const pts = narrow ? [[-1,1],[0,0],[1,1]] : [[-3,1],[-2,0],[-1,-1],[0,-1],[1,0],[2,1]]; for (const [dx, dy] of pts) g.set(cx + dx, cy + dy, R.outline); }
        else if (eyesStyle === 'sleepy') { for (let dx = (narrow ? -1 : -2); dx <= (narrow ? 1 : 2); dx++) g.set(cx + dx, cy + 1, R.outline); }
        else for (const [dx, dy] of (narrow ? [[0,-1],[0,0],[0,1]] : [[-1,-1],[0,-1],[-1,0],[0,0],[-1,1],[0,1]])) g.set(cx + dx, cy + dy, R.outline);
      } else if (eyesStyle === 'side') {
        for (let y = e.y0; y <= e.y1; y++) for (let x = e.x0; x <= e.x1; x++) if (g.get(x, y) === R.outline && N4.every(([dx, dy]) => g.get(x + dx, y + dy) !== R.body)) g.set(x, y, R.eye);
        const px = e.x1 - 1; for (const [dx, dy] of [[0,0],[-1,0],[0,-1],[-1,-1]]) if (g.get(px + dx, cy + dy + 1) === R.eye) g.set(px + dx, cy + dy + 1, R.outline);
      }
    }
    if (!rec.nose && L.nose) for (let i = 0; i < w * h; i++) if (L.noseM[i]) g.px[i] = R.body;
    // mouth
    if (rec.mouth !== 'tongue' && L.mouth) {
      const m = L.mouth;
      clearBox(m.x0 - 1, m.y0 - 1, m.x1 + 1, m.y1 + 1);
      const cx = Math.round(L.nose ? L.nose.cx : m.cx), y = m.y0, narrow = m.w < 6 || side;
      const put = pts => { for (const [dx, dy] of pts) { const v = g.get(cx + dx, y + dy); if (v >= 0) g.set(cx + dx, y + dy, R.outline); } };
      if (rec.mouth === 'smile') put(narrow ? [[-1,0],[0,1],[1,1],[2,0]].map(([a,b]) => [a * (fac || 1), b]) : [[-3,0],[-2,1],[-1,1],[0,1],[1,1],[2,1],[3,0]]);
      else if (rec.mouth === 'cat') put(narrow ? [[-1,0],[0,1],[1,0]] : [[-3,0],[-2,1],[-1,1],[0,0],[1,1],[2,1],[3,0]]);
      else if (rec.mouth === 'open' || rec.mouth === 'jack') {
        const jack = rec.mouth === 'jack';
        const rx = jack ? (narrow ? 4 : L.core[1] - L.core[0] > 20 ? 8.5 : 7) : (narrow ? 2.2 : 3.6), ry = jack ? (narrow ? 4 : 5) : 3;
        const mx = cx + (narrow ? fac * 0.5 : 0) + 0.5, my = y - 0.5;
        const mm = mAnd(raster(w, h, [Ell(mx, my, rx, ry), { t:'above', y: my + 0.6, op:'sub' }]), maskOf(g, v => BODY.has(v)));
        const inner = erode(mm, w, h, 1);
        paint(g, mm, (x, yy) => {
          if (jack) return yy >= my + ry - 2 ? R.pumpkinDark : R.pumpkin;
          return yy >= my + ry - 1.2 ? R.tongue : R.mouthDark;
        }, 'over', true, (v) => v < 0);
        void inner;
        if (jack) {   // teeth
          const tx = Math.round(rx * 0.42), top = Math.round(my + 0.6);
          for (const t of narrow ? [0] : [-tx - 1, tx]) for (const [dx, dy] of [[0,0],[1,0],[0,1],[1,1]]) if (g.get(cx + t + dx, top + dy) === R.pumpkin) g.set(cx + t + dx, top + dy, R.body);
          if (!narrow) for (const [dx, dy] of [[0,0],[1,0]]) { const yy = Math.round(my + ry) - 1; if (g.get(cx + dx, yy + dy) === R.pumpkinDark || g.get(cx + dx, yy + dy) === R.pumpkin) g.set(cx + dx, yy + dy, R.body); }
        }
      }
    }
    if (rec.blush && L.eyes.length) for (const e of L.eyes) {
      const s = e.cx < L.cx ? -1 : 1, bx = Math.round(e.cx + s * (e.x1 - e.x0) * 0.35), by = e.y1 + 2;
      for (const dx of (e.x1 - e.x0 < 4 ? [0] : [-1, 0, 1])) if (g.get(bx + dx, by) === R.body) g.set(bx + dx, by, R.cheek);
    }
  }
  // --- pattern ---
  if (rec.pattern === 'spots') {
    const spots = [[0.2, 0.35, 1.3], [0.72, 0.28, 1.1], [0.5, 0.78, 1.4], [0.15, 0.7, 1.0], [0.85, 0.62, 1.2], [0.38, 0.55, 0.9], [0.62, 0.48, 1.0]];
    const bw = L.core[1] - L.core[0], bh = L.footTop - L.topRow;
    for (const [fx, fy, r] of spots) {
      const sx = L.core[0] + fx * bw, sy = L.topRow + fy * bh;
      const sm = raster(w, h, [Ell(sx, sy, r + 0.3, r)]);
      for (let i = 0; i < w * h; i++) if (sm[i] && g.px[i] === R.body) {
        const x = i % w, y = (i / w) | 0;
        if (!N4.some(([dx, dy]) => { const v = g.get(x + dx, y + dy); return v === R.outline || v === R.eye || v === R.nose; })) g.px[i] = R.pattern;
      }
    }
  } else if (rec.pattern === 'belly' && !back) {
    const bw = L.core[1] - L.core[0], bx = side ? L.cx + fac * bw * 0.25 : L.cx, by = L.footTop - (L.footTop - L.topRow) * 0.28;
    const sm = raster(w, h, [Ell(bx, by, side ? bw * 0.22 : bw * 0.28, (L.footTop - L.topRow) * 0.24)]);
    for (let i = 0; i < w * h; i++) if (sm[i] && g.px[i] === R.body) g.px[i] = R.pattern;
  }
  // --- toppers ---
  const tx = L.cx + (side ? -fac * 1.5 : fac * 1), ty = L.topRow + (rec.ears === 'cat' ? 0.5 : 0.5);
  const need = { daisy: 16, stem: 7, sprout: 9, leaf: 9, mushroom: 9 }[rec.top] || 0;
  if (need) {   // grow the canvas upward so toppers have room
    const ng = new G(w, h + need); for (let i = 0; i < w * h; i++) ng.px[i + need * w] = g.px[i]; g = ng;
  }
  const W = g.w, H = g.h, oy = need, Y = ty + oy;
  if (rec.top === 'daisy') {
    paint(g, raster(W, H, [Line(tx, Y + 1, tx + 0.4, Y - 6, 0.85)]), () => R.leafDark, 'over');
    const pet = []; for (let i = 0; i < 9; i++) { const t = i / 9 * Math.PI * 2 + 0.2; pet.push(Ell(tx + Math.cos(t) * 5.8, Y - 12 + Math.sin(t) * 5.2, 2.9, 2.8)); }
    paint(g, raster(W, H, pet), (x, y, m) => !m[(y + 1) * W + x] ? R.petalShade : R.petal, 'over');
    paint(g, raster(W, H, [Ell(tx, Y - 12, 3.4, 3.2)]), (x, y) => (x > tx + 0.5 && y > Y - 12.5) ? R.centerDark : R.center, 'over');
  } else if (rec.top === 'stem') {
    paint(g, raster(W, H, [Poly([[tx - 1.6, Y + 1.5], [tx + 1.6, Y + 1.5], [tx + 2.8, Y - 5], [tx + 0.4, Y - 5.6]])]), (x) => x > tx + 0.8 ? R.leafDark : R.stem, 'over');
  } else if (rec.top === 'sprout') {
    paint(g, raster(W, H, [Line(tx, Y + 1, tx, Y - 4, 0.8)]), () => R.leafDark, 'over');
    paint(g, raster(W, H, [Poly([[tx, Y - 4], [tx - 6.5, Y - 7.5], [tx - 3, Y - 3]]), Poly([[tx, Y - 4.5], [tx + 6.5, Y - 9], [tx + 3.5, Y - 3.6]])]), (x, y, m) => !m[(y + 1) * W + x] ? R.leafDark : R.leaf, 'over');
  } else if (rec.top === 'leaf') {
    paint(g, raster(W, H, [Poly([[tx - 0.5, Y + 1.5], [tx + 7, Y - 6.5], [tx + 1.2, Y - 8]])]), (x, y, m) => !m[(y + 1) * W + x] ? R.leafDark : R.leaf, 'over');
  } else if (rec.top === 'mushroom') {
    const x0 = L.topRun[0], x1 = L.topRun[1], cw = (x1 - x0) / 2 + 3.5;
    const cap = raster(W, H, [Ell((x0 + x1 + 1) / 2, Y + 3.5, cw, 10), { t:'below', y: Y + 4.5, op:'sub' }]);
    paint(g, cap, (x, y) => y >= Y + 3.5 ? R.capDark : R.cap, 'over');
    for (const [fx, fy] of [[-0.5, -4.5], [0.2, -8.5], [0.55, -3]]) { const sx = Math.round((x0 + x1) / 2 + fx * cw), sy = Math.round(Y + fy); for (const [dx, dy] of [[0,0],[1,0],[0,1],[1,1]]) if (g.get(sx + dx, sy + dy) === R.cap) g.set(sx + dx, sy + dy, R.capSpot); }
  }
  return g;
}

/* ================================ RIG ================================ */
const runsOf = (g, y) => { const out = []; let s = -1; for (let x = 0; x <= g.w; x++) { const on = x < g.w && g.get(x, y) >= 0; if (on && s < 0) s = x; if (!on && s >= 0) { out.push([s, x - 1]); s = -1; } } return out; };
function mkPart(g, test, attach) {
  const mask = new Uint8Array(g.w * g.h); let r0 = 1e9, r1 = -1, x0 = 1e9, x1 = -1, n = 0;
  for (let y = 0; y < g.h; y++) for (let x = 0; x < g.w; x++) { const v = g.get(x, y); if (v < 0 || !test(x, y, v)) continue; mask[y*g.w+x] = 1; n++; r0 = Math.min(r0, y); r1 = Math.max(r1, y); x0 = Math.min(x0, x); x1 = Math.max(x1, x); }
  return n ? { mask, r0, r1, x0, x1, attach } : null;
}
function rigHuman(g, dir) {
  const w = g.w, h = g.h, at = (x, y) => g.get(x, y);
  const legPants = v => v === R.bottom || v === R.bottomDark || v === R.legSkin || v === R.legSkinShade;
  let hip = h - 8; for (let y = 0; y < h; y++) { let n = 0; for (let x = 0; x < w; x++) if (legPants(at(x, y))) n++; if (n >= 3) { hip = y; break; } }
  const legSet = new Uint8Array(w * h);
  for (let y = hip; y < h; y++) for (const [a, b] of runsOf(g, y)) {
    let ok = false; for (let x = a; x <= b; x++) if (LEGS.has(at(x, y))) ok = true;
    if (!ok) continue;
    let lo = a, hi = b; const sk = v => v === R.skin || v === R.skinShade;
    if (y < hip + 5) {
      while (lo < hi && !LEGS.has(at(lo, y)) && (sk(at(lo, y)) || sk(at(lo + 1, y)) || TOPS.has(at(lo + 1, y)) || sk(at(lo + 2, y)))) lo++;
      while (hi > lo && !LEGS.has(at(hi, y)) && (sk(at(hi, y)) || sk(at(hi - 1, y)) || TOPS.has(at(hi - 1, y)) || sk(at(hi - 2, y)))) hi--;
    }
    for (let x = lo; x <= hi; x++) legSet[y*w+x] = 1;
  }
  for (let y = hip + 1; y < h; y++) for (let x = 0; x < w; x++) if (at(x, y) === R.outline && legSet[(y - 1)*w+x]) legSet[y*w+x] = 1;   // the sole's outline moves with the foot
  const isLeg = (x, y) => legSet[y*w+x] === 1;
  const bx = []; for (let y = hip; y < Math.min(h, hip + 4); y++) for (let x = 0; x < w; x++) if (legPants(at(x, y))) bx.push(x);
  const cx = bx.reduce((a, b) => a + b, 0) / Math.max(1, bx.length);
  const parts = {};
  if (SIDE[dir]) parts.leg = mkPart(g, (x, y) => isLeg(x, y), 'top');
  else {
    parts.legL = mkPart(g, (x, y) => isLeg(x, y) && x < cx, 'top');
    parts.legR = mkPart(g, (x, y) => isLeg(x, y) && x >= cx, 'top');
    let shoulder = 0; for (let y = 0; y < h; y++) { let n = 0; for (let x = 0; x < w; x++) if (TOPS.has(at(x, y))) n++; if (n >= 2) { shoulder = y; break; } }
    const coreL = Math.min(...bx), coreR = Math.max(...bx), top = shoulder + 3;
    parts.armL = mkPart(g, (x, y) => y >= top && y < hip + 8 && x < coreL && !isLeg(x, y), 'top');
    parts.armR = mkPart(g, (x, y) => y >= top && y < hip + 8 && x > coreR && !isLeg(x, y), 'top');
  }
  return finishRig(g, parts);
}
function rigCreature(g, dir) {
  const w = g.w, h = g.h;
  let footTop = h; for (let y = h - 1; y >= 0; y--) { if (runsOf(g, y).length >= 2) footTop = y; else break; }
  let split;
  if (h - footTop < 2) { footTop = h - 3; split = w / 2; }
  else { const mids = []; for (let y = footTop; y < h; y++) { const r = runsOf(g, y); let best = 0, m = w / 2; for (let i = 1; i < r.length; i++) { const gp = r[i][0] - r[i-1][1]; if (gp > best) { best = gp; m = (r[i][0] + r[i-1][1]) / 2; } } mids.push(m); } mids.sort((a, b) => a - b); split = mids[Math.floor(mids.length / 2)]; }
  const parts = {};
  parts.legL = mkPart(g, (x, y) => y >= footTop && x < split, 'top');
  parts.legR = mkPart(g, (x, y) => y >= footTop && x >= split, 'top');
  if (!SIDE[dir]) {
    const coreRow = Math.max(0, footTop - 2), r = runsOf(g, coreRow);
    const coreL = r.length ? r[0][0] : 0, coreR = r.length ? r[r.length - 1][1] : w - 1;
    const band = cond => { let a = 1e9, b = -1; for (let y = 0; y < footTop - 1; y++) { const rr = runsOf(g, y); if (rr.length && cond(rr)) { a = Math.min(a, y); b = Math.max(b, y); } } return [a, b]; };
    const lowest = (cond) => { const [a, b] = band(cond); return b < 0 ? null : [Math.max(b - 9, a, 0), b]; };
    const la = lowest(rr => rr[0][0] < coreL - 1), ra = lowest(rr => rr[rr.length - 1][1] > coreR + 1);
    if (la) { const [a, b] = [Math.max(0, la[0] - 2), Math.min(footTop - 1, la[1] + 2)]; parts.armL = mkPart(g, (x, y) => y >= a && y <= b && x < coreL, 'both'); if (parts.armL) { parts.armL.r0 = a; parts.armL.r1 = b; } }
    if (ra) { const [a, b] = [Math.max(0, ra[0] - 2), Math.min(footTop - 1, ra[1] + 2)]; parts.armR = mkPart(g, (x, y) => y >= a && y <= b && x > coreR, 'both'); if (parts.armR) { parts.armR.r0 = a; parts.armR.r1 = b; } }
  }
  return finishRig(g, parts);
}
function finishRig(g, parts) {
  const partOf = new Int8Array(g.w * g.h); let k = 1;
  for (const p of Object.values(parts)) { if (!p) continue; for (let i = 0; i < p.mask.length; i++) if (p.mask[i]) partOf[i] = k; k++; }
  return { parts, partOf };
}

/* ============================== ANIMATION ============================== */
/* kept deliberately small: one-pixel lifts and bobs, the way 16-bit RPG walkers move */
const ANIMS = {
  human: {
    idle: { ms: [360, 360, 360, 360], f: [{}, {}, { b: 1 }, { b: 1 }] },
    walk: { ms: [140, 140, 140, 140], f: [{ s: 1 }, { b: -1, legs: [-1, 0] }, { s: 1 }, { b: -1, legs: [0, -1] }] },
    run:  { ms: [95, 95, 95, 95], f: [{ s: 2 }, { b: -1, legs: [-2, 0], arms: [1, -1], lean: 1 }, { s: 2 }, { b: -1, legs: [0, -2], arms: [-1, 1], lean: 1 }] },
    jump: { ms: [120, 80, 80, 100, 100, 80, 80, 120, 260], f: [{ b: 1 }, { oy: -3, legs: [-1, -1] }, { oy: -6, legs: [-1, -1], arms: [-1, -1] }, { oy: -8, legs: [-1, -1], arms: [-1, -1] }, { oy: -8, legs: [-1, -1] }, { oy: -6, legs: [-1, -1] }, { oy: -3 }, { b: 1 }, {}] },
    wave: { ms: [180, 180, 180, 180], f: [{ wave: 0 }, { wave: 1 }, { wave: 0 }, { wave: 1 }] },
  },
  creature: {
    idle: { ms: [360, 360, 360, 360], f: [{}, {}, { b: 1 }, { b: 1 }] },
    walk: { ms: [150, 150, 150, 150], f: [{}, { b: -1, legs: [-1, 0], cat: [0, -1] }, {}, { b: -1, legs: [0, -1], cat: [-1, 0] }] },
    run:  { ms: [100, 100, 100, 100], f: [{ b: 1 }, { oy: -2, legs: [-1, -1], cat: [-1, -1], lean: 1 }, { b: 1 }, { oy: -2, legs: [-1, -1], cat: [-1, -1], lean: 1 }] },
    jump: { ms: [120, 80, 80, 100, 100, 80, 80, 120, 260], f: [{ b: 1 }, { oy: -3, legs: [-1, -1], cat: [-1, -1] }, { oy: -6, legs: [-1, -1], cat: [-2, -2] }, { oy: -8, legs: [-1, -1], cat: [-2, -2] }, { oy: -8, legs: [-1, -1], cat: [-1, -1] }, { oy: -6, legs: [-1, -1] }, { oy: -3, cat: [1, 1] }, { b: 1 }, {}] },
  },
};
const ANIM_LIST = { human: ['idle', 'walk', 'run', 'jump', 'wave'], creature: ['idle', 'walk', 'run', 'jump'] };
const CELL = { w: 56, h: 84, ground: 78 };

/* draw one animation frame of a built grid into a cell-sized RGBA buffer */
function animate(g, rig, kind, dir, anim, fi, pal, shadow) {
  const A = ANIMS[kind][anim] || ANIMS[kind].idle, F = A.f[fi % A.f.length];
  const W = CELL.w, H = CELL.h, buf = new Int16Array(W * H).fill(-1), shadeBuf = new Uint8Array(W * H);
  const ox = Math.floor((W - g.w) / 2), oyBase = CELL.ground - g.h;
  const oy = F.oy || 0, b = F.b || 0, facing = SIDE[dir] || 0, tdx = (F.lean || 0) * facing;
  const put = (x, y, v, sh) => { if (x >= 0 && y >= 0 && x < W && y < H && v >= 0) { buf[y*W+x] = v; shadeBuf[y*W+x] = sh ? 1 : 0; } };
  const P = rig.parts;
  const drawTop = (p, dx, dy, shd, leg) => {
    const ext = Math.max(0, dy) + (leg ? Math.max(0, -b) + 1 : 0);
    for (let sy = p.r0 - ext; sy <= p.r1; sy++) { const ry = Math.max(sy, p.r0); for (let x = p.x0; x <= p.x1; x++) { const i = ry * g.w + x; if (!p.mask[i]) continue; put(x + ox + dx, sy + oyBase + dy + oy, g.px[i], shd); } }
  };
  const drawBoth = (p, dx, warp, rigid) => {
    for (let ty = p.r0; ty <= p.r1; ty++) { const ry = clamp(ty - warp, p.r0, p.r1); for (let x = p.x0; x <= p.x1; x++) { const i = ry * g.w + x; if (!p.mask[i]) continue; put(x + ox + dx, ty + oyBase + rigid + oy, g.px[i]); } }
  };
  const legs = F.legs || [0, 0];
  if (P.leg) { const st = F.s || 0; if (st) { drawTop(P.leg, -st * facing, 0, true, true); drawTop(P.leg, st * facing, 0, false, true); } else drawTop(P.leg, 0, legs[0] && legs[1] ? legs[0] : 0, false, true); }
  else { if (P.legL) drawTop(P.legL, 0, legs[0], false, true); if (P.legR) drawTop(P.legR, 0, legs[1], false, true); }
  // torso
  let waveArm = null;
  if (F.wave !== undefined && kind === 'human') waveArm = facing > 0 || dir === 'NE' || dir === 'SE' ? 'armL' : 'armR';
  for (let y = 0; y < g.h; y++) for (let x = 0; x < g.w; x++) { const i = y * g.w + x; if (rig.partOf[i] === 0 && g.px[i] >= 0) put(x + ox + tdx, y + oyBase + b + oy, g.px[i]); }
  if (kind === 'human') {
    const a = F.arms || [0, 0];
    if (P.armL && waveArm !== 'armL') drawTop(P.armL, 0, b + a[0], false);
    if (P.armR && waveArm !== 'armR') drawTop(P.armR, 0, b + a[1], false);
    if (waveArm) {   // the sheet's own arm, flipped upward, swaying a pixel
      const p = P[waveArm];
      if (p) {
        const sway = F.wave ? (waveArm === 'armL' ? -1 : 1) : 0;
        for (let y = p.r0; y <= p.r1; y++) for (let x = p.x0; x <= p.x1; x++) {
          const i = y * g.w + x; if (!p.mask[i]) continue;
          const ny = 2 * p.r0 - y - 2 + (y - p.r0 > (p.r1 - p.r0) / 2 ? sway * 0 : 0);
          const nx = x + (y - p.r0 > (p.r1 - p.r0) / 2 ? sway : 0);
          put(nx + ox, ny + oyBase + b + oy, g.px[i]);
        }
      }
    }
  }
  if (waveArm) {   // close the torso edge where the arm used to hang
    for (let y = 1; y < H - 1; y++) for (let x = 1; x < W - 1; x++) {
      const v = buf[y*W+x]; if (v < 0 || v === R.outline) continue;
      if (buf[y*W+x-1] < 0 || buf[y*W+x+1] < 0) buf[y*W+x] = R.outline;
    }
  } else {
    const a = F.cat || [0, 0];
    if (P.armL) drawBoth(P.armL, 0, a[0], b);
    if (P.armR) drawBoth(P.armR, 0, a[1], b);
  }
  const img = new Uint32Array(W * H);
  if (shadow) {
    const front = ANIMS; void front;
    const rx = Math.max(9, Math.round(g.w * (kind === 'human' ? 0.38 : 0.42))), ry = kind === 'human' ? 3 : 3.5;
    const k = clamp(1 + oy * 0.04, 0.6, 1), cx = W / 2, cy = CELL.ground - 1.5;
    const col = (66 << 24) | (44 << 16) | (66 << 8) | 92;
    for (let y = Math.floor(cy - ry * k); y <= Math.ceil(cy + ry * k); y++) for (let x = Math.floor(cx - rx * k); x <= Math.ceil(cx + rx * k); x++) { const nx = (x + .5 - cx) / (rx * k), ny = (y + .5 - cy) / (ry * k); if (nx*nx + ny*ny <= 1 && x >= 0 && y >= 0 && x < W && y < H) img[y*W+x] = col >>> 0; }
  }
  const packed = pal.map(hx => { const [r, g2, bb] = hex2rgb(hx); return ((255 << 24) | (bb << 16) | (g2 << 8) | r) >>> 0; });
  const dark = pal.map(hx => { const [r, g2, bb] = hex2rgb(hx).map((v, j) => v * [0.8, 0.78, 0.84][j]); return ((255 << 24) | (Math.round(bb) << 16) | (Math.round(g2) << 8) | Math.round(r)) >>> 0; });
  for (let i = 0; i < W * H; i++) { const v = buf[i]; if (v >= 0) img[i] = shadeBuf[i] ? dark[v] : packed[v]; }
  return img;
}

/* public: cached frames per recipe */
function makeCharacter(rec) {
  const pal = paletteFor(rec), grids = {}, rigs = {}, cache = new Map();
  const grid = (dir, blink) => { const k = dir + (blink ? 'b' : ''); if (!grids[k]) grids[k] = rec.kind === 'human' ? humanGrid(rec, dir, blink) : creatureGrid(rec, dir, blink); return grids[k]; };
  const rig = (dir, blink) => { const k = dir + (blink ? 'b' : ''); if (!rigs[k]) { const g = grid(dir, blink); rigs[k] = rec.kind === 'human' ? rigHuman(g, dir) : rigCreature(g, dir); } return rigs[k]; };
  return {
    rec, pal,
    frame(dir, anim, fi, opt = {}) {
      const key = dir + '|' + anim + '|' + fi + '|' + (opt.blink ? 1 : 0) + (opt.shadow ? 1 : 0);
      let f = cache.get(key);
      if (!f) { const g = grid(dir, opt.blink); f = animate(g, rig(dir, opt.blink), rec.kind, dir, anim, fi, pal, opt.shadow); cache.set(key, f); }
      return f;
    },
    topY(dir) { const g = grid(dir, false); return CELL.ground - g.h; },
  };
}

loadBase(BASEDATA);

/* ---------- recipes ---------- */
const HUMAN_BASE = { kind:'human', name:'Hero', age:'kid', build:'regular', skin:'#fdc58d', hair:'spiky', hairColor:'#834f40', eyes:'dots', blush:true, freckles:false, glasses:false, facial:'none',
  top:'sweater', topColor:'#d1262b', emblem:'heart', emblemColor:'#fcefd4', bottom:'jeans', bottomColor:'#4d78b8', shoes:'sneakers', shoeColor:'#faf8f0', hat:'none', hatColor:'#3e5ba9', emote:'none' };
const CREATURE_BASE = { kind:'creature', name:'Friend', shape:'cat', color:'#fcecd3', ears:'cat', top:'none', pattern:'none', patternColor:'#a8743a', eyes:'round', mouth:'tongue', nose:true, blush:false, emote:'none' };
const HUMAN_PRESETS = [
  { name:'Original boy', set:{} },
  { name:'Girl', set:{ hair:'long', hairColor:'#3b2318', eyes:'lashes', top:'dress', topColor:'#e8607a', emblem:'heart', emblemColor:'#fff4e0', hat:'bow', hatColor:'#ffd25e', skin:'#e8a877' } },
  { name:'Teen', set:{ age:'teen', hair:'ponytail', hairColor:'#e0ad55', eyes:'sparkle', top:'hoodie', topColor:'#3f6d6b', emblem:'none', bottom:'shorts', bottomColor:'#2f3b55', hat:'cap', hatColor:'#c8242c', skin:'#8d5a3b' } },
  { name:'Man', set:{ age:'adult', build:'broad', hair:'short', hairColor:'#2b2329', facial:'beard', top:'tshirt', topColor:'#2f8a5e', emblem:'none', bottomColor:'#3e4f73', skin:'#c58556' } },
  { name:'Woman', set:{ age:'adult', hair:'bob', hairColor:'#c45d2a', eyes:'lashes', top:'sweater', topColor:'#f0b52f', emblem:'heart', emblemColor:'#c8242c', bottom:'skirt', bottomColor:'#2f3b55', shoes:'boots', shoeColor:'#6b3f2a', skin:'#fbd3ac', freckles:true } },
  { name:'Grandpa', set:{ age:'elder', hair:'bald', hairColor:'#cfcac2', facial:'mustache', glasses:true, top:'sweater', topColor:'#4a6b8a', emblem:'none', bottomColor:'#6b5a48', shoeColor:'#6b4a3a', eyes:'sleepy' } },
  { name:'Grandma', set:{ age:'elder', hair:'buns', hairColor:'#e4e0d8', glasses:true, eyes:'happy', top:'cardigan', topColor:'#c97b8e', emblemColor:'#f4efe6', bottom:'skirt', bottomColor:'#5a5e6b', shoeColor:'#6b4a3a', skin:'#e8a877' } },
];
const CREATURE_PRESETS = [
  { name:'Cat', set:{} },
  { name:'Frog', set:{ shape:'round', color:'#8fcf7a', ears:'none', top:'daisy', mouth:'smile', nose:false } },
  { name:'Potato', set:{ shape:'oval', color:'#e3b768', ears:'none', pattern:'spots', patternColor:'#a8743a', eyes:'side', mouth:'open', nose:false } },
  { name:'Pumpkin', set:{ color:'#f6ecd3', top:'stem', eyes:'happy', mouth:'jack', nose:false } },
  { name:'Mushroom', set:{ shape:'round', ears:'none', top:'mushroom', color:'#f3e6d2', mouth:'smile', blush:true } },
  { name:'Bunny', set:{ ears:'bunny', color:'#ffffff', mouth:'cat', blush:true } },
  { name:'Bear', set:{ shape:'round', ears:'bear', color:'#b07d58', pattern:'belly', patternColor:'#e6c9a3', eyes:'dots', mouth:'smile' } },
  { name:'Sprout', set:{ shape:'round', ears:'none', top:'sprout', color:'#cfe8b0', mouth:'cat', blush:true } },
];
const SKINS = ['#ffe0c2','#fdc58d','#fbd3ac','#e8a877','#c58556','#8d5a3b','#5e3a28'];
const HAIRS = ['#834f40','#3b2318','#2b2329','#c45d2a','#e0ad55','#e4e0d8','#cfcac2','#5b6a8a','#8e4fb0','#e8607a'];
const CLOTH = ['#d1262b','#f0b52f','#2f8a5e','#3f6d6b','#4d78b8','#3e5ba9','#8e4fb0','#e8607a','#c97b8e','#f4efe6','#5a5e6b','#2f3b55'];
const FURS = ['#fcecd3','#ffffff','#8fcf7a','#cfe8b0','#e3b768','#f6ecd3','#f3e6d2','#b07d58','#cfd3dc','#f8c1a6','#bcd6f5','#4a4366'];
const PATTERN_COLS = ['#a8743a','#e6c9a3','#6b4a3a','#ffffff','#f6a091','#4f9a49'];

/* ===== Tiny Town portrait extension =====
   Portraits are drawn from the studio's own grid (no animation cell), with headroom for tall hats,
   coloured eyes and headwear drawn the way addHat draws its caps: masks from the head landmarks,
   one outline ring, three tones, and the brim, crest or knot pushed by FACING so SE and SW turn. */
for (const n of ['trim','trimDark','trimLight','acc','accDark','accLight','iris','irisDark','irisLight','glint','maskC','maskDark','lens'])
  if (R[n] == null) { R[n] = RL.length; RL.push(n); }

function palX(rec) {
  const P = paletteFor(rec);
  const t = rec.trimColor || rec.hatColor, a = rec.accColor || t, ir = rec.irisColor || '#6b4a3a';
  if (rec.hatShade) P[R.hatDark] = rec.hatShade;
  P[R.trim] = t; P[R.trimDark] = shade(t, -0.13, 0.03); P[R.trimLight] = shade(t, 0.1);
  P[R.acc] = a; P[R.accDark] = shade(a, -0.14, 0.03); P[R.accLight] = shade(a, 0.12);
  P[R.iris] = ir; P[R.irisDark] = rec.irisDark || shade(ir, -0.16, 0.04); P[R.irisLight] = rec.irisLight || shade(ir, 0.2);
  P[R.glint] = '#ffffff';
  P[R.maskC] = rec.maskColor || '#3a3436'; P[R.maskDark] = shade(P[R.maskC], -0.1);
  P[R.lens] = '#3a3f52';
  return P;
}

/* ---------- eyes: lid line, iris in the eye colour, a catch-light ---------- */
function colorEyes(g, rec, dir, L) {
  if (rec.eyes === 'happy' || rec.eyes === 'sleepy') return;
  const w = g.w;
  for (const e of L.eyes) {
    const H = e.y1 - e.y0 + 1, wide = e.x1 > e.x0;
    for (const j of e.cells) {
      const x = j % w, y = (j / w) | 0, r = y - e.y0;
      g.px[j] = r === 0 ? R.outline : r === 1 ? R.irisDark : r >= H - 1 ? R.irisLight : R.iris;
    }
    // the lid reaches across the top of the eye
    for (let x = e.x0; x <= e.x1; x++) { const j = (e.y0 + 1) * w + x; if (L.eyeMask[j] && !L.eyeMask[e.y0 * w + x]) g.px[j] = R.outline; }
    // pupil: a darker column down the middle of wide eyes
    if (wide && e.x1 - e.x0 >= 2) { const px = Math.round((e.x0 + e.x1) / 2) + (FACING[dir] > 0 ? 1 : FACING[dir] < 0 ? -1 : 0); for (let y = e.y0 + 2; y < e.y1; y++) { const j = y * w + px; if (L.eyeMask[j] && g.px[j] === R.iris) g.px[j] = R.irisDark; } }
    // catch-light, upper left inside the lid
    let hx = e.x0, hy = e.y0 + 1; while (hy <= e.y1 && !L.eyeMask[hy * w + hx]) hx++;
    if (!L.eyeMask[hy * w + hx] || g.px[hy * w + hx] === R.outline) hy++;
    if (L.eyeMask[hy * w + hx]) g.px[hy * w + hx] = R.glint;
    if (rec.eyes === 'sparkle' && wide) { const j = (e.y1 - 1) * w + e.x1; if (L.eyeMask[j]) g.px[j] = R.glint; }
  }
}

/* ---------- headroom ---------- */
const PADX = 8, PADY = 14;
function padGrid(g) {
  const W = g.w + 2 * PADX, H = g.h + PADY, n = new G(W, H);
  for (let y = 0; y < g.h; y++) for (let x = 0; x < g.w; x++) n.px[(y + PADY) * W + x + PADX] = g.px[y * g.w + x];
  return n;
}
function shiftL(L, w, h) {
  const W = w + 2 * PADX, H = h + PADY, o = {};
  const mm = m => { const n = new Uint8Array(W * H); for (let i = 0; i < m.length; i++) if (m[i]) n[(((i / w) | 0) + PADY) * W + (i % w) + PADX] = 1; return n; };
  const bb = b => b && Object.assign({}, b, { x0: b.x0 + PADX, x1: b.x1 + PADX, cx: b.cx + PADX, y0: b.y0 + PADY, y1: b.y1 + PADY, cy: b.cy + PADY });
  for (const k in L) {
    const v = L[k];
    if (v instanceof Uint8Array && v.length === w * h) o[k] = mm(v);
    else if (k === 'eyes') o[k] = v.map(e => ({ x0: e.x0 + PADX, x1: e.x1 + PADX, y0: e.y0 + PADY, y1: e.y1 + PADY, cells: e.cells.map(j => (((j / w) | 0) + PADY) * W + (j % w) + PADX) }));
    else if (v && typeof v === 'object' && 'x0' in v) o[k] = bb(v);
    else if (['shoulder', 'hip', 'shoeTop', 'chin', 'eyeRow'].includes(k)) o[k] = v + PADY;
    else if (['bodyCx', 'coreL', 'coreR'].includes(k)) o[k] = v + PADX;
    else o[k] = v;
  }
  return o;
}

/* ---------- hat helpers ---------- */
function hatKit(g, L, dir) {
  const w = g.w, h = g.h, sb = L.sb, fac = FACING[dir];
  const at = k => Math.round(sb.y0 + sb.h * k);
  const M = shapes => raster(w, h, shapes);
  const crownOf = (band, grow) => mAnd(mOr(M([Ell(sb.cx, sb.cy + 1, sb.w / 2 + grow - 0.5, sb.h / 2 + grow)]), mAnd(dilate(L.skull, w, h, grow), M([{ t: 'below', y: sb.y0 + 4 }]))), M([{ t: 'above', y: band + 0.5 }]));
  const flatten = (band, keep) => { for (let y = 0; y < band; y++) for (let x = 0; x < w; x++) { const v = g.get(x, y); if ((HAIR.has(v) || v === R.outline) && !keep[y * w + x]) g.set(x, y, -1); } };
  // three tones: light top-left rim, dark bottom-right rim and a soft shadow on the far third
  const tones = (m, base, dark, light, opt = {}) => {
    const b = bbox(m, w, h), shadeX = opt.noShadow ? 1e9 : b.x0 + b.w * 0.74, shadeX0 = -1;
    return (x, y) => {
      const on = (a, c) => a >= 0 && c >= 0 && a < w && c < h && m[c * w + a];
      if (!on(x, y + 1) || !on(x + 1, y)) return dark;
      if (!on(x, y - 1) || !on(x - 1, y)) return light;
      if (x >= shadeX || x <= shadeX0) return dark;
      return base;
    };
  };
  const eyeGuard = (v, x, y) => !!L.eyeMask[y * w + x];
  /* headgear rule: anything attached to the sides or back sits on a ring around the head that turns with
     the facing. deg is measured from the nose (0 front, 90 the character's left, -90 right, 180 back).
     Screen x follows sin, and depth tips the ring: near points drop, far points rise (top-down camera). */
  const psi = fac * 42 * Math.PI / 180, hrx = sb.w / 2, rz = Math.max(3, sb.w * 0.14), tilt = rz / hrx;
  const ring = (deg, y, r = 1) => {
    const p = deg * Math.PI / 180 + psi, ox = Math.sin(p), oy = Math.cos(p) * 0.8, n = Math.hypot(ox, oy) || 1;
    return { x: sb.cx + hrx * r * Math.sin(p), y: y + rz * r * Math.cos(p), depth: Math.cos(p), out: [ox / n, oy / n], fwd: [Math.sin(psi), Math.cos(psi) * tilt], scale: 1 + Math.cos(p) * 0.12 };
  };
  // points in the attachment's own frame: u outward from the head, v up, f toward the face
  const place = (a, pts) => pts.map(([u, v, f = 0]) => { u *= a.scale; v *= a.scale; return [a.x + u * a.out[0] + f * a.fwd[0], a.y + u * a.out[1] + f * a.fwd[1] - v]; });
  // side pieces (horns, fins): sit on the head's edges; in a three-quarter view the near one drops and swings
  // toward the viewer, the far one rises and swings back, so the pair lies along the SW-NE (or SE-NW) axis
  const side = (s, y) => {
    const near = fac ? (s === -fac ? 1 : -1) : 0, a = 22 * Math.PI / 180;
    return { x: sb.cx + s * (hrx - 1), y: y + near * rz * 0.55, depth: near, out: [s * Math.cos(near ? a : 0), near * Math.sin(a)], fwd: [Math.sin(psi), Math.cos(psi) * tilt], scale: 1 + near * 0.08 };
  };
  const ex = L.eyes.length >= 2 ? (L.eyes[0].x0 + L.eyes[L.eyes.length - 1].x1) / 2 : sb.cx + fac * 4;
  const bandAt = (band, x) => band + Math.round(rz * 0.5 * Math.sqrt(Math.max(0, 1 - ((x - sb.cx) / (hrx + 1)) ** 2)));
  return { w, h, sb, fac, at, M, crownOf, flatten, tones, eyeGuard, cx: sb.cx + fac * 1.5, ring, side, place, front: ex, bandAt };
}
/* ===== Tiny Town portraits v2 =====
   The studio's face is kept exactly. Around it: a smooth bald head, our own hairstyles (clean shapes,
   one outline, shine arc, strand lines), facial hair placed from the real mouth, neckwear, masks,
   and helmets that share one build. SW is the SE portrait mirrored, so both eyes always show. */
for (const n of ['stub', 'neck', 'neckDark', 'neckLight', 'neckAcc', 'tie', 'frame', 'maskLight', 'tear', 'tearL', 'heartC', 'heartD'])
  if (R[n] == null) { R[n] = RL.length; RL.push(n); }
const mixHex = (a, b, t) => { const A = hex2rgb(a), B = hex2rgb(b); return rgb2hex(A.map((v, i) => v + (B[i] - v) * t)); };
function palTT(rec) {
  const P = palX(rec);
  for (const [k, v] of Object.entries(rec.palOverride || {})) if (v && R[k] != null) P[R[k]] = v;
  P[R.stub] = mixHex(P[R.skin], P[R.hairDark], 0.4);
  const nc = rec.neckColor || '#db614f';
  P[R.neck] = nc; P[R.neckDark] = rec.neckShade || shade(nc, -0.13, 0.03); P[R.neckLight] = shade(nc, 0.1); P[R.neckAcc] = rec.neckAcc || '#fbf7ee';
  P[R.tear] = '#8fc7ec'; P[R.tearL] = '#e6f6fc'; P[R.heartC] = '#f5777d'; P[R.heartD] = '#db614f';
  P[R.tie] = rec.tieColor || '#f5777d'; P[R.frame] = rec.frameColor || OUT; P[R.maskLight] = shade(P[R.maskC], 0.08);
  return P;
}

/* the studio marks the neck shadow as the mouth; the real mouth is the widest mouth-coloured run on the face */
function realMouth(g, L) {
  const w = g.w; let best = null;
  for (const c of comps(maskOf(g, (v, x, y) => v === R.mouth && y > L.eyeRow + 3 && y < L.shoulder - 3), w, g.h)) {
    const xs = c.map(j => j % w), ys = c.map(j => (j / w) | 0);
    const b = { x0: Math.min(...xs), x1: Math.max(...xs), y0: Math.min(...ys), y1: Math.max(...ys) }; b.w = b.x1 - b.x0 + 1;
    if (!best || b.w > best.w) best = b;
  }
  if (best) { best.cx = (best.x0 + best.x1) / 2; best.cy = (best.y0 + best.y1) / 2; }
  return best;
}

/* a smooth cranium: an ellipse over the eyes, the jaw below, the face itself always inside */
function smoothSkull(L, w, h) {
  const E = L.eyeRow, fb = bbox(L.face, w, h);
  let xl = 1e9, xr = -1; for (let x = 0; x < w; x++) if (L.blob[(E - 2) * w + x]) { xl = Math.min(xl, x); xr = Math.max(xr, x); }
  const cx = (xl + xr) / 2, rx = (xr - xl) / 2 + 0.3, top = L.sb.y0 + 0.5, cy = E - 1, ry = cy - top;
  let chin = fb.y1; for (let y = fb.y1; y > E; y--) { let n = 0; for (let x = 0; x < w; x++) if (L.face[y * w + x]) n++; if (n >= 6) { chin = y; break; } }
  const up = mAnd(raster(w, h, [Ell(cx, cy, rx, ry)]), raster(w, h, [{ t: 'above', y: cy + 0.5 }]));
  const lo = mAnd(mAnd(raster(w, h, [Ell(cx, cy, rx - 0.6, chin - cy + 1)]), raster(w, h, [{ t: 'below', y: cy - 0.5 }])), raster(w, h, [{ t: 'above', y: chin - 1.5 }]));
  return { S: mOr(mOr(up, lo), L.face), cx, rx, ry, top, cy, chin, xl, xr };
}
function baldSmooth(base, L, S) {
  const g = base.clone(), w = g.w;
  const nearHair = (x, y) => N8.some(([dx, dy]) => HAIR.has(base.get(x + dx, y + dy)));
  const nearSkinOut = (x, y) => N8.some(([dx, dy]) => { const v = base.get(x + dx, y + dy); return SKIN.has(v) && !S[(y + dy) * w + x + dx]; });
  for (let y = 0; y < L.shoulder; y++) for (let x = 0; x < w; x++) {
    const i = y * w + x, v = base.px[i];
    if (L.eyeMask[i]) continue;
    if (S[i]) { if (v < 0 || HAIR.has(v)) g.px[i] = R.skin; else if (v === R.outline && nearHair(x, y)) g.px[i] = R.skin; }
    else if (v >= 0) { if (HAIR.has(v)) g.px[i] = -1; else if (v === R.outline && !nearSkinOut(x, y) && nearHair(x, y)) g.px[i] = -1; }
  }
  // nothing but the head above the eyes: drop stray spike tips left from the sheet's hair
  for (let y = 0; y < L.eyeRow - 2; y++) for (let x = 0; x < w; x++) { const i = y * w + x; if (!S[i] && g.px[i] >= 0 && !N8.some(([dx, dy]) => S[(y + dy) * w + x + dx])) g.px[i] = -1; }
  // the sheet shades the forehead under its bangs; without that hair the shadow reads as a phantom hairline
  for (let y = 0; y < L.eyeRow - 1; y++) for (let x = 0; x < w; x++) { const i = y * w + x; if (S[i] && !L.eyeMask[i] && (g.px[i] === R.skinShade || g.px[i] === R.blush || g.px[i] === R.mouth)) g.px[i] = R.skin; }
  for (let y = 0; y < L.eyeRow - 1; y++) for (let x = 0; x < w; x++) { const i = y * w + x; if (S[i] && g.px[i] === R.outline && !L.eyeMask[i] && N4.filter(([dx, dy]) => g.get(x + dx, y + dy) === R.skin).length >= 3) g.px[i] = R.skin; }
  reoutline(g, [0, L.shoulder]);
  return g;
}

/* face columns: where the hair must not cover */
function faceCols(L) {
  const e = L.eyes;
  if (e.length >= 2) return { fx0: e[0].x0 - 4, fx1: e[e.length - 1].x1 + 4 };
  if (e.length === 1) return { fx0: e[0].x0 - 5, fx1: e[0].x1 + 9 };
  return { fx0: L.sb.cx - 9, fx1: L.sb.cx + 9 };
}

/* ---------- hair ---------- */
const TT_HAIR = {
  //          volume, bangs line,          sides (front, back),    panel bottom,     extras
  bob:       { gr: 1.6, bang: 'flat2', side: ['chin', 'chin'], panel: 'chin' },
  long:      { gr: 1.6, bang: 'part2', side: ['chin', 'chin'], panel: 'long' },
  spiky:     { gr: 1.4, bang: 'teeth3', side: [1, 'nape'], spikes: 'big' },
  short:     { gr: 1.3, bang: 'teeth4', side: [-1, 'nape'], spikes: 'small' },
  crop:      { gr: 1.0, bang: 'flat5', side: [-2, 'nape'] },
  swept:     { gr: 1.4, bang: 'sweep', side: [1, 'nape'] },
  topbun:    { gr: 1.3, bang: 'partV', side: [2, 'nape'], bun: 'top' },
  granbun:   { gr: 1.5, bang: 'wave4', side: [2, 'nape'], bun: 'back', curly: true },
  topknot:   { gr: 1.0, bang: 'flat6', side: [-3, 'nape'], bun: 'knot' },
  fluffy:    { gr: 2.4, bang: 'scallop', side: [4, 'chin'], curly: true },
  twintails: { gr: 1.5, bang: 'flat2', side: [2, 'chin'], tails: true },
  braid:     { gr: 1.5, bang: 'side', side: [3, 'chin'], braid: true },
  tufts:     { tufts: true },
  bald:      {},
};
function hairPaint(m, w, h, E, hb, fac, opt = {}) {
  const shx = hb.cx - 2 - fac * 3, shy = hb.y0 + (E - hb.y0) * 0.58, srx = hb.w * 0.34, sry = (E - hb.y0) * 0.42;
  return (x, y) => {
    const on = (a, c) => a >= 0 && c >= 0 && a < w && c < h && m[c * w + a];
    if (!on(x, y + 1)) return R.hairDark;
    if (!on(x + 1, y) && !opt.noRight) return R.hairDark;
    const dx = (x - shx) / srx, dy = (y - shy) / sry, d = dx * dx + dy * dy;
    if (y < shy && d > 0.6 && d < 0.98 && x < shx + srx * 0.6 && !opt.noShine) return R.hairLight;
    if (y > E - 6 && (x % 4 === 0) && on(x, y + 2)) return R.hairDark;   // strands
    if (opt.curly && ((x + y * 2) % 7 === 0)) return R.hairDark;
    if (!on(x, y - 1) && !opt.noShine) return R.hairLight;
    return R.hair;
  };
}
function ttHair(g, rec, dir, L, H) {
  const sty = TT_HAIR[rec.ttHair] || TT_HAIR.short; if (!rec.ttHair || rec.ttHair === 'bald') return;
  const w = g.w, h = g.h, E = L.eyeRow, fac = FACING[dir], S = L.skull;
  const M = sh => raster(w, h, sh), above = y => M([{ t: 'above', y }]), below = y => M([{ t: 'below', y }]);
  const { fx0, fx1 } = faceCols(L), span = fx1 - fx0, chin = H.chin, back = !!BACK[dir];
  const hb = { x0: H.xl, x1: H.xr, y0: Math.round(H.top), w: H.xr - H.xl + 1, cx: H.cx };
  const behind = [], extra = [];
  let over = new Uint8Array(w * h);
  if (sty.tufts) {
    for (const s of [-1, 1]) if (!(fac && s === fac)) over = mOr(over, M([Ell(s < 0 ? H.xl + 1.5 : H.xr - 1.5, E - 1, 3.2, 3.8)]));
    over = mSub(over, dilate(L.eyeMask, w, h, 2));
  } else {
    const gr = sty.gr;
    // cap over the head down to the eye line
    let cap = mAnd(dilate(S, w, h, gr), above(E - 0.5));
    if (sty.curly) { const bumps = []; for (let a = -170; a <= -10; a += 20) { const t = a * Math.PI / 180; bumps.push(Ell(H.cx + Math.cos(t) * (H.rx + gr - 1), H.cy + Math.sin(t) * (H.ry + gr - 1), sty.gr >= 2 ? 2.8 : 2.2)); } cap = mOr(cap, mAnd(M(bumps), above(E - 3))); }
    // forehead: the hairline over the face columns
    const t = x => (x - fx0) / span;
    const line = x => {
      const k = Math.round(x);
      switch (sty.bang) {
        case 'flat2': return E - 2 - (k % 4 === 1 ? 1 : 0);
        case 'part2': return E - 2 - Math.max(0, 3 - Math.abs(x - (fx0 + span * 0.42)) * 1.2) - (k % 4 === 1 ? 1 : 0);
        case 'teeth3': return E - 4 + Math.abs(((k + 2) % 4) - 2);
        case 'teeth4': return E - 5 + (Math.abs(((k + 1) % 3) - 1) ? 0 : 1);
        case 'flat5': return E - 5;
        case 'flat6': return E - 7;
        case 'sweep': return E - 7 + 6 * (1 - t(x)) - (k % 4 === 1 ? 1 : 0);
        case 'partV': return E - 3 - Math.max(0, 4 - Math.abs(x - (fx0 + span * 0.45)) * 1.4);
        case 'wave4': return E - 4 - (k % 4 < 2 ? 1 : 0);
        case 'scallop': return E - 2 - (k % 5 === 0 || k % 5 === 4 ? 1 : 0);
        case 'side': return t(x) < 0.62 ? E - 2 - (k % 4 === 1 ? 1 : 0) : E - 6;
      }
      return E - 3;
    };
    // the hairline curves down into the temples instead of meeting them at a corner
    if (!back) for (let y = 0; y < h; y++) for (let x = Math.ceil(fx0) + 1; x <= Math.floor(fx1) - 1; x++) { const edge = Math.min(x - fx0, fx0 + span - x); if (y > line(x) + Math.max(0, (3 - edge) * 1.3)) cap[y * w + x] = 0; }
    over = cap;
    // sides beside the face, the back of the head in a three-quarter view
    const len = v => v === 'chin' ? chin - 1 : v === 'nape' ? chin - 3 : E + v;
    const coverL = fx0 + 2, coverR = fac > 0 ? 1e9 : fx1 - 2;
    const lenL = fac > 0 ? len(sty.side[1]) : len(sty.side[0]), lenR = len(sty.side[0]);
    const sideZone = mAnd(dilate(S, w, h, gr), below(E - 1.5));
    for (let y = E - 1; y < h; y++) for (let x = 0; x < w; x++) {
      if (!sideZone[y * w + x]) continue;
      const slant = typeof sty.side[1] === 'number' || sty.side[1] === 'nape' ? Math.max(0, y - E) * 0.5 : 0;
      if (back ? y <= len(sty.side[1]) : (x < coverL - (fac > 0 ? slant : 0) && y <= lenL) || (x > coverR && y <= lenR)) over[y * w + x] = 1;
    }
    // length below the head: hangs over the shoulders in one piece
    if (sty.panel) {
      const bot = sty.panel === 'long' ? L.shoulder + 16 : chin + 1;
      const pl = M([Rect(H.xl - gr - (sty.panel === 'long' ? 1 : 0), E - 2, back ? H.xr + gr + 1 : coverL, bot, 3)]);
      // on a full-body sprite, hair below the chin hangs behind the shoulders instead of over the body
      if (rec.spriteMode && !back) { over = mOr(over, mAnd(pl, above(chin + 1))); behind.push(mAnd(pl, below(chin))); }
      else over = mOr(over, pl);
      if (fac <= 0) { const pr = M([Rect(coverR, E - 2, H.xr + gr + (sty.panel === 'long' ? 1 : 0), bot, 3)]); if (rec.spriteMode && !back) { over = mOr(over, mAnd(pr, above(chin + 1))); behind.push(mAnd(pr, below(chin))); } else over = mOr(over, pr); }
      if (sty.panel === 'long') behind.push(M([Rect(H.xl - gr, E, H.xr + gr, bot, 4)]));
      // strand tips along the bottom
      for (let x = 0; x < w; x++) { let yb = -1; for (let y = h - 1; y > E; y--) if (over[y * w + x]) { yb = y; break; } if (yb > chin - 2 && x % 3 === 1) over[yb * w + x] = 0; }
    }
    if (sty.spikes) {
      const big = sty.spikes === 'big', tips = [];
      for (let k = -2; k <= 2; k++) {
        const bx = H.cx + k * (big ? 5.5 : 5) - fac * 1, by = H.top + 3 + Math.abs(k) * 1.5;
        tips.push(Poly([[bx - (big ? 3.4 : 2.6), by + 2], [bx + k * 1.4 - fac * 1.5, by - (big ? 7 : 3.4) + Math.abs(k) * 0.8], [bx + (big ? 3.4 : 2.6), by + 2]]));
      }
      over = mOr(over, M(tips));
    }
    if (sty.bun) {
      const bun = sty.bun === 'top' ? Ell(H.cx - fac * 2, H.top - 2, 4.6, 3.8) : sty.bun === 'back' ? Ell(H.cx - fac * 6 + (fac ? 0 : 0), H.top - 0.5, 5, 4.2) : Ell(H.cx - fac * 3, H.top - 2.2, 2.8, 2.6);
      extra.push({ m: M([bun]), tie: sty.bun === 'knot' });
    }
    if (sty.tails) for (const s of [-1, 1]) {
      // round side buns at ear height; in a three-quarter view the far one tucks behind the head
      const far = fac && s === fac, tx = (s < 0 ? H.xl - 2 : H.xr + 2) - (far ? s * 3.5 : 0);
      const bun = M([Ell(tx, E + 2, far ? 3 : 3.8, far ? 4 : 4.6)]);
      if (far) behind.push(bun); else extra.push({ m: bun, bun: true });
      if (!far) extra.push({ m: M([Ell(tx + (s < 0 ? 2.2 : -2.2), E - 2, 1.7, 1.6)]), tieOnly: true });
    }
    if (sty.braid) {
      const bx = fac > 0 ? H.xl + 1 : H.xr - 1;
      for (let i = 0; i < 7; i++) extra.push({ m: M([Ell(bx + (i % 2 ? 0.7 : -0.7), E + 3 + i * 3, 2.5, 2)]), link: true });
      extra.push({ m: M([Rect(bx - 2, E + 22, bx + 2, E + 23)]), tieOnly: true });
    }
  }
  over = mSub(over, dilate(L.eyeMask, w, h, 1));
  const hbb = Object.assign({}, hb);
  for (const m of behind) paint(g, m, hairPaint(m, w, h, E, hbb, fac, { noShine: true }), 'behind');
  paint(g, over, hairPaint(over, w, h, E, hbb, fac, { curly: sty.curly }), 'over', true, (v, x, y) => !!L.eyeMask[y * w + x]);
  for (const e of extra) {
    if (e.tieOnly) { paint(g, e.m, (x, y) => R.tie, 'over', true); continue; }
    paint(g, e.m, hairPaint(e.m, w, h, E, bbox(e.m, w, h), fac, { noShine: !!e.link, curly: !!e.bun }), 'over');
    if (e.tie) { const b = bbox(e.m, w, h); for (let x = b.x0; x <= b.x1; x++) if (g.get(x, b.y1) >= 0) g.set(x, b.y1 + 0, R.tie); }
  }
}

/* ---------- facial hair ---------- */
function ttBeard(g, rec, dir, L, H) {
  const fh = rec.ttBeard, Mo = L.mouth; if (!fh || fh === 'none' || !Mo) return;
  const w = g.w, h = g.h, E = L.eyeRow, chin = H.chin, { fx0, fx1 } = faceCols(L);
  const isSkin = v => v === R.skin || v === R.skinShade || v === R.blush;
  const mb = L.mouthBox || Mo, mouthKeep = raster(w, h, [Rect(mb.x0 - 0.5, mb.y0 - 0.5, mb.x1 + 0.5, mb.y1 + 0.5)]);
  const stache = (wide, curl) => {
    const y = Mo.y0 - 1;
    for (let x = Mo.x0 - 1 - wide; x <= Mo.x1 + 1 + wide; x++) if (g.get(x, y) >= 0) g.set(x, y, x === Mo.x0 - 1 - wide || x === Mo.x1 + 1 + wide ? R.hairDark : R.hair);
    if (curl) for (const s of [-1, 1]) { const x = s < 0 ? Mo.x0 - 2 - wide : Mo.x1 + 2 + wide; if (g.get(x, y - 1) >= 0) g.set(x, y - 1, R.hairDark); if (g.get(x + s, y - 2) >= 0) g.set(x + s, y - 2, R.hairDark); }
    else for (const x of [Mo.x0 - 1 - wide, Mo.x1 + 1 + wide]) if (isSkin(g.get(x, Mo.y0))) g.set(x, Mo.y0, R.hairDark);
  };
  if (fh === 'mustache') return stache(0, false);
  if (fh === 'handlebar') return stache(1, true);
  if (fh === 'stubble') {
    for (let y = Mo.y0 - 1; y <= chin + 1; y++) for (let x = 0; x < w; x++) if (isSkin(g.get(x, y)) && !mouthKeep[y * w + x] && (x + y * 2) % 3 === 0) g.set(x, y, R.stub);
    for (let y = E + 6; y < Mo.y0 - 1; y++) for (let x = 0; x < w; x++) if (isSkin(g.get(x, y)) && (x < fx0 + 3 || x > fx1 - 3) && (x + y * 2) % 3 === 0) g.set(x, y, R.stub);
    return;
  }
  if (fh === 'goatee') {
    stache(-1, false);
    const gm = raster(w, h, [Rect(Mo.cx - 2.2, Mo.y1 + 0.5, Mo.cx + 2.2, chin + 2.5, 1.5)]);
    paint(g, gm, (x, y) => y >= chin + 1 ? R.hairDark : R.hair, 'over', true, (v) => isSkin(v));
    return;
  }
  // beard and long beard: frame the face from the jaw, leave the mouth
  const skin = maskOf(g, (v, x, y) => isSkin(v) && y < L.shoulder);
  let B = mOr(mAnd(skin, raster(w, h, [{ t: 'below', y: Mo.y0 - 1.5 }])), mAnd(mAnd(skin, raster(w, h, [{ t: 'below', y: E + 5.5 }])), raster(w, h, [Rect(0, 0, fx0 + 3, h), Rect(fx1 - 3, 0, w, h)])));
  B = mOr(B, raster(w, h, [Ell(Mo.cx, chin + 1, span2(fx0, fx1), 3)]));
  if (fh === 'longbeard') B = mOr(B, raster(w, h, [Poly([[Mo.cx - span2(fx0, fx1), chin], [Mo.cx + span2(fx0, fx1), chin], [Mo.cx + 1, chin + 10], [Mo.cx - 1, chin + 10]])]));
  B = mSub(B, mouthKeep);
  paint(g, B, (x, y) => {
    const on = (a, c) => B[c * w + a];
    if (!on(x, y + 1)) return R.hairDark;
    if (y >= chin && (x + y) % 3 === 0) return R.hairDark;
    if (!on(x, y - 1)) return R.hairLight;
    return (x * 2 + y) % 7 === 0 ? R.hairDark : R.hair;
  }, 'over', true, (v, x, y) => isSkin(v) || !!L.eyeMask[y * w + x] || mouthKeep[y * w + x] === 1);
  stache(0, false);
}
const span2 = (a, b) => (b - a) * 0.36;

/* ---------- neckwear ---------- */
function ttNeck(g, rec, dir, L) {
  const nw = rec.neckwear; if (!nw || nw === 'none') return;
  const w = g.w, h = g.h, SH = L.shoulder, fac = FACING[dir], M = sh => raster(w, h, sh);
  let nx0 = 1e9, nx1 = -1; for (let x = 0; x < w; x++) { const v = g.get(x, SH - 1); if (v === R.skin || v === R.skinShade || v === R.mouth) { nx0 = Math.min(nx0, x); nx1 = Math.max(nx1, x); } }
  if (nx1 < 0) { nx0 = L.sb.cx - 3; nx1 = L.sb.cx + 3; }
  const cx = (nx0 + nx1) / 2;
  const cloth = (m, mode) => paint(g, m, (x, y) => { const on = (a, c) => m[c * w + a]; return !on(x, y + 1) || !on(x + 1, y) ? R.neckDark : !on(x, y - 1) ? R.neckLight : R.neck; }, mode || 'over');
  if (nw === 'scarf' || nw === 'bluescarf') {
    const side = fac > 0 ? -1 : 1, tx = cx + side * 4;
    const wrap = M([Rect(nx0 - 7, SH - 2.5, nx1 + 7, SH + 2.5, 2.5)]);
    cloth(wrap);
    for (let x = Math.round(nx0 - 6); x <= nx1 + 6; x++) if ((x - nx0) % 4 === 0) for (const y of [SH - 1, SH]) if (g.get(x, y) === R.neck) g.set(x, y, R.neckDark);
    const tail = M([Poly([[tx - 2.5, SH], [tx + 2.5, SH], [tx + 3 + side, SH + 8], [tx - 2 + side, SH + 8]])]);
    cloth(tail);
    for (let y = SH + 3; y < SH + 9; y += 3) for (let x = Math.round(tx - 2); x <= Math.round(tx + 3); x++) if (tail[y * w + x] && g.get(x, y) === R.neck) g.set(x, y, R.neckAcc);
    paint(g, M([Ell(tx, SH + 0.5, 2.2, 1.8)]), (x, y) => y > SH + 0.5 ? R.neckDark : R.neck, 'over', true);
  } else if (nw === 'kerchief') {
    cloth(M([Poly([[nx0 - 3.5, SH - 1.5], [nx1 + 3.5, SH - 1.5], [cx + fac, SH + 6]])]));
    cloth(M([Rect(nx0 - 2.5, SH - 2, nx1 + 2.5, SH - 0.5, 1)]));
  } else if (nw === 'bowtie') {
    const y = SH + 1;
    cloth(M([Poly([[cx, y], [cx - 4.5, y - 2.5], [cx - 4.5, y + 2.5]]), Poly([[cx, y], [cx + 4.5, y - 2.5], [cx + 4.5, y + 2.5]])]));
    paint(g, M([Ell(cx, y, 1.3, 1.3)]), () => R.neckDark, 'over', true);
  } else if (nw === 'amulet') {
    const py = SH + 6;
    for (let x = Math.round(nx0 - 2); x <= Math.round(nx1 + 2); x++) { const y = Math.round(SH - 1 + (1 - Math.abs(x - cx) / ((nx1 - nx0) / 2 + 2)) * 5); if (g.get(x, y) >= 0) g.set(x, y, R.neck); }
    paint(g, M([Ell(cx, py, 2, 2.4)]), (x, y) => y < py - 0.5 && x < cx ? R.glint : R.neckAcc, 'over', true);
  } else if (nw === 'mantle') {
    const bx0 = L.coreL - 5, bx1 = L.coreR + 5;
    const cape = mSub(M([Rect(bx0, SH - 2, bx1, SH + 12, 4)]), M([Poly([[nx0 - 1, SH - 3], [nx1 + 1, SH - 3], [cx, SH + 5]])]));
    cloth(cape);
    paint(g, M([Ell(cx, SH + 4, 1.8, 1.6)]), (x, y) => x < cx ? R.glint : R.neckAcc, 'over', true);
  }
}

/* ---------- masks, glasses and patches ---------- */
function ttFaceWear(g, rec, dir, L, H) {
  const fw = rec.faceWear; if (!fw || fw === 'none' || BACK[dir]) return;
  const w = g.w, h = g.h, E = L.eyeRow, Mo = L.mouth, chin = H.chin, { fx0, fx1 } = faceCols(L);
  const isSkin = v => SKIN.has(v), eyeG = (v, x, y) => !!L.eyeMask[y * w + x];
  const eyeBot = L.eyes.length ? Math.max(...L.eyes.map(e => e.y1)) : E + 4;
  if (fw === 'menpo' && Mo) {
    const top = Math.max(Mo.y0 - 2.5, eyeBot + 2.5), cxm = Mo.cx, fac = FACING[dir];   // never over the eyes
    const faceOnly = maskOf(g, (v, x, y) => (SKIN.has(v) || v === R.stub) && y < L.shoulder && x > fx0 - 3 && x < fx1 + 3);
    const plate = mAnd(raster(w, h, [Rect(fx0 - 2, top, fx1 + 2, chin + 0.5, 2)]), faceOnly);
    const nx = Math.round(cxm + fac * 1.5), pb0 = bbox(plate, w, h);
    paint(g, plate, (x, y) => {
      const on = (a, c) => plate[c * w + a];
      if (!on(x, y - 1)) return R.maskLight;
      if (!on(x, y + 1) || !on(x + 1, y)) return R.maskDark;
      if (y < Mo.y0 - 1 && x === nx) return R.maskLight;
      if (y < Mo.y0 - 1 && x === nx + 1) return R.maskDark;
      return R.maskC;
    }, 'over', true, eyeG);
    // closed mouth slit and a lacquer shine
    for (let x = Mo.x0; x <= Mo.x1; x++) if (plate[Mo.y0 * w + x]) g.set(x, Mo.y0, R.outline);
    const sx = pb0.x0 + 2, sy = Math.round(top + 2); if (plate[sy * w + sx]) g.set(sx, sy, R.glint);
    // cords tying it behind the ears
    const pb = bbox(plate, w, h);
    for (const [x0, s] of [[pb.x0 - 1, -1], [pb.x1 + 1, 1]]) { if (fac && s === fac) continue; for (let k = 0; k < 3; k++) { const x = x0 + s * k, y = Math.round(top + 1 - k * 0.6); if (g.get(x, y) >= 0) g.set(x, y, R.outline); } }
    return;
  }
  if (fw === 'mask' || fw === 'menpo') {
    const top = fw === 'mask' ? eyeBot + 1.5 : (Mo ? Mo.y0 - 2.5 : eyeBot + 2.5);
    const skin = maskOf(g, (v, x, y) => (isSkin(v) || v === R.stub) && y < L.shoulder && x > fx0 - 3 && x < fx1 + 3);
    const cxm = Mo ? Mo.cx : (fx0 + fx1) / 2;
    let m = mOr(mAnd(skin, raster(w, h, [{ t: 'below', y: top }])), raster(w, h, [Ell(cxm, chin + 1, span2(fx0, fx1) + 1, 2.6)]));
    paint(g, m, (x, y) => { const on = (a, c) => m[c * w + a]; return !on(x, y - 1) ? R.maskLight : !on(x, y + 1) || !on(x + 1, y) ? R.maskDark : R.maskC; }, 'over', true, (v, x, y) => fw === 'mask' && isSkin(v) && y < top + 1 || eyeG(v, x, y));
    if (fw === 'menpo' && Mo) {
      const y = Mo.y0;
      for (let x = Mo.x0 - 1; x <= Mo.x1 + 1; x++) if (m[y * w + x]) g.set(x, y, R.outline);
      for (let x = Mo.x0; x <= Mo.x1; x += 2) if (m[(y + 1) * w + x]) g.set(x, y + 1, R.glint);
      const ny = Math.round(top + 1), nx = Math.round(cxm + FACING[dir]);
      if (m[ny * w + nx]) g.set(nx, ny, R.maskDark);
    }
    if (fw === 'mask') { const ky = Math.round(top + 2); for (let x = 0; x < w; x++) if (m[ky * w + x] && (x % 3 === 0)) g.set(x, ky, R.maskDark); }
  }
  if ((fw === 'round' || fw === 'square') && L.eyes.length) {
    const rims = [];
    for (const e of L.eyes) {
      const r = fw === 'round' ? Ell((e.x0 + e.x1) / 2, (e.y0 + e.y1) / 2, (e.x1 - e.x0) / 2 + 2.2, (e.y1 - e.y0) / 2 + 1.8) : Rect(e.x0 - 2, e.y0 - 1, e.x1 + 2, e.y1 + 1);
      const fill = raster(w, h, [r]), ring = mSub(dilate(fill, w, h, 1), fill);
      for (let i = 0; i < w * h; i++) if (ring[i] && g.px[i] >= 0) g.px[i] = R.frame;
      const gx = e.x1 + 1, gy = e.y0; if (isSkin(g.get(gx, gy))) g.set(gx, gy, R.glint);
      rims.push(bbox(fill, w, h));
    }
    if (rims.length === 2) for (let x = rims[0].x1 + 2; x < rims[1].x0 - 1; x++) g.set(x, rims[0].y0 + 1, R.frame);
  }
  if (fw === 'shades' && L.eyes.length) {
    for (const e of L.eyes) paint(g, raster(w, h, [Rect(e.x0 - 1.5, e.y0 + 0.5, e.x1 + 1.5, e.y1 + 0.5, 1)]), (x, y) => y === e.y0 + 1 && x === e.x0 ? R.glint : R.lens, 'over', true);
    if (L.eyes.length === 2) for (let x = L.eyes[0].x1 + 2; x < L.eyes[1].x0 - 1; x++) g.set(x, L.eyes[0].y0 + 1, R.outline);
  }
  if (fw === 'eyepatch' && L.eyes.length) {
    const e = L.eyes[L.eyes.length - 1], ex = (e.x0 + e.x1) / 2;
    for (let x = Math.round(H.xl); x <= Math.round(H.xr); x++) { const y = Math.round(x < ex ? e.y0 - 1 - (ex - x) * 0.45 : e.y0 + (x - ex) * 0.15); const v = g.get(x, y); if (v >= 0 && !L.eyeMask[y * w + x]) g.set(x, y, R.outline); }
    paint(g, raster(w, h, [Ell(ex, (e.y0 + e.y1) / 2, 2.8, 3.1)]), (x, y) => x < ex - 1 && y < e.y0 + 1 ? R.maskLight : R.maskC, 'over', true);
  }
  if (fw === 'monocle' && L.eyes.length) {
    const e = L.eyes[L.eyes.length - 1], fill = raster(w, h, [Ell((e.x0 + e.x1) / 2, (e.y0 + e.y1) / 2, (e.x1 - e.x0) / 2 + 2.4, (e.y1 - e.y0) / 2 + 2)]);
    const ring = mSub(dilate(fill, w, h, 1), fill);
    for (let i = 0; i < w * h; i++) if (ring[i] && g.px[i] >= 0) g.px[i] = R.frame;
    const b = bbox(fill, w, h); for (let k = 1; k < 8; k++) { const x = b.x1 + 1 + (k > 4 ? 1 : 0), y = b.cy + 2 + k; if (g.get(x, y) >= 0 && k % 2) g.set(x, y, R.frame); }
  }
  if (fw === 'bandage' && L.eyes.length) {
    const e = L.eyes[0], bx = e.x0 - 1, by = e.y1 + 2;
    paint(g, raster(w, h, [Rect(bx - 1.5, by - 0.5, bx + 3.5, by + 2.5, 0.6)]), (x, y) => (x === Math.round(bx + 1) || y === by + 1) ? R.petalShade : R.glint, 'over', true, eyeG);
  }
}

/* ---------- the hat engine: draws a PORTRAIT_HATS recipe ---------- */
const H_chinOf = L => L._chin || L.shoulder - 2;
function hatFromSpec(g, L, dir, k, spec) {
  const { w, h, sb, fac, M, crownOf, flatten, tones, eyeGuard } = k, E = L.eyeRow;
  const back = fac ? -fac : 1, hrx = sb.w / 2;
  const band = typeof spec.band === 'number' ? k.at(spec.band) : E + (spec.band && spec.band.eyes != null ? spec.band.eyes : -4);
  const edgeK = back < 0 ? sb.x0 : sb.x1;
  const X = (v, turn, s = 1) => {
    if (typeof v === 'number') return sb.cx + v * s + fac * (turn || 0);
    const m = /^([LRFK])([+-][\d.]+)?$/.exec(v), o = m[2] ? +m[2] : 0;
    if (m[1] === 'F') return BACK[dir] ? NaN : k.front + o;
    if (m[1] === 'K') return edgeK + o * back + fac * (turn || 0);
    return (m[1] === 'L' ? sb.x0 : sb.x1) + o + fac * (turn || 0);
  };
  const Y = v => { if (typeof v === 'number') return band + v; const m = /^([TBE])([+-][\d.]+)?$/.exec(v); return { T: sb.y0, B: band, E }[m[1]] + (m[2] ? +m[2] : 0); };
  const RX = v => typeof v === 'number' ? v : v[1] === '*' ? hrx * +v.slice(2) : hrx + +v.slice(1);
  const shapeOf = (sh, s = 1) => {
    const t = sh.turn || 0, bx = (sh.back || 0) * back;
    if (sh.ell) return Ell(X(sh.ell[0], t, s) + bx, Y(sh.ell[1]), RX(sh.ell[2]), RX(sh.ell[3]));
    if (sh.rect) return Rect(X(sh.rect[0], t, s) + bx, Y(sh.rect[1]), X(sh.rect[2], t, s) + bx, Y(sh.rect[3]), sh.rect[4] || 0);
    if (sh.line) return Line(X(sh.line[0], t, s) + bx, Y(sh.line[1]), X(sh.line[2], t, s) + bx, Y(sh.line[3]), sh.line[4] || 1);
    if (sh.poly) return Poly(sh.poly.map(p => [X(p[0], t, s) + bx + (p[2] || 0) * back, Y(p[1])]));
    return null;
  };
  const maskOfShapes = (list, s) => M((list || []).map(sh => shapeOf(sh, s)));
  const groups = { hat: [R.hat, R.hatDark, R.hatLight], trim: [R.trim, R.trimDark, R.trimLight], acc: [R.acc, R.accDark, R.accLight], leaf: [R.leaf, R.leafDark, R.leaf] };
  // the role painter shared by every part: three tones, then rows, then a pattern
  const painter = (m, p, extra) => {
    const G3 = groups[p.tone || 'hat'], base = p.flat ? () => G3[0] : tones(m, G3[0], G3[1], G3[2]), b = bbox(m, w, h);
    const fx = Math.round(sb.cx + fac * 1.5);
    return (x, y) => {
      const on = (a, c) => a >= 0 && c >= 0 && a < w && c < h && m[c * w + a];
      if (extra) { const r = extra(x, y, on); if (r != null) return r; }
      if (p.rows) for (const [a, z, role] of p.rows) if (y >= band + a && y <= band + z) return R[role];
      switch (p.pattern) {
        case 'weave': if ((x + y) % 4 === 0) return G3[1]; break;
        case 'dots': if (y % 4 === 1 && (x + (y >> 2) * 2) % 5 === 0) return R.trim; break;
        case 'knit': if (y >= band - 2) return x % 2 ? G3[1] : G3[0]; if (!on(x + 1, y) || x % 3 === 0) return G3[1]; return G3[0];
        case 'pleats': if (y === band - 6) return G3[1]; if (y > band - 6 && y < band && Math.round(x - fx) % 5 === 0) return G3[1]; break;
        case 'fin': if ((x + y) % 3 === 0) return G3[1]; return G3[0];
        case 'vane': if (!on(x, y - 1) || !on(x - 1, y)) return G3[2]; if ((x + y) % 3 === 0) return G3[1]; return G3[0];
        case 'gem': return x < b.cx && y < b.cy ? R.glint : x < b.cx || y < b.cy ? G3[0] : G3[1];
        case 'lens': if (!on(x, y - 1) && !on(x - 1, y)) return R.glint; if (x < b.cx - 0.5 && y < b.cy - 0.5) return R.accLight; if (y > b.cy + 1) return G3[1]; return G3[0];
      }
      return base(x, y);
    };
  };
  const guard = (v, x, y) => !!L.eyeMask[y * w + x];
  for (const p of spec.parts) {
    if (p.crown) {
      const c = p.crown;
      let m = crownOf(band, c.grow != null ? c.grow : 1);
      if (c.shapes) m = mOr(m, maskOfShapes(c.shapes));
      if (c.cut) m = mSub(m, maskOfShapes(c.cut));
      m = mAnd(m, M([{ t: 'above', y: band + 0.5 }]));
      if (c.flat != null) m = mAnd(m, M([{ t: 'below', y: sb.y0 + c.flat }]));
      if (!spec.keepHair) flatten(band + (p.flattenAt || 0), m);
      paint(g, m, painter(m, p), 'over', true, guard);
    } else if (p.brim) {
      let m = maskOfShapes(p.brim.shapes);
      if (p.brim.cut != null) m = mSub(m, M([{ t: 'above', y: band + p.brim.cut }]));
      const roll = p.brim.roll;
      paint(g, m, painter(m, p, (x, y) => roll ? (y > band ? R.hatDark : y < band - 0.5 ? R.hatLight : (p.pattern ? null : R.hat)) : (y > band + 1 ? R.hatDark : y < band ? R.hatLight : null)), 'over', true, guard);
    } else if (p.strap) {
      const m = mAnd(dilate(L.skull, w, h, p.grow || 1.1), M([Rect(0, band + p.strap[0], w, band + p.strap[1])]));
      paint(g, m, painter(m, Object.assign({ flat: true }, p)), 'over', true, guard);
    } else if (p.shape) {
      const m = maskOfShapes(p.shape.shapes);
      paint(g, m, painter(m, p), p.mode || 'over', p.ring !== false, guard);
    } else if (p.pair) {
      for (const s of [-1, 1]) { const m = maskOfShapes(p.pair.shapes.map(sh => Object.assign({}, sh, { turn: p.pair.turn || sh.turn })), s); paint(g, m, painter(m, p, p.antler ? (x, y) => y > sb.y0 - 2 ? R.hatDark : R.hat : null), 'over', true, guard); }
    } else if (p.flower) {
      const f = p.flower, fx = X(f.at[0]), fy = Y(f.at[1]), r = f.r || 2.4, pr = f.petal || 1.8;
      const petals = M([0, 72, 144, 216, 288].map(a => Ell(fx + Math.cos((a - 90) * Math.PI / 180) * r, fy + Math.sin((a - 90) * Math.PI / 180) * r, pr)));
      const T = groups[f.tone || 'trim'];
      paint(g, petals, (x, y) => (x - fx) * 0.6 + (y - fy) > 2 || (x + y) % 3 === 0 && !f.tone ? T[1] : T[0]);
      paint(g, M([Ell(fx, fy, 1.4)]), (x, y) => x < fx ? R.accLight : R.acc, 'over', false);
    } else if (p.side) {
      const sd = p.side, list = [-1, 1].map(s => { const a = k.side(s, Y(sd.y)); if (sd.x != null) a.x = sb.cx + s * hrx * sd.x; return { a, m: M([Poly(k.place(a, sd.pts))]) }; }).sort((u, v) => u.a.depth - v.a.depth);
      for (const { a, m } of list) {
        const along = x => (x - a.x) * Math.sign(a.out[0] || 1), hgt = bbox(m, w, h);
        const shadeFn = p.shade === 'horn' ? (x, y) => y > a.y - 2 ? R.accDark : along(x) < 5 && y < a.y - 7 ? R.accLight : R.acc
          : p.shade === 'spike' ? (x, y) => y < a.y - 9 ? R.accLight : along(x) > 2 ? R.accDark : R.acc : null;
        const fn = shadeFn || painter(m, p);
        if (p.over || a.depth > 0.05) paint(g, m, fn, 'over', true, guard); else paint(g, m, fn, 'behind');
      }
    } else if (p.back) {
      const bk = p.back, a = k.ring(-125, Y(bk.y)), sg = a.out[0] < 0 ? -1 : 1;
      const mapS = list => M((list || []).map(sh => {
        if (sh.ell) return Ell(a.x + sg * sh.ell[0], a.y + sh.ell[1], sh.ell[2], sh.ell[3]);
        if (sh.poly) return Poly(sh.poly.map(([u, v]) => [a.x + sg * u, a.y + v]));
        if (sh.line) return Line(a.x + sg * sh.line[0], a.y + sh.line[1], a.x + sg * sh.line[2], a.y + sh.line[3], sh.line[4] || 1);
      }));
      const tails = mapS(bk.tails), knot = mapS(bk.knot);
      paint(g, tails, (x, y) => y > a.y + 3 ? R.hatDark : R.hat, 'behind');
      if (bk.knot) paint(g, knot, (x, y) => y > a.y ? R.hatDark : R.hat);
    } else if (p.helm) helmPart(g, L, dir, k, Object.assign({ band: band === E - 4 ? 4 : E - band }, p.helm));
    else if (p.detail) hatDetail(g, L, dir, k, p, band, X, Y);
  }
}
/* the shared helmet: smooth dome, curved brow band, shine, plus optional pieces */
function helmPart(g, L, dir, k, o) {
  const { w, h, sb, fac, M, crownOf, flatten, tones, eyeGuard } = k, E = L.eyeRow, band = E - (o.band || 4);
  const { fx0, fx1 } = faceCols(L);
  const dome = mAnd(crownOf(band + 3, 1.4), maskOf(g, (v, x, y) => y <= k.bandAt(band, x)));
  let helm = dome;
  if (o.cheeks) helm = mOr(helm, mSub(M([Rect(Math.max(sb.x0 - 1.5, fx0 - 4), band - 2, fx0 + 2.5, E + 6, 1.5), Rect(fac > 0 ? 1e9 : fx1 - 2.5, band - 2, Math.min(sb.x1 + 1.5, fx1 + 4), E + 6, 1.5)]), dilate(L.eyeMask, w, h, 1.5)));
  flatten(band, helm);
  if (o.flaps) {
    const flaps = mSub(M([Rect(sb.x0 - 3, band - 1, fx0 + 1.5, E + 7, 1.5), Rect(fac > 0 ? 1e9 : fx1 - 1.5, band - 1, sb.x1 + 3, E + 7, 1.5)]), dilate(L.eyeMask, w, h, 1.5));
    paint(g, flaps, (x, y) => (y - band) % 3 === 0 ? R.trim : (y - band) % 3 === 1 ? R.hat : R.hatDark, 'over', true, (v, x, y) => !!L.eyeMask[y * w + x]);
  }
  const t = tones(helm, R.hat, R.hatDark, R.hatLight);
  const shx = sb.cx - 3 - fac * 2, shy = sb.y0 + (band - sb.y0) * 0.62, srx = sb.w * 0.32, sry = (band - sb.y0) * 0.5;
  const ridge = Math.round(k.front);
  paint(g, helm, (x, y) => {
    const bx = k.bandAt(band, x), inD = dome[y * w + x];
    if (o.grille && !BACK[dir] && inD && y >= bx - 6 && y < bx - 2 && x > fx0 + 1 && x < fx1 - 1) return (x % 2 === 0) ? R.outline : (y === bx - 6 ? R.hatLight : R.hat);
    if (inD && y >= bx - 2) return y === bx ? R.trimDark : (y === bx - 2 && (x - ridge) % 5 === 2) ? R.trimLight : R.trim;
    if (o.goldRidge && inD && x === ridge && y > sb.y0 + 1) return R.trim;
    if (o.ridge && inD && (x === ridge || x === ridge + 1) && y < band - 2) return x === ridge ? R.hatLight : R.hatDark;
    if (o.ribs && inD && (x - ridge) % 4 === 0 && y > sb.y0) return R.hatDark;
    const dx = (x - shx) / srx, dy = (y - shy) / sry, d = dx * dx + dy * dy;
    if (inD && y < shy && d > 0.55 && d < 0.95 && x < shx + srx * 0.5) return R.hatLight;
    return t(x, y);
  }, 'over', true, eyeGuard);
  if (o.faceplate && !BACK[dir]) {
    const eyeBot = Math.max(...L.eyes.map(e => e.y1));
    const plate = mSub(M([Rect(fx0 - 1, band - 1, fx1 + (fac > 0 ? 2 : 1), (L.mouth ? L.mouth.y1 : E + 8) + 2, 3)]), M([Rect(fx0 + 0.5, E - 0.5, fx1 - 0.5 + (fac > 0 ? 2 : 0), eyeBot + 0.5)]));
    paint(g, plate, (x, y) => { const on = (a, c) => plate[c * w + a]; return !on(x, y + 1) || !on(x + 1, y) ? R.hatDark : !on(x, y - 1) ? R.hatLight : (L.mouth && y === L.mouth.y0 && (x % 2 === 0) && Math.abs(x - L.mouth.cx) < 5) ? R.outline : R.hat; }, 'over', true, (v, x, y) => !!L.eyeMask[y * w + x]);
  }
  if (o.nasal && !BACK[dir]) {
    const e = L.eyes, nx = e.length >= 2 ? Math.round((e[0].x1 + e[1].x0) / 2) : Math.round(k.front);
    paint(g, mSub(M([Rect(nx - 1, band, nx + 1, E + 3, 0.5)]), dilate(L.eyeMask, w, h, 0.6)), (x, y) => x === nx - 1 ? R.hatLight : x === nx + 1 ? R.hatDark : R.hat, 'over', true, (v, x, y) => !!L.eyeMask[y * w + x]);
  }
  return { band, dome, ridge };
}
function hatDetail(g, L, dir, k, p, band, X, Y) {
  const { w, h, sb, fac, M, tones, eyeGuard } = k, E = L.eyeRow;
  if (p.detail === 'creases') { const cx = sb.cx + fac * 1.5; for (const dx of [-3, 4]) for (let y = sb.y0 - 3; y < sb.y0 + 1; y++) { const x = Math.round(cx + dx); if (g.get(x, y) === R.hat) g.set(x, y, R.hatDark); } }
  if (p.detail === 'star') { const sx = Math.round(X(p.at[0], p.turn)), sy = Math.round(Y(p.at[1])); for (const [dx, dy] of [[0, -1], [-1, 0], [0, 0], [1, 0], [0, 1]]) g.set(sx + dx, sy + dy, dx === 0 && dy === 0 ? R.trimLight : R.trim); }
  if (p.detail === 'frontGlint' && !fac) { const mx = Math.round(sb.cx); for (const [dx, dy] of [[0, 0], [-1, 0], [1, 0], [0, -1]]) g.set(mx + dx, band - 1 + dy, R.glint); }
  if (p.detail === 'leafRing') {
    const ring = mAnd(dilate(L.skull, w, h, 1.3), M([Rect(0, band - 2, w, band + 1)])), rb = bbox(ring, w, h), leaves = [];
    for (let x = rb.x0 + 1; x <= rb.x1 - 1; x += 4) leaves.push(Ell(x, band - 0.5 + ((x >> 2) % 2 ? -0.8 : 0.4), 2.4, 1.6));
    const lm = mAnd(M(leaves), dilate(ring, w, h, 1));
    paint(g, lm, (x, y) => (x + y) % 4 === 0 ? R.trimDark : y < band - 1 ? R.trimLight : R.trim, 'over', true, eyeGuard);
    const fx = sb.cx + fac * 5 + (fac ? 0 : 6), fy = band - 1;
    paint(g, M([0, 72, 144, 216, 288].map(a => Ell(fx + Math.cos((a - 90) * Math.PI / 180) * 1.8, fy + Math.sin((a - 90) * Math.PI / 180) * 1.8, 1.4))), (x, y) => y > fy + 1 ? R.accDark : R.acc);
    g.set(Math.round(fx), Math.round(fy), R.center);
  }
  if (p.detail === 'hood') {
    const { fx0, fx1 } = faceCols(L), top = E - 5, bot = L.shoulder + 1;
    const open = BACK[dir] ? new Uint8Array(w * h) : M([Rect(fx0 - 0.5, top, fx1 + 0.5 + (fac > 0 ? 3 : 0), bot, 6)]);
    const shell = mOr(M([Ell(sb.cx, sb.cy, sb.w / 2 + 1.8, sb.h / 2 + 1.8)]), M([Rect(sb.x0 - 2.5, E - 2, sb.x1 + 2.5, L.shoulder + 4, 5)]));
    const hood = mSub(shell, open), t = tones(hood, R.hat, R.hatDark, R.hatLight);
    const rim = mAnd(mAnd(hood, dilate(open, w, h, 1.2)), M([{ t: 'above', y: H_chinOf(L) }]));
    paint(g, hood, (x, y) => rim[y * w + x] ? R.trim : t(x, y), 'over', true, (v, x, y) => !!open[y * w + x] && y > top + 2 || eyeGuard(v, x, y));
    for (let x = 0; x < w; x++) for (let y = top - 2; y < bot; y++) if (rim[y * w + x] && !rim[(y - 1) * w + x] && (x % 3 === 0) && g.get(x, y - 1) === R.hat) g.set(x, y - 1, R.trim);
  }
}
/* no recipe: build the portrait hat from the in-game sprite rows (silhouette + colour regions) */
function hatFromSprite(g, L, dir, k, auto) {
  const { w, h, sb, fac, M, flatten, tones, eyeGuard } = k, E = L.eyeRow, rows = auto.rows;
  const sx = c => sb.cx + (c - 9) * (sb.w / 16) + fac * 1.5, sy = r => sb.y0 + (r - 2) * (E - sb.y0) / 10;
  // every run of filled cells in every row becomes a block, then the blocks are smoothed into one shape
  const blocks = [];
  rows.forEach((row, i) => { let st = -1; for (let j = 0; j <= row.length; j++) { const on = j < row.length && row[j] !== '.'; if (on && st < 0) st = j; if (!on && st >= 0) { blocks.push(Rect(sx(st), sy(auto.y + i), sx(j), sy(auto.y + i + 1))); st = -1; } } });
  if (!blocks.length) return;
  let m = erode(dilate(M(blocks), w, h, 1.3), w, h, 1.3);
  m = mSub(m, dilate(L.eyeMask, w, h, 1));
  // hair is only flattened outside the hat's outer outline, so openings (hoods, visors) keep the hair inside
  const hull = M(rows.map((row, i) => { const cs = [...row].map((c, j) => c !== '.' ? j : -1).filter(j => j >= 0); return cs.length ? Rect(sx(cs[0]), sy(auto.y + i), sx(cs[cs.length - 1] + 1), sy(auto.y + i + 1)) : null; }));
  const band = Math.round(sy(auto.y + rows.length)) - 1;
  if (auto.covers) flatten(band, dilate(hull, w, h, 1));
  const key = (x, y) => { const c = Math.floor((x - sb.cx - fac * 1.5) * 16 / sb.w + 9), r = Math.floor((y - sb.y0) * 10 / (E - sb.y0) + 2) - auto.y; return rows[r] ? rows[r][c] : '.'; };
  const t = tones(m, R.hat, R.hatDark, R.hatLight);
  paint(g, m, (x, y) => { const c = key(x, y); if (c === '2' && m[(y - 1) * w + x] && m[(y + 1) * w + x] && m[y * w + x - 1] && m[y * w + x + 1]) return R.outline; if (c === auto.keys[1] && auto.keys[1]) return R.hatDark; if (c === auto.keys[2] && auto.keys[2]) return R.trim; if (c === auto.keys[3] && auto.keys[3]) return R.acc; return t(x, y); }, 'over', true, eyeGuard);
}

/* ---------- eye shapes: big, narrow (lashes come from the studio's lash rule) ---------- */
function ttEyeShape(g, rec, dir, L) {
  const s = rec.eyeShape; if (!s || s === 'round' || s === 'lashes' || rec.eyes === 'happy' || rec.eyes === 'sleepy' || L.eyes.length < 2) return;
  const w = g.w, fc = (L.eyes[0].x0 + L.eyes[1].x1) / 2;
  for (const e of L.eyes) {
    const outer = (e.x0 + e.x1) / 2 < fc ? -1 : 1, ox = outer < 0 ? e.x0 : e.x1;
    if (s === 'big') {
      const add = [];
      for (let y = e.y0; y <= e.y1; y++) if (L.eyeMask[y * w + ox]) { g.set(ox + outer, y, g.get(ox, y)); L.eyeMask[y * w + ox + outer] = 1; add.push(y * w + ox + outer); }
      e.cells = e.cells.concat(add); if (outer < 0) e.x0--; else e.x1++;
      const ix = outer < 0 ? e.x1 : e.x0, gy = e.y1 - 1; if (L.eyeMask[gy * w + ix]) g.set(ix, gy, R.glint);
    }
    if (s === 'narrow') {
      for (const j of e.cells) if (((j / w) | 0) < e.y0 + 2) { g.px[j] = R.skin; L.eyeMask[j] = 0; }
      e.cells = e.cells.filter(j => ((j / w) | 0) >= e.y0 + 2); e.y0 += 2;
      for (let x = e.x0 - (outer < 0 ? 1 : 0); x <= e.x1 + (outer > 0 ? 1 : 0); x++) g.set(x, e.y0, R.outline);
    }
  }
}
/* ---------- neckline: the sheet shades the neck with the mouth colour, which reads as a high collar ---------- */
function ttNeckline(g, L) {
  const w = g.w, SH = L.shoulder;
  const neck = []; for (let x = 0; x < w; x++) if (g.get(x, SH - 1) === R.mouth) neck.push(x);
  const ncx = neck.length ? Math.round((neck[0] + neck[neck.length - 1]) / 2) : Math.round(L.bodyCx);
  for (let y = SH - 3; y <= SH; y++) for (let x = 0; x < w; x++) if (g.get(x, y) === R.mouth) g.set(x, y, y === SH - 3 ? R.skinShade : R.skin);
  // a small V neckline so the collar sits lower
  for (let k = 0; k <= 2; k++) {
    const y = SH + k, half = 3 - k;
    for (let x = ncx - half; x <= ncx + half; x++) { const v = g.get(x, y); if (v === R.top || v === R.topDark || v === R.outline || v === R.skinShade || v === R.emblem) g.set(x, y, R.skin); }
    for (const x of [ncx - half - 1, ncx + half + 1]) { const v = g.get(x, y); if (v === R.top || v === R.outline) g.set(x, y, R.topDark); }
  }
}
/* ---------- stout: puff the cheeks outward beside the eyes, round at the bottom, before hair and hats ---------- */
function puffCheeks(g, L, H) {
  const w = g.w, h = g.h, E = L.eyeRow, chin = H.chin;
  // how much each row grows on each side: round cheeks, a thick neck, broad shoulders
  const kOf = y => { if (y >= L.shoulder) return 4; if (y > chin + 1) return 2; if (y < E - 2) return 1; const t = (y - (E - 2)) / (chin + 3 - (E - 2)); return Math.max(2, 1 + Math.round(2.2 * Math.sin(Math.PI * Math.min(1, t * 1.15)))); };
  const c0 = Math.round(L.sb.cx), e0 = L.eyes[0] || {x0: c0 - 6, x1: c0 - 4}, e1 = L.eyes[1] || {x0: c0 + 4, x1: c0 + 6}, isFill = v => v >= 0 && v !== R.outline;
  // the column copied on each row must be fill (skin, hair, cloth), never outline, or it thickens into a black block
  const pick = (y, from, to) => { const st = from <= to ? 1 : -1; for (let x = from; x !== to + st; x += st) { const v = g.get(x, y); if (isFill(v) && !L.eyeMask[y * w + x] && isFill(g.get(x - 1, y)) && isFill(g.get(x + 1, y))) return x; } return null; };
  const cols = [];
  for (let y = 0; y < h; y++) {
    const lx = pick(y, e0.x0 - 3, e0.x0 - 1) ?? pick(y, e0.x0 - 4, e0.x0 - 7) ?? e0.x0 - 3;
    const rx = pick(y, e1.x1 + 3, e1.x1 + 1) ?? pick(y, e1.x1 + 4, e1.x1 + 7) ?? e1.x1 + 3;
    cols.push([lx, rx]);
  }
  const shiftRow = (get, set, y) => {
    const k = kOf(y), [xl, xr] = cols[y], o = []; for (let x = 0; x < w; x++) o.push(get(y * w + x));
    for (let x = 0; x < w; x++) { let src = x; if (x <= xl) src = Math.min(xl, x + k); else if (x >= xr) src = Math.max(xr, x - k); set(y * w + x, src >= 0 && src < w ? o[src] : 0); }
  };
  for (const m of [L.skull, L.face, L.blob, L.hairM]) if (m) for (let y = 0; y < h; y++) shiftRow(i => m[i], (i, v) => { m[i] = v; }, y);
  for (let y = 0; y < h; y++) shiftRow(i => g.px[i], (i, v) => { g.px[i] = v; }, y);
  H.xl -= 1; H.xr += 1; H.rx += 1; L.sb = bbox(L.skull, w, h); L.coreL -= 4; L.coreR += 4;
}
function chubbyCues(g, L) {
  const w = g.w;
  for (const e of L.eyes) {   // cheeks lift the lower lids and glow
    const by = e.y1; for (let x = e.x0; x <= e.x1; x++) if (L.eyeMask[by * w + x]) { g.set(x, by, R.skin); L.eyeMask[by * w + x] = 0; }
    e.y1 -= 1;
    const cx = Math.round((e.x0 + e.x1) / 2);
    for (let dy = 2; dy <= 3; dy++) for (let dx = -2; dx <= 2; dx++) { const v = g.get(cx + dx, e.y1 + dy); if (v === R.skin || v === R.skinShade) g.set(cx + dx, e.y1 + dy, R.blush); }
  }
}
/* ---------- stout (old version, unused) ---------- */
function widenStout(g, L) {
  const w = g.w, h = g.h, cx = L.eyes.length >= 2 ? Math.round((L.eyes[0].x0 + L.eyes[1].x1) / 2) : Math.round(L.sb.cx), E = L.eyeRow;
  for (let y = 0; y < h; y++) {
    const steps = y >= E + 6 ? 3 : 1;
    for (let k = 0; k < steps; k++) {
      const o = []; for (let x = 0; x < w; x++) o.push(g.px[y * w + x]);
      for (let x = 0; x < w; x++) g.px[y * w + x] = x <= cx - 2 ? (x + 1 < w ? o[x + 1] : -1) : x >= cx + 1 ? (x - 1 >= 0 ? o[x - 1] : -1) : o[x];
    }
  }
  // the step between the widths becomes a soft cheek curve
  for (let y = E + 4; y <= E + 7; y++) for (let x = 1; x < w - 1; x++) { const v = g.get(x, y); if (v < 0 && N4.some(([dx, dy]) => SKIN.has(g.get(x + dx, y + dy)))) g.set(x, y, R.outline); }
}
/* ---------- body cues: old, stout, young, tall ---------- */
function ttBody(g, rec, dir, L, H) {
  const b = rec.body; if (!b || b === 'standard') return;
  const w = g.w, h = g.h, Mo = L.mouth, isSkin = v => v === R.skin || v === R.skinShade || v === R.blush;
  const cx = Math.round(L.bodyCx);
  const shiftRows = (y0, n) => { for (let y = y0; y < h; y++) { for (let k = 0; k < Math.abs(n); k++) { const o = []; for (let x = 0; x < w; x++) o.push(g.get(x, y));
    for (let x = 0; x < w; x++) g.px[y * w + x] = n > 0 ? (x <= cx - 2 ? (o[x + 1] ?? -1) : x >= cx + 1 ? (o[x - 1] ?? -1) : o[x]) : (x < cx ? (o[x - 1] ?? -1) : (o[x + 1] ?? -1)); } } };
  if (b === 'old' && L.eyes.length >= 2) {
    const fc = (L.eyes[0].x0 + L.eyes[1].x1) / 2;
    for (const e of L.eyes) {
      const outer = (e.x0 + e.x1) / 2 < fc ? -1 : 1, ox = (outer < 0 ? e.x0 : e.x1) + outer * 2;
      for (const [x, y] of [[ox, e.y1 - 1], [ox + outer, e.y1], [ox, e.y1 + 1]]) if (isSkin(g.get(x, y))) g.set(x, y, R.skinShade);
      for (let x = e.x0 - 1; x <= e.x1 + 1; x++) if (isSkin(g.get(x, e.y0 - 2))) g.set(x, e.y0 - 2, R.hairLight);
    }
    if (Mo) for (const [x, y] of [[Mo.x0 - 2, Mo.y0 - 1], [Mo.x0 - 2, Mo.y0], [Mo.x1 + 2, Mo.y0 - 1], [Mo.x1 + 2, Mo.y0]]) if (isSkin(g.get(x, y))) g.set(x, y, R.skinShade);
  }
  if (b === 'stout' && Mo) {   // double chin; the widening happens on the finished portrait
    let yl = -1; for (let y = h - 1; y > Mo.y1; y--) if (isSkin(g.get(Math.round(Mo.cx), y))) { yl = y; break; }
    if (yl > 0) for (let x = Math.round(Mo.cx) - 4; x <= Math.round(Mo.cx) + 4; x++) if (isSkin(g.get(x, yl - 1))) g.set(x, yl - 1, R.skinShade);
  }
  if (b === 'young') shiftRows(L.shoulder + 1, -1);
  if (b === 'tall') { for (let y = h - 1; y >= L.shoulder; y--) for (let x = 0; x < w; x++) g.px[y * w + x] = g.px[(y - 1) * w + x]; L.shoulder += 1; }
}

/* ---------- expressions: mouth shapes, brows, wink ---------- */
const TT_MOUTH = { neutral: 'keep', smile: 'smile', happy: 'smile', laugh: 'open', surprised: 'o', sleepy: 'small', concerned: 'frown', excited: 'open', angry: 'frown', sad: 'frown', love: 'smile', wink: 'smile' };
const TT_BROWS = { angry: 'angry', sad: 'sad', concerned: 'sad', surprised: 'up' };
function ttExpression(g, rec, dir, L) {
  const ex = rec.expr || 'neutral', w = g.w, Mo = L.mouth;
  const put = (x, y, r) => { if (g.get(x, y) >= 0) g.set(x, y, r); };
  if (ex === 'wink' && L.eyes.length) {
    const e = L.eyes[0], y = e.y0 + 2;
    for (const j of e.cells) g.px[j] = R.skin;
    put(e.x0 - 1, y + 1, R.outline); for (let x = e.x0; x <= e.x1; x++) put(x, y, R.outline); put(e.x1 + 1, y + 1, R.outline);
  }
  const kind = TT_MOUTH[ex] || 'keep';
  if (Mo) L.mouthBox = { x0: Mo.x0, x1: Mo.x1, y0: Mo.y0, y1: Mo.y1 };
  if (Mo && kind !== 'keep') {
    for (let y = Mo.y0; y <= Mo.y1; y++) for (let x = Mo.x0; x <= Mo.x1; x++) if (g.get(x, y) === R.mouth) g.set(x, y, R.skin);
    const x0 = Mo.x0, x1 = Mo.x1, y0 = Mo.y0, c = Math.round(Mo.cx);
    if (kind === 'smile') { for (let x = x0 + 1; x <= x1 - 1; x++) put(x, y0, R.mouth); put(x0, y0 - 1, R.mouth); put(x1, y0 - 1, R.mouth); }
    if (kind === 'open') { for (let x = x0; x <= x1; x++) put(x, y0, R.mouthDark); for (let x = x0 + 1; x <= x1 - 1; x++) put(x, y0 + 1, Math.abs(x + 0.5 - (x0 + x1 + 1) / 2) < 1.1 ? R.tongue : R.mouthDark); for (let x = x0 + 2; x <= x1 - 2; x++) put(x, y0 + 2, R.tongue); }
    if (kind === 'o') for (const [dx, dy] of [[-1, 0], [0, 0], [-1, 1], [0, 1]]) put(c + dx, y0 + dy, R.mouthDark);
    if (kind === 'frown') { for (let x = x0 + 1; x <= x1 - 1; x++) put(x, y0, R.mouth); put(x0, y0 + 1, R.mouth); put(x1, y0 + 1, R.mouth); }
    if (kind === 'flat') for (let x = x0 + 1; x <= x1 - 1; x++) put(x, y0, R.mouth);
    if (kind === 'small') { put(c - 1, y0, R.mouth); put(c, y0, R.mouth); }
    L.mouthBox = { x0: x0 - 1, x1: x1 + 1, y0: y0 - 1, y1: y0 + 2 };
  }
  // hearts for love, tears for sad, a sweat drop for concerned (the same as the walking sprite)
  if (ex === 'love') for (const e of L.eyes) {
    for (const j of e.cells) { g.px[j] = R.skin; L.eyeMask[j] = 0; }
    const HEART = ['.#.#.', '#####', '#####', '.###.', '..#..'], hx = Math.round((e.x0 + e.x1) / 2) - 2, hy = e.y0;
    HEART.forEach((row, yy) => [...row].forEach((c, xx) => { if (c === '#') put(hx + xx, hy + yy, xx >= 3 && yy >= 2 || yy === 4 ? R.heartD : R.heartC); }));
    put(hx + 1, hy + 1, R.glint);
  }
  if (ex === 'sad') for (const e of L.eyes) { const tx = Math.round((e.x0 + e.x1) / 2); put(tx, e.y1 + 1, R.tearL); put(tx, e.y1 + 2, R.tear); put(tx, e.y1 + 3, R.tear); }
  if (ex === 'concerned' && L.eyes.length) {
    const e = L.eyes[L.eyes.length - 1], sx = e.x1 + 4, sy = e.y0 - 3;
    paint(g, raster(w, g.h, [Ell(sx, sy + 2.2, 1.6, 1.8), Poly([[sx - 1.2, sy + 1.5], [sx, sy - 1.2], [sx + 1.2, sy + 1.5]])]), (x, y) => y < sy + 1 && x <= sx ? R.tearL : R.tear, 'over', true, (v, x, y) => !!L.eyeMask[y * w + x]);
  }
  const bk = TT_BROWS[ex];
  if (bk && L.eyes.length) {
    const fc = L.eyes.reduce((a, e) => a + (e.x0 + e.x1) / 2, 0) / L.eyes.length;
    for (const e of L.eyes) {
      const ec = (e.x0 + e.x1) / 2, inner = L.eyes.length > 1 ? Math.sign(fc - ec) : -FACING[dir] || 1, by = e.y0 - (bk === 'up' ? 3 : 2);
      for (let x = e.x0 - 1; x <= e.x1 + 1; x++) {
        const t = (x - ec) * inner; let y = by;
        if (bk === 'angry' && t > 0.5) y += 1;
        if (bk === 'sad' && t > 0.5) y -= 1;
        if (g.get(x, y) >= 0 && !L.eyeMask[y * w + x]) g.set(x, y, R.outline);
      }
    }
  }
}

/* the sheet's left eye is drawn larger than the right; copy the right eye so they match */
function matchEyes(g, L) {
  if (L.eyes.length < 2) return;
  const w = g.w, [a, b] = L.eyes;
  for (const j of a.cells) { g.px[j] = R.skin; L.eyeMask[j] = 0; }
  const dx = Math.round((a.x0 + a.x1) / 2 - (b.x0 + b.x1) / 2), dy = b.y1 - b.y0 >= a.y1 - a.y0 ? a.y0 - b.y0 : a.y0 - b.y0;
  const cells = b.cells.map(j => j + dy * w + dx);
  for (const j of cells) { g.px[j] = R.outline; L.eyeMask[j] = 1; }
  L.eyes[0] = { x0: b.x0 + dx, x1: b.x1 + dx, y0: b.y0 + dy, y1: b.y1 + dy, cells };
}
function portrait(rec, dir) {
  const L0 = humanLandmarks(dir), base0 = BASE.boy[dir];
  const base = padGrid(base0.clone());
  const L = shiftL(L0, base0.w, base0.h);
  L.mouth = realMouth(base, L) || (BACK[dir] ? null : L.mouth);
  const H = smoothSkull(L, base.w, base.h);
  L.skull = H.S; L.sb = bbox(H.S, base.w, base.h); L._chin = H.chin;
  let g = baldSmooth(base, L, H.S);
  matchEyes(g, L);
  if (rec.body === 'stout') puffCheeks(g, L, H);
  ttHair(g, rec, dir, L, H);
  faceEdits(g, Object.assign({}, rec, { eyes: rec.eyes === 'sparkle' ? 'dots' : rec.eyes, facial: 'none', glasses: false }), dir, L, false);
  colorEyes(g, rec, dir, L);
  ttEyeShape(g, rec, dir, L);
  if (rec.body === 'stout' && rec.eyes !== 'happy' && rec.eyes !== 'sleepy') chubbyCues(g, L);
  ttExpression(g, rec, dir, L);
  ttBeard(g, rec, dir, L, H);
  g = outfitEdits(g, rec, dir, L);
  ttNeckline(g, L);
  ttBody(g, rec, dir, L, H);
  ttNeck(g, rec, dir, L);
  ttFaceWear(g, rec, dir, L, H);
  if (rec.hatSpec) hatFromSpec(g, L, dir, hatKit(g, L, dir), rec.hatSpec);
  else if (rec.hatAuto) hatFromSprite(g, L, dir, hatKit(g, L, dir), rec.hatAuto);
  reoutline(g, [0, L.eyeRow - 6]);
  return { g, L, pal: palTT(rec) };
}

/* ---------- portrait-style in-game sprites: the same pipeline on the whole body, then the studio's rig and animation ---------- */
const BODY_AGE = {young: 'kid', standard: 'teen', old: 'elder', tall: 'adult', stout: 'adult'};
const SPR = new Map();
/* chibi: thin out torso and leg rows (big head, short body), then halve the resolution keeping outlines, eyes and mouth */
function chibiGrid(g, L, body, rec, dir) {
  const w = g.w, sh = L.shoulder, hip = L.hip, ft = L.shoeTop;
  const dropT = {young: 2, standard: 3, old: 3, stout: 3, tall: 5}[body] || 3, dropL = {young: 2, standard: 2, old: 2, stout: 2, tall: 3}[body] || 2;
  const rows = [];
  for (let y = 0; y < g.h; y++) {
    if (y > sh + 1 && y < hip && (y - sh) % dropT === 0) continue;
    if (y >= hip && y < ft - 1 && (y - hip) % dropL === 1) continue;
    rows.push(y);
  }
  // eyes and mouth are redrawn crisply after shrinking, so they shrink as plain skin
  const EYEISH = new Set([R.outline, R.iris, R.irisDark, R.irisLight, R.glint, R.heartC, R.heartD, R.tear, R.tearL]), MOUTHISH = new Set([R.mouth, R.mouthDark, R.tongue]);
  const mb = L.mouthBox || L.mouth;
  const t = new G(w, rows.length); rows.forEach((sy, ny) => { for (let x = 0; x < w; x++) { let v = g.px[sy * w + x];
    if (L.eyeMask[sy * w + x] && EYEISH.has(v)) v = R.skin;
    if (mb && MOUTHISH.has(v) && sy >= mb.y0 - 1 && sy <= mb.y1 + 2 && x >= mb.x0 - 2 && x <= mb.x1 + 2) v = R.skin;
    t.px[ny * w + x] = v; } });
  const mapY = y => { let i = 0; while (i < rows.length - 1 && rows[i + 1] <= y) i++; return Math.floor(i / 2); };
  const W2 = Math.ceil(w / 2), H2 = Math.ceil(t.h / 2), o = new G(W2, H2);
  const EYE = new Set([R.iris, R.irisDark, R.irisLight, R.glint]), FACE = new Set([R.mouth, R.mouthDark, R.tongue, R.heartC, R.heartD, R.tear]);
  for (let y = 0; y < H2; y++) for (let x = 0; x < W2; x++) {
    const top = [t.get(2 * x, 2 * y), t.get(2 * x + 1, 2 * y)], bot = [t.get(2 * x, 2 * y + 1), t.get(2 * x + 1, 2 * y + 1)], vs = top.concat(bot), filled = vs.filter(v => v >= 0);
    let v = -1;
    if (filled.length >= 2 || filled.some(f => EYE.has(f) || FACE.has(f))) {
      const eye = filled.filter(f => EYE.has(f));
      if (eye.length) v = top.includes(R.outline) && !eye.some(f => top.includes(f)) ? R.outline : (eye.includes(R.iris) ? R.iris : eye[0] === R.glint ? R.iris : eye[0]);
      else if (filled.some(f => FACE.has(f))) v = filled.find(f => FACE.has(f));
      else if (filled.filter(f => f === R.outline).length >= 2) v = R.outline;
      else { const cnt = new Map(); for (const f of filled) if (f !== R.outline) cnt.set(f, (cnt.get(f) || 0) + 1); let best = -1, bn = 0; for (const [k2, n] of cnt) if (n > bn) { bn = n; best = k2; }
        const hn = (cnt.get(R.hair) || 0) + (cnt.get(R.hairDark) || 0) + (cnt.get(R.hairLight) || 0);
        if (hn && hn >= bn) best = (cnt.get(R.hairDark) || 0) >= 3 ? R.hairDark : (cnt.get(R.hairLight) || 0) >= 2 ? R.hairLight : R.hair;   // strands alternate per pixel: keep the main tone
        v = best >= 0 ? best : R.outline; }
    }
    o.px[y * W2 + x] = v;
  }
  reoutline(o, [0, H2 - 1]);
  const HAIRS_R = new Set([R.hair, R.hairDark, R.hairLight]), SKINS_R = new Set([R.skin, R.skinShade, R.blush, R.cheek]);
  const sbx0 = Math.floor(L.sb.x0 / 2), sbx1 = Math.floor(L.sb.x1 / 2), ey = mapY(L.eyeRow + 1), side = !BACK[dir] && FACING[dir] !== 0;
  const ncx = Math.round((sbx0 + sbx1) / 2) + (side ? 1 : 0), sy = mapY(L.shoulder), isHair = v => HAIRS_R.has(v);
  // long hair is drawn in two layers (head, and behind the body); join them so it doesn't look cut at the chin
  for (let pass = 0; pass < 2; pass++) for (let y = 1; y < H2 - 1; y++) for (let x = 1; x < W2 - 1; x++) {
    if (o.get(x, y) !== R.outline) continue;
    const up = o.get(x, y - 1), dn = o.get(x, y + 1), lf = o.get(x - 1, y), rt = o.get(x + 1, y);
    if ((isHair(up) && isHair(dn)) || (isHair(lf) && isHair(rt) && (isHair(up) || isHair(dn)))) o.set(x, y, R.hair);
  }
  // the neck always joins head and shoulders (hair can hide it at full size, then the shrink drops it)
  {
    let top = -1; for (let y = ey; y < H2; y++) { let any = false; for (let x = ncx - 1; x <= ncx; x++) if (o.get(x, y) >= 0) any = true; if (!any) { top = y; break; } }
    if (top > 0 && top <= sy + 2) {
      let bot = top; while (bot < H2 && o.get(ncx - 1, bot) < 0 && o.get(ncx, bot) < 0) bot++;
      if (bot < H2 && bot - top <= 4) for (let y = top; y < bot; y++) o.set(ncx, y, R.skin);
    }
  }
  // one neck for everyone: three pixels of skin between two outlines
  let lastNeck = -1;
  for (let y = ey + 2; y <= sy; y++) {
    const cv = o.get(ncx, y), isNeck = cv >= 0 && (SKINS_R.has(cv) || cv === R.outline);
    let a = ncx, b = ncx; if (isNeck) { while (o.get(a - 1, y) >= 0) a--; while (o.get(b + 1, y) >= 0) b++; }
    if (!isNeck || b - a + 1 > 7) { if (lastNeck >= 0) break; continue; }
    lastNeck = y;
    for (let x = a; x <= b; x++) o.set(x, y, -1);
    o.set(ncx - 2, y, R.outline); o.set(ncx + 2, y, R.outline);
    for (let x = ncx - 1; x <= ncx + 1; x++) o.set(x, y, BACK[dir] || x === ncx + 1 ? R.skinShade : R.skin);
  }
  // seen from behind, a neckline is just the back of the shirt
  const torsoTop = lastNeck >= 0 ? lastNeck + 1 : sy;
  if (BACK[dir]) {
    for (let y = torsoTop; y <= torsoTop + 3 && y < H2; y++) for (let x = ncx - 2; x <= ncx + 2; x++) if (SKINS_R.has(o.get(x, y))) o.set(x, y, R.top);
    for (let y = torsoTop; y < H2; y++) for (let x = 0; x < W2; x++) { const v = o.get(x, y); if (v === R.mouth || v === R.mouthDark || v === R.tongue) o.set(x, y, R.topDark); }
  }
  // side bodies shrink to a sliver: give them one more pixel of depth
  if (side) for (let y = torsoTop + 1; y < H2; y++) {
    const sx = o.get(ncx, y) >= 0 ? ncx : o.get(ncx - 1, y) >= 0 ? ncx - 1 : -1; if (sx < 0) continue;
    let b = sx; while (o.get(b + 1, y) >= 0) b++;
    if (o.get(b + 1, y) >= 0 || b + 1 >= W2) continue;
    for (let x = b + 1; x > ncx; x--) o.set(x, y, o.get(x - 1, y));
    const l = o.get(ncx - 1, y), c = o.get(ncx + 1, y);
    o.set(ncx, y, c !== R.outline && c >= 0 ? c : l !== R.outline && l >= 0 ? l : R.outline);
  }
  // feet from one template: a matching pair from front and back, both toes forward from the side
  {
    let yb = -1; for (let y = H2 - 1; y > sy && yb < 0; y--) for (let x = ncx - 7; x <= ncx + 7; x++) if (o.get(x, y) >= 0) { yb = y; break; }
    const lr = yb - 2;
    if (yb > 0 && o.get(ncx, lr) >= 0 || (yb > 0 && o.get(ncx - 1, lr) >= 0)) {
      const sx = o.get(ncx, lr) >= 0 ? ncx : ncx - 1;
      let xl = sx, xr = sx; while (o.get(xl - 1, lr) >= 0) xl--; while (o.get(xr + 1, lr) >= 0) xr++;
      if (xr - xl <= 12) {
        for (let y = yb - 1; y <= yb; y++) for (let x = xl - 2; x <= xr + 3; x++) o.set(x, y, -1);
        const foot = (x0, len) => { o.set(x0, yb - 1, R.outline); for (let i = 1; i <= len; i++) o.set(x0 + i, yb - 1, R.shoe); o.set(x0 + len + 1, yb - 1, R.outline); for (let i = 0; i <= len + 1; i++) o.set(x0 + i, yb, R.outline); };
        if (side) foot(xl, Math.max(3, xr - xl + 1));
        else { foot(xl, 2); foot(xr - 3, 2); }
      }
    }
  }
  if (!BACK[dir] && L.eyes.length) {
    const ex = rec.expr || 'neutral', st = rec.eyes, put = (x, y, v) => { if (o.get(x, y) >= 0) o.set(x, y, v); };
    const hidden = rec.faceWear === 'shades';
    // one face band for everyone: the same width, the same eye spacing, the same eye height
    for (let i = 0; i < o.px.length; i++) if (o.px[i] === R.mouth || o.px[i] === R.mouthDark || o.px[i] === R.tongue) o.px[i] = R.skin;
    const sorted = L.eyes.slice().sort((p, q) => p.x0 - q.x0);
    const eyeXs = side ? [sbx1 - 2] : [Math.floor(sorted[0].x1 / 2), Math.floor(sorted[sorted.length - 1].x0 / 2)];
    const fx0 = side ? sbx1 - 4 : eyeXs[0] - 1, fx1 = side ? sbx1 - 1 : eyeXs[1] + 1;
    for (let y = ey - 1; y <= ey + 1; y++) for (let x = fx0; x <= fx1; x++) {
      const v = o.get(x, y); if (v < 0) continue;
      if (HAIRS_R.has(v)) o.set(x, y, R.skin);
    }
    for (let y = ey - 1; y <= ey + 1; y++) for (let x = fx0; x <= fx1; x++) {
      if (o.get(x, y) !== R.outline) continue;
      const nb = [o.get(x - 1, y), o.get(x + 1, y), o.get(x, y - 1), o.get(x, y + 1)];
      if (nb.every(v => v >= 0 && (SKINS_R.has(v) || HAIRS_R.has(v) || v === R.outline)) && nb.filter(v => SKINS_R.has(v)).length >= 2) o.set(x, y, R.skin);
    }
    if (side) for (let y = ey - 1; y <= ey + 1; y++) if (HAIRS_R.has(o.get(sbx1 - 3, y))) o.set(sbx1 - 3, y, R.skin);
    eyeXs.forEach((x, i) => {
      if (hidden) return;
      const y = ey, outer = side ? 1 : (i === 0 ? -1 : 1);
      const closed = st === 'happy' || (ex === 'wink' && i === eyeXs.length - 1 && !side);
      if (ex === 'love') { put(x, y, R.heartC); put(x, y + 1, R.heartD); return; }
      if (closed) { put(x, y, R.outline); put(x - 1, y + 1, R.outline); put(x + 1, y + 1, R.outline); return; }
      if (st === 'sleepy' || rec.eyeShape === 'narrow') { put(x, y + 1, R.outline); return; }
      put(x, y, R.outline); put(x, y + 1, st === 'sparkle' || rec.eyeShape === 'big' ? R.irisLight : R.iris);
      if (st === 'lashes') put(x + outer, y, R.outline);
      if (ex === 'sad') put(x, y + 2, R.tear);
    });
    const Mo = L.mouth, fh = rec.ttBeard || 'none', bearded = fh === 'beard' || fh === 'longbeard', stached = fh === 'mustache' || fh === 'handlebar';
    if (side && (bearded || stached) && rec.faceWear !== 'mask' && rec.faceWear !== 'menpo') {
      const bx = sbx1 - 1, by = ey + 2, pts = bearded ? [[0, 0], [-1, 0], [-2, 0], [0, 1], [-1, 1], [-2, 1], [-3, 1], [-1, 2], [-2, 2]].concat(fh === 'longbeard' ? [[-1, 3], [-2, 3], [-2, 4]] : []) : [[0, 0], [-1, 0], [1, 0]];
      const bset = new Set(pts.map(([dx, dy]) => (bx + dx) + ',' + (by + dy)));
      for (const k of bset) { const [x, y] = k.split(',').map(Number); o.set(x, y, R.hair); }
      for (const k of bset) { const [x, y] = k.split(',').map(Number); for (const [dx, dy] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) { const q = (x + dx) + ',' + (y + dy); if (!bset.has(q) && o.get(x + dx, y + dy) < 0) o.set(x + dx, y + dy, R.outline); } }
    }
    if (Mo && rec.faceWear !== 'mask' && rec.faceWear !== 'menpo' && !stached && !(side && bearded)) {
      const mx = side ? sbx1 - 1 : Math.round((eyeXs[0] + eyeXs[1] + 1) / 2), my = ey + 2, kind = TT_MOUTH[ex] || 'keep';
      const M = (x, y, v) => { const c = o.get(x, y); if (c >= 0 && (SKINS_R.has(c) || c === R.mouth || c === R.mouthDark || c === R.tongue)) o.set(x, y, v); };
      if (side) {
        if (kind === 'open' || kind === 'o') { M(mx, my, R.mouthDark); M(mx, my + 1, kind === 'open' ? R.tongue : R.mouthDark); }
        else if (kind === 'smile') { M(mx - 1, my + 1, R.mouth); M(mx, my, R.mouth); }
        else if (kind === 'frown') { M(mx - 1, my - 1, R.mouth); M(mx, my, R.mouth); }
        else M(mx, my, R.mouth);
      }
      else if (kind === 'smile') { M(mx - 2, my, R.mouth); M(mx - 1, my + 1, R.mouth); M(mx, my + 1, R.mouth); M(mx + 1, my, R.mouth); }
      else if (kind === 'open') { M(mx - 1, my, R.mouthDark); M(mx, my, R.mouthDark); M(mx - 1, my + 1, R.tongue); M(mx, my + 1, R.tongue); }
      else if (kind === 'o') { M(mx - 1, my, R.mouthDark); M(mx, my, R.mouthDark); M(mx - 1, my + 1, R.mouthDark); M(mx, my + 1, R.mouthDark); }
      else if (kind === 'frown') { M(mx - 1, my, R.mouth); M(mx, my, R.mouth); M(mx - 2, my + 1, R.mouth); M(mx + 1, my + 1, R.mouth); }
      else { M(mx - 1, my, R.mouth); M(mx, my, R.mouth); }
    }
  }
  return o;
}
function spriteEntry(rec, sd, chibi) {
  const key = JSON.stringify(rec) + sd + (chibi ? 'c' : 'l');
  let e = SPR.get(key);
  if (!e) {
    const r = portrait(Object.assign({}, rec, {spriteMode: true}), sd);
    const g = chibi ? chibiGrid(r.g, r.L, rec.body, rec, sd) : reshape(r.g, Object.assign({}, rec, {age: BODY_AGE[rec.body] || 'teen', build: rec.body === 'stout' ? 'broad' : 'regular'}), r.L);
    e = {g, pal: r.pal, rig: rigHuman(g, sd)};
    SPR.set(key, e); if (SPR.size > 240) SPR.delete(SPR.keys().next().value);
  }
  return e;
}
function spriteFrame(rec, dir4, anim, fi, chibi) {
  const sd = {down: 'S', up: 'N', right: 'E', left: 'E'}[dir4] || 'S', e = spriteEntry(rec, sd, chibi);
  let img = animate(e.g, e.rig, 'human', sd, anim, fi, e.pal, !chibi);
  if (dir4 === 'left') { const W = CELL.w, H = CELL.h, m = new Uint32Array(W * H); for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) m[y * W + x] = img[y * W + W - 1 - x]; img = m; }
  return img;
}
return {makeCharacter, HUMAN_BASE, CELL, R, portrait, spriteFrame, ANIMS, _chibi: chibiGrid};
})();

const HF_HAIR = {bob:'bob', spiky:'spiky', topbun:'ponytail', short:'short', granbun:'buns', tufts:'bald', long:'long', twintails:'pigtails', fluffy:'curly', crop:'neat', swept:'short', braid:'ponytail', topknot:'ponytail', bald:'bald'};
const HF_EYES = {neutral:'dots', smile:'dots', happy:'happy', laugh:'happy', surprised:'sparkle', sleepy:'sleepy', concerned:'dots', excited:'sparkle', angry:'dots', sad:'dots', love:'dots', wink:'dots'};
const HF_TOP = {dress:'dress', cardigan:'cardigan', hoodie:'hoodie', tee:'tshirt', teepants:'tshirt'};
// portrait headwear comes from each hat's recipe (portrait_hats.js); without one it is built from the sprite
function hfHatAuto(hat){
  if (!hat.rows) return null;
  const n = {}; hat.rows.join('').split('').forEach(c => { if (c !== '.' && c !== '2') n[c] = (n[c] || 0) + 1; });
  const ks = Object.keys(n).sort((a, b) => n[b] - n[a]);
  return {rows: hat.rows, y: hat.y || 0, keys: [ks[0], ks.find(k => k === k.toLowerCase() && k !== k.toUpperCase()) || null, ks[1] && ks[1] !== ks[1].toLowerCase() ? ks[1] : ks[2] || null, ks[3] || null], covers: (hat.y || 0) <= 2 && hat.hideHair !== false};
}
const HF_CACHE = new Map();
function hfRecipe(look){
  const hair = HAIRS[look.hair].id, face = FACES[look.face].id, outfit = OUTFITS[look.outfit], dye = DYES[look.dye] || DYES[0];
  const hc = HAIR_COLORS[look.hairColor], skin = SKINS[look.skin], fh = FACIAL_HAIR[look.facialHair].id, fw = FACIAL_WEAR[look.facialWear].id;
  const hat = look.hatOff ? HATS[0] : HATS[look.hat];
  const A = (look.outfitColors && look.outfitColors.A) || dye.A || outfit.colors.A;
  const hc2 = Object.assign({}, hat.colors || {}, look.hatColors || {}), auto = hat.portrait ? null : hfHatAuto(hat);
  const cols = hat.portrait ? hat.portrait.keys : auto ? auto.keys : ['A', 'a', 'C', 'G'];
  const aCol = (look.outfitColors && look.outfitColors.a) || dye.a || outfit.colors.a;
  const eye = EYE_COLORS[look.eyeColor || 0] || EYE_COLORS[0];
  const fwC = FACIAL_WEAR[look.facialWear].colors || {}, nk = NECKWEAR[look.neck || 0] || NECKWEAR[0], nkC = nk.colors || {};
  const soft = ['long', 'bob', 'twintails', 'braid', 'topbun', 'granbun'].includes(hair);
  return Object.assign({}, HF.HUMAN_BASE, {
    age: hc.id === 'silver' ? 'elder' : (fh !== 'none' ? 'adult' : 'kid'),
    skin: skin.n, hair: HF_HAIR[hair] || 'short', hairColor: hc.H,
    eyes: (HF_EYES[face] === 'dots' && eyeShapeOf(look) === 'lashes') ? 'lashes' : (HF_EYES[face] || 'dots'),
    eyeShape: eyeShapeOf(look), body: (BODIES[look.body || 0] || BODIES[0]).id,
    facial: ['beard', 'longbeard'].includes(fh) ? 'beard' : (['mustache', 'handlebar'].includes(fh) ? 'mustache' : 'none'),
    glasses: ['round', 'square'].includes(fw), freckles: fw === 'freckles', blush: true,
    top: HF_TOP[outfit.id] || 'sweater', topColor: A, emblem: 'none',
    bottom: ['dress', 'robe', 'hakama', 'leaftunic'].includes(outfit.id) ? 'skirt' : 'jeans',
    bottomColor: (look.outfitColors && look.outfitColors.L) || dye.L || outfit.colors.L || outfit.colors.M || '#4e83ad',
    shoeColor: outfit.id === 'plate' ? '#9aa3ad' : '#7a473f',
    hat: hat.id, hatSpec: hat.portrait || null, hatAuto: auto, hatColor: hc2[cols[0]] || '#3e5ba9', expr: face,
    palOverride: {hair: hc.H, hairDark: hc.D, hairLight: hc.h, skin: skin.n, skinShade: skin.S, outline: PAL.outline, top: A, topDark: aCol || null, white: PAL.white, glint: PAL.shine},
    hatShade: (cols[1] && hc2[cols[1]]) || null, trimColor: (cols[2] && hc2[cols[2]]) || null, accColor: (cols[3] && hc2[cols[3]]) || (hat.id === 'knight' ? '#db614f' : null),
    emblemColor: hat.id === 'straw' && outfit.id !== 'cardigan' ? (hc2.C || '#db614f') : HF.HUMAN_BASE.emblemColor,
    irisColor: eye.I, irisLight: eye.i, faceWear: fw, emote: 'none',
    maskColor: fw === 'menpo' ? '#b4473b' : fw === 'eyepatch' ? '#3a3436' : (fwC.A || '#3a3436'),
    frameColor: fwC.F || fwC.G || null,
    ttHair: hair, ttBeard: fh, tieColor: hair === 'topknot' ? '#fbf7ee' : '#f5777d',
    neckwear: nk.id, neckColor: nk.id === 'amulet' ? nkC.G : (nkC.C || null), neckShade: nkC.c || null, neckAcc: nk.id === 'amulet' ? nkC.R : (nkC.W || nkC.G || null)
  });
}
function composePortraitHF(look){
  const pose = portraitPose(look);
  const dir = pose.turn !== 0 ? 'SE' : 'S', mirror = pose.turn < 0;   // SW is SE mirrored: same face, both eyes
  const rec = hfRecipe(look), key = JSON.stringify(rec) + dir + mirror;
  let out = HF_CACHE.get(key);
  if (!out) {
    const {g, L, pal} = HF.portrait(rec, dir);
    const N = 48, x0 = Math.round(L.sb.cx) - N / 2, y0 = L.sb.y0 - 11;
    out = Array.from({length:N}, (_, y) => Array.from({length:N}, (_, x) => { const v = g.get(x0 + (mirror ? N - 1 - x : x), y0 + y); return v >= 0 ? pal[v] : null; }));
    HF_CACHE.set(key, out); if (HF_CACHE.size > 120) HF_CACHE.delete(HF_CACHE.keys().next().value);
  }
  return out;
}

// Town people from the Tiny Town sheet, rebuilt from parts, and job outfit previews.
function look(o){
  const L = {hair:'bob', hairColor:'chestnut', skin:'peach', face:'neutral', facialHair:'none', facialWear:'none',
    hat:'none', outfit:'tee', dye:'default', weapon:'none', offhand:'none', neck:'none', pet:'none', eyeColor:'dark', portraitBg:'auto', portraitTilt:1, tier:1, leftHanded:false, hatOff:false,
    outfitColors:null, hatColors:null, gearColors:null, body:'standard', eyeShape:'auto'};
  return Object.assign(L, o);
}
const TOWN = [
  {name:'Girl',     look:look({body:'young', eyeShape:'big', })},
  {name:'Boy',      look:look({body:'young', eyeShape:'big', hair:'spiky', hairColor:'ink', dye:'peri'})},
  {name:'Woman',    look:look({hair:'topbun', outfit:'dress'})},
  {name:'Man',      look:look({body:'tall', hair:'short', outfit:'teepants', dye:'lilac'})},
  {name:'Grandma',  look:look({body:'old', hair:'granbun', hairColor:'silver', facialWear:'round', outfit:'cardigan', face:'smile'})},
  {name:'Grandpa',  look:look({body:'old', eyeShape:'narrow', hair:'tufts', hairColor:'silver', facialHair:'mustache', outfit:'teepants', dye:'butter', face:'smile'})},
  {name:'Chef',     look:look({body:'stout', hair:'crop', hat:'chef', outfit:'chef', weapon:'spoon'})},
  {name:'Baker',    look:look({body:'stout', hair:'bob', hairColor:'cocoa', hat:'baker', outfit:'apron', face:'smile', offhand:'bread'})},
  {name:'Barista',  look:look({hair:'crop', hat:'fedora', outfit:'overalls', dye:'butter', neck:'bowtie'})},
  {name:'Farmer',   look:look({body:'stout', eyeShape:'narrow', hair:'short', hat:'straw', outfit:'overalls'})},
  {name:'Gardener', look:look({hair:'bob', hat:'bucketflower', outfit:'overalls', dye:'mint',
    outfitColors:{B:'#6aa04a', b:'#4e7d36', L:'#6aa04a', M:'#4e7d36'}, offhand:'bouquet', face:'smile'})},
  {name:'Florist',  look:look({eyeShape:'lashes', hair:'long', hairColor:'ink', hat:'flower', outfit:'dress', dye:'blush', offhand:'bouquet', face:'happy'})},
  {name:'Fisher',   look:look({eyeShape:'narrow', hair:'spiky', hat:'bucket', outfit:'tee', dye:'forest', weapon:'rod', neck:'kerchief'})},
  {name:'Sailor',   look:look({body:'tall', hair:'spiky', hat:'sailor', outfit:'sailor', neck:'bluescarf'})},
  {name:'Pirate',   look:look({hair:'bob', hat:'bandana', outfit:'teepants', dye:'lilac', face:'smile'})},
  {name:'Knight',   look:look({body:'tall', hat:'knight', outfit:'plate', weapon:'sword'})}
];
const JOBS = [
  {name:'Knight', blurb:'Front line', look:look({body:'tall', hair:'short', hat:'knight', outfit:'plate', weapon:'sword', offhand:'kite'})},
  {name:'Black Mage', blurb:'Spells', look:look({body:'young', eyeShape:'big', hair:'bob', hairColor:'ink', hat:'wizard', outfit:'robe', weapon:'staff', offhand:'book'})},
  {name:'White Mage', blurb:'Healer', look:look({hat:'hood', outfit:'robe', outfitColors:{A:'#fbf7ee', a:'#e3dccb', C:'#db614f'},
    weapon:'staff', gearColors:{R:'#89c9bc', r:'#79af98', w:'#f9c776'}, face:'smile'})},
  {name:'Thief', blurb:'Speed', look:look({eyeShape:'narrow', hair:'swept', hairColor:'cocoa', facialWear:'mask', outfit:'leather',
    outfitColors:{A:'#3a3436', a:'#26232a', C:'#7a473f', L:'#26232a', M:'#171b20'}, weapon:'dagger'})},
  {name:'Ranger', blurb:'Range', look:look({eyeShape:'big', hair:'long', hairColor:'honey', hat:'feather', outfit:'cloak', weapon:'bow'})},
  {name:'Monk', blurb:'Fists', look:look({body:'stout', hair:'crop', hairColor:'ink', hat:'headband', outfit:'tunic',
    outfitColors:{A:'#eba25e', a:'#c98a3a', C:'#583937', L:'#583937', M:'#3a3436'}, face:'excited'})},
  {name:'Dragoon', blurb:'Jumps', look:look({hat:'dragon', outfit:'plate', outfitColors:{A:'#4e83ad', a:'#3d6a8f', C:'#f9c776'}, weapon:'spear'})},
  {name:'Berserker', blurb:'Rage', look:look({body:'tall', hair:'short', hairColor:'honey', facialHair:'beard', hat:'horned', outfit:'furvest', weapon:'greataxe', face:'angry', eyeColor:'blue'})},
  {name:'Samurai', blurb:'Precision', look:look({eyeShape:'narrow', hair:'topknot', hairColor:'ink', hat:'kabuto', facialWear:'menpo', outfit:'hakama', weapon:'katana', eyeColor:'amber'})},
  {name:'Druid', blurb:'Beasts & nature', look:look({eyeShape:'lashes', hair:'long', hairColor:'cocoa', hat:'antlers', outfit:'leaftunic', weapon:'druidstaff', pet:'pinkslime', face:'smile', eyeColor:'green'})},
  {name:'Bard', blurb:'Buffs', look:look({hair:'braid', hairColor:'ginger', hat:'feather', hatColors:{A:'#a77daa', a:'#86618a', C:'#f9c776'},
    outfit:'vest', outfitColors:{A:'#fbf7ee', a:'#e3dccb', B:'#a77daa', b:'#86618a'}, offhand:'lyre', face:'happy'})}
];


const $ = id => document.getElementById(id);
const TS = 16, MW = 40, MH = 28;
const INK = PAL.outline;
const C = {grass:'#aed287', grassD:'#8fbf5a', grassL:'#c6e3a0', path:'#ecd6b6', pathD:'#d6b48f', pathL:'#f6e7d0',
  stone:'#e3dccb', stoneD:'#cdbb8c', stoneL:'#fbf7ee', water:'#a3def4', waterD:'#7cc0d8', waterL:'#e6f6fc', deep:'#4e83ad',
  soil:'#9a6a3e', soilD:'#6e4a2c', soilL:'#b9875a', wood:'#c78659', woodD:'#935746', woodL:'#e0a87a',
  leaf:'#6aa04a', leafD:'#4e7d36', leafL:'#8fbf5a', trunk:'#7a473f', trunkD:'#583937', wall:'#fbf7ee', wallD:'#e3dccb',
  glass:'#a3def4', glassL:'#ffffff', gold:'#f9c776', goldD:'#c99a3a', shadow:'rgba(47,42,38,.2)'};
const hash = (x, y, k = 0) => { let h = (x * 374761393 + y * 668265263 + k * 2147483647) | 0; h = (h ^ (h >>> 13)) * 1274126177; return ((h ^ (h >>> 16)) >>> 0); };

/* ---------- map ---------- */
const GRASS = 0, PATH = 1, STONE = 2, WATER = 3, SOIL = 4, PIER = 5;
const G = Array.from({length: MH}, () => new Array(MW).fill(GRASS));
const B = Array.from({length: MH}, () => new Array(MW).fill(false));
const fill = (x0, y0, x1, y1, t) => { for (let y = y0; y <= y1; y++) for (let x = x0; x <= x1; x++) G[y][x] = t; };
const block = (x0, y0, x1, y1) => { for (let y = y0; y <= y1; y++) for (let x = x0; x <= x1; x++) if (y >= 0 && x >= 0 && y < MH && x < MW) B[y][x] = true; };
fill(2, 13, MW - 3, 14, PATH); fill(19, 1, 20, 12, PATH); fill(19, 15, 20, MH - 3, PATH);
fill(14, 9, 25, 18, STONE);
for (let y = 17; y < 26; y++) for (let x = 2; x < 14; x++) if (((x + 0.5 - 7.5) / 5.6) ** 2 + ((y + 0.5 - 21.5) / 3.9) ** 2 <= 1) G[y][x] = WATER;
fill(7, 17, 8, 21, PIER);
for (const y of [20, 22, 24]) fill(27, y, 35, y, SOIL);
const BUILDINGS = [
  {name: 'Bakery', x: 3, y: 3, w: 6, h: 5, roof: '#db614f', roofD: '#b4473b', door: 3, icon: 'bread'},
  {name: 'Guild Hall', x: 11, y: 2, w: 7, h: 6, roof: '#4e83ad', roofD: '#3d6a8f', door: 3, icon: 'shield'},
  {name: 'Flowers', x: 27, y: 3, w: 6, h: 5, roof: '#d67599', roofD: '#a85a7a', door: 2, icon: 'flower'}];
BUILDINGS.forEach(b => { block(b.x, b.y, b.x + b.w - 1, b.y + b.h - 1); fill(b.x + b.door, b.y + b.h, b.x + b.door, 12, PATH); });
for (let y = 0; y < MH; y++) for (let x = 0; x < MW; x++) if (G[y][x] === WATER) B[y][x] = true;
block(0, 0, MW - 1, 0); block(0, MH - 1, MW - 1, MH - 1); block(0, 0, 0, MH - 1); block(MW - 1, 0, MW - 1, MH - 1);

/* ---------- pixel helpers ---------- */
function sprite(w, h, paintFn, opts = {}) {
  const cv = document.createElement('canvas'); cv.width = w; cv.height = h;
  const ctx = cv.getContext('2d'), cols = [];
  for (let y = 0; y < h; y++) { cols.push([]); for (let x = 0; x < w; x++) cols[y].push(paintFn(x, y)); }
  const at = (x, y) => x >= 0 && y >= 0 && x < w && y < h ? cols[y][x] : null;
  for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
    let c = cols[y][x];
    if (!c && !opts.noOutline && [[1, 0], [-1, 0], [0, 1], [0, -1]].some(([dx, dy]) => at(x + dx, y + dy) && at(x + dx, y + dy) !== INK)) c = INK;
    if (c) { ctx.fillStyle = c; ctx.fillRect(x, y, 1, 1); }
  }
  return cv;
}
const inEll = (x, y, cx, cy, rx, ry) => ((x + 0.5 - cx) / rx) ** 2 + ((y + 0.5 - cy) / ry) ** 2 <= 1;
const BAYER = [[0, 8, 2, 10], [12, 4, 14, 6], [3, 11, 1, 9], [15, 7, 13, 5]];
const dith = (x, y) => (BAYER[y & 3][x & 3] + 0.5) / 16;
function vnoise(x, y, s, k = 0) {
  const fx = x / s, fy = y / s, x0 = Math.floor(fx), y0 = Math.floor(fy), tx = fx - x0, ty = fy - y0;
  const r = (a, b) => (hash(a, b, k) % 1000) / 1000, sm = t => t * t * (3 - 2 * t);
  const a = r(x0, y0), b = r(x0 + 1, y0), c = r(x0, y0 + 1), d = r(x0 + 1, y0 + 1), u = sm(tx), v = sm(ty);
  return a + (b - a) * u + (c - a) * v + (a - b - c + d) * u * v;
}
const ramp = (v, cols) => cols[Math.max(0, Math.min(cols.length - 1, Math.floor(v * cols.length)))];
function shadeHex(hex, amt) { const n = [1, 3, 5].map(i => Math.max(0, Math.min(255, parseInt(hex.slice(i, i + 2), 16) + amt))); return '#' + n.map(v => v.toString(16).padStart(2, '0')).join(''); }

/* ---------- trees, bushes, grass ---------- */
// a canopy is a pile of leaf clusters, each lit from the top left, with darker seams where clusters overlap
function canopy(w, h, clusters, cols, trunk, extra) {
  const which = (x, y) => { let best = -1; clusters.forEach((c, i) => { if (inEll(x, y, c[0], c[1], c[2], c[2] * 0.92)) best = i; }); return best; };
  return sprite(w, h, (x, y) => {
    const i = which(x, y);
    if (i >= 0) {
      const [cx, cy, r] = clusters[i], nx = (x + 0.5 - cx) / r, ny = (y + 0.5 - cy) / r;
      if (which(x, y - 1) < 0) return cols.rim;
      const below = which(x, y + 1); if (below >= 0 && below !== i && below > i) return cols.dark;
      if (extra) { const e = extra(x, y); if (e) return e; }
      if (nx + ny < -0.75) return cols.light;
      if (nx + ny > 0.6) return cols.dark;
      if ((x * 5 + y * 3) % 17 === 0) return cols.light;
      return cols.base;
    }
    return trunk ? trunk(x, y) : null;
  });
}
const LEAVES = {base: '#6aa04a', light: '#8fbf5a', dark: '#4e7d36', rim: '#a9d47a'};
const BARK = (x, y) => {
  if (x >= 14 && x <= 20 && y >= 27 && y <= 40) { if (x === 14) return '#9a6a5c'; if (x >= 19) return '#583937'; return (y + x * 3) % 7 === 0 ? '#583937' : '#7a473f'; }
  if (y >= 38 && y <= 40 && (x >= 11 && x <= 13 || x >= 21 && x <= 23)) return y === 40 ? '#583937' : '#7a473f';
  return null;
};
const OAK = canopy(34, 42, [[17, 9, 9], [8, 15, 7.5], [26, 15, 7.5], [17, 16, 10], [10, 22, 7], [24, 22, 7], [17, 24, 8]], LEAVES, BARK);
const BLOSSOM = canopy(34, 42, [[17, 9, 9], [8, 15, 7.5], [26, 15, 7.5], [17, 16, 10], [10, 22, 7], [24, 22, 7], [17, 24, 8]], LEAVES, BARK,
  (x, y) => (hash(x, y, 5) % 13 === 0) ? '#f29bb8' : (hash(x, y, 6) % 29 === 0) ? '#fdc9ca' : null);
const PINE = sprite(26, 44, (x, y) => {
  for (let t = 0; t < 4; t++) {
    const top = 2 + t * 8, base = top + 13, half = 4 + t * 2.6;
    if (y >= top && y <= base) { const wdt = (y - top) / (base - top) * half; if (Math.abs(x + 0.5 - 13) <= wdt) {
      if (y === base || y === base - 1 && (x % 3 === 0)) return '#3d6a3f';
      return x + 0.5 < 13 - wdt * 0.4 ? '#5e9a52' : x + 0.5 > 13 + wdt * 0.5 ? '#3d6a3f' : '#4e8547'; } }
  }
  if (x >= 11 && x <= 14 && y >= 36 && y <= 43) return x === 11 ? '#9a6a5c' : '#7a473f';
  return null;
});
const BUSH = [0, 1, 2].map(v => canopy(22, 16, [[6, 9, 5.5], [15, 9, 5.5], [11, 6, 6], [11, 10, 6]], LEAVES, null,
  v === 1 ? (x, y) => hash(x, y, 9) % 11 === 0 ? '#db614f' : null : v === 2 ? (x, y) => hash(x, y, 4) % 10 === 0 ? '#fbf7ee' : null : null));
// tall grass: blades fanning out from a clump, like the dune grass in the reference
const TUFT = [0, 1].map(v => sprite(16, 15, (x, y) => {
  const blades = [[-6, 9], [-4, 12], [-2, 14], [0, 13], [2, 14], [4, 12], [6, 9], [-1, 10], [3, 9]];
  for (let i = 0; i < blades.length; i++) {
    const [dx, len] = blades[i], t = (14 - y) / len; if (t < 0 || t > 1) continue;
    const bx = 8 + dx * t * t * 0.9 + (v ? 0.4 : -0.4) * t * 3;
    if (Math.abs(x + 0.5 - bx) <= (t < 0.35 ? 0.9 : 0.5)) return t > 0.82 ? '#cbe4a6' : i % 3 === 0 ? '#6aa04a' : i % 3 === 1 ? '#8fbf5a' : '#7cae55';
  }
  return null;
}, {noOutline: false}));
const REEDS = sprite(14, 22, (x, y) => {
  for (const [sx, top] of [[3, 3], [7, 0], [11, 5]]) { if (x === sx && y >= top + 5) return '#6aa04a'; if ((x === sx || x === sx + 1) && y >= top && y < top + 5) return x === sx ? '#9a6a3e' : '#7a473f'; }
  if (y >= 15 && ((x + y) % 4 === 0) && x > 1 && x < 13) return '#8fbf5a';
  return null;
});
const LILY = [0, 1].map(v => sprite(12, 8, (x, y) => {
  if (!inEll(x, y, 6, 4, 5.5, 3.4)) return null;
  if (x >= 6 && x <= 7 && y <= 3) return null;
  if (v && inEll(x, y, 4, 3, 1.8, 1.4)) return x < 4 ? '#fdc9ca' : '#f29bb8';
  return y > 4 ? '#4e7d36' : (x + y) % 5 === 0 ? '#8fbf5a' : '#6aa04a';
}));
const MUSHROOM = sprite(10, 10, (x, y) => {
  if (y <= 5 && inEll(x, y, 5, 5, 4.5, 4)) return (x === 3 && y === 2 || x === 6 && y === 3) ? '#fbf7ee' : y > 3 ? '#b4473b' : '#db614f';
  if (x >= 4 && x <= 5 && y > 5 && y <= 8) return x === 4 ? '#fbf7ee' : '#e3dccb';
  return null;
});

/* ---------- town props ---------- */
const BARREL = sprite(14, 18, (x, y) => {
  if (!(x >= 1 && x <= 12 && y >= 1 && y <= 16)) return null;
  if (y === 1 && (x === 1 || x === 12) || y === 16 && (x === 1 || x === 12)) return null;
  if (y === 4 || y === 13) return '#5a5e6b';
  if (y <= 2) return '#9a6a3e';
  return x <= 2 ? '#d49364' : x >= 11 ? '#7a473f' : x % 3 === 0 ? '#a8683f' : '#c78659';
});
const CRATE = sprite(16, 16, (x, y) => {
  if (x < 1 || x > 14 || y < 1 || y > 14) return null;
  if (x <= 2 || x >= 13 || y <= 2 || y >= 12) return x <= 2 || y <= 2 ? '#d49364' : '#9a6a3e';
  if (Math.abs((x - 2) - (y - 2) * 1.1) < 1.1) return '#9a6a3e';
  return y % 4 === 0 ? '#b97a4c' : '#c78659';
});
const POT = [0, 1, 2].map(v => sprite(12, 16, (x, y) => {
  if (y >= 9 && y <= 15 && x >= 2 + (y - 9) * 0.3 && x <= 9 - (y - 9) * 0.3) return y === 9 ? '#eba25e' : x <= 3 ? '#db8a5a' : '#b4673f';
  const fl = ['#f29bb8', '#f9c776', '#fbf7ee'][v];
  if (y < 9 && inEll(x, y, 6, 5, 5, 4)) return (x + y) % 3 === 0 ? fl : (hash(x, y, v) % 3 === 0 ? '#4e7d36' : '#6aa04a');
  return null;
}));
const BOAT = sprite(36, 14, (x, y) => {
  const hull = y >= 4 && y <= 12 && x >= 2 + Math.max(0, (y - 4) * 0.6) && x <= 33 - Math.max(0, (y - 4) * 0.6);
  if (!hull) return null;
  if (y <= 5) return '#e0a87a';
  if (y >= 6 && y <= 8 && x >= 6 && x <= 29) return x % 8 === 0 ? '#7a473f' : '#9a6a3e';
  return y >= 11 ? '#7a473f' : y === 9 ? '#fbf7ee' : '#c78659';
});
const BENCH = sprite(32, 18, (x, y) => {
  if (y >= 1 && y <= 6 && x >= 2 && x <= 29) return y === 1 ? '#e0a87a' : y === 3 ? '#9a6a3e' : '#c78659';
  if (y >= 8 && y <= 11 && x >= 0 && x <= 31) return y === 8 ? '#e0a87a' : y === 11 ? '#9a6a3e' : '#d49364';
  if (y >= 12 && y <= 17 && (x === 3 || x === 4 || x === 27 || x === 28)) return '#5a5e6b';
  return null;
});
const LAMP = sprite(12, 36, (x, y) => {
  if (y <= 1 && x >= 3 && x <= 8) return '#3a3436';
  if (y >= 2 && y <= 9 && x >= 1 && x <= 10) { if (y === 2 || y === 9 || x === 1 || x === 10) return '#3a3436'; return x < 5 && y < 6 ? '#fff6c8' : '#f9c776'; }
  if (x >= 5 && x <= 6 && y > 9 && y < 32) return x === 5 ? '#5a5e6b' : '#3a3436';
  if (y >= 32 && x >= 2 && x <= 9) return y === 32 ? '#5a5e6b' : '#3a3436';
  return null;
});
const STALL = sprite(52, 46, (x, y) => {
  if (y <= 12) { const band = Math.floor(x / 6) % 2; if (y >= 10) return (y === 12 || (x % 6) === 3 && y === 11) ? (band ? '#b4473b' : '#e3dccb') : band ? '#db614f' : '#fbf7ee'; if (y <= 1) return '#b4473b'; return band ? '#db614f' : '#fbf7ee'; }
  if ((x === 3 || x === 4 || x === 47 || x === 48) && y > 12 && y < 27) return x === 3 || x === 47 ? '#c78659' : '#9a6a3e';
  if (y >= 26 && y <= 45 && x >= 2 && x <= 49) { if (y === 26) return '#e0a87a'; if (y > 42) return '#7a473f'; return (x % 8 === 0) ? '#9a6a3e' : '#c78659'; }
  if (y >= 20 && y <= 25) for (const cx of [10, 18, 26, 34]) if (x >= cx && x <= cx + 4) return y === 20 ? '#7a473f' : x === cx + 4 ? '#e3dccb' : '#fbf7ee';
  if (y >= 15 && y <= 18 && x >= 38 && x <= 45) return y === 15 ? '#9a6a3e' : '#f9c776';
  return null;
});
const FOUNTAIN = sprite(64, 58, (x, y) => {
  if (inEll(x, y, 32, 42, 30, 14)) {
    if (inEll(x, y, 32, 40, 25, 9.5)) return inEll(x, y, 32, 40, 21, 7) ? ((hash(x, y, 2) % 13 === 0) ? '#e6f6fc' : y < 37 ? '#8fcfe8' : '#a3def4') : '#7cc0d8';
    if (y < 33) return '#f3eee3';
    return y > 47 ? '#cdbb8c' : (Math.floor(x / 6) + (y > 42 ? 1 : 0)) % 2 ? '#e3dccb' : '#d8cfbb';
  }
  if (x >= 28 && x <= 36 && y >= 14 && y <= 38) return x <= 29 ? '#f3eee3' : x >= 35 ? '#cdbb8c' : '#e3dccb';
  if (inEll(x, y, 32, 15, 11, 5)) return inEll(x, y, 32, 14, 8, 2.6) ? '#a3def4' : y > 16 ? '#cdbb8c' : '#e3dccb';
  if (x >= 31 && x <= 33 && y >= 5 && y <= 11) return x === 31 ? '#e6f6fc' : '#a3def4';
  return null;
});
const FENCE_H = sprite(16, 14, (x, y) => (x >= 6 && x <= 9) ? (y <= 1 ? '#e0a87a' : x === 6 ? '#d49364' : x === 9 ? '#9a6a3e' : '#c78659') : (y === 4 || y === 5 || y === 9 || y === 10) ? (y % 5 === 0 ? '#9a6a3e' : '#c78659') : null);
const FENCE_V = sprite(8, 18, (x, y) => (x >= 2 && x <= 5) ? (x === 2 ? '#d49364' : x === 5 ? '#9a6a3e' : y % 8 === 0 ? '#9a6a3e' : '#c78659') : null);
const CABBAGE = sprite(12, 10, (x, y) => inEll(x, y, 6, 5, 5.5, 4.5) ? (inEll(x, y, 4.5, 3.5, 2.5, 2) ? '#b6de7c' : (x + y) % 4 === 0 ? '#4e7d36' : '#8fbf5a') : null);
const CARROT = sprite(10, 10, (x, y) => (y <= 5 && (x === 2 || x === 5 || x === 7) && y >= (x === 5 ? 0 : 2)) ? '#6aa04a' : (y >= 6 && x >= 2 && x <= 7 && y <= 8) ? (x === 2 ? '#f9c776' : '#eba25e') : null);
const SIGN = sprite(18, 22, (x, y) => (y <= 9 && x >= 1 && x <= 16) ? (y === 1 ? '#e0a87a' : y === 9 ? '#9a6a3e' : (x + y) % 9 === 0 ? '#9a6a3e' : '#c78659') : (x >= 8 && x <= 9 && y > 9) ? (x === 8 ? '#9a6a3e' : '#7a473f') : null);
const ROCK = sprite(14, 10, (x, y) => inEll(x, y, 7, 5.5, 6.5, 4.5) ? (inEll(x, y, 5, 3.5, 3, 2) ? '#f3eee3' : y > 6 ? '#bfb39a' : (y < 3 && x > 8) ? '#8fbf5a' : '#d8cfbb') : null);
function signIcon(kind, x, y) {
  const I = {bread: ['...........', '...TTTTT...', '..TttTtT...', '.TTTTTTTT..', '.TTTTTTTT..', '...........'],
    shield: ['....BBB....', '...BGGGB...', '...BGBGB...', '...BBGBB...', '....BBB....', '.....B.....'],
    flower: ['....P.P....', '...PPYPP...', '....PPP....', '.....G.....', '....GG.....', '...........']}[kind];
  const k = I && I[y] && I[y][x]; if (!k || k === '.') return null;
  return {T: '#d49364', t: '#f9c776', B: '#3d6a8f', G: kind === 'flower' ? '#6aa04a' : '#f9c776', P: '#f29bb8', Y: '#f9c776'}[k];
}
// houses: stone footing, plank walls, timber corners, eave shadow, shingles, window boxes, a chimney
function house(b) {
  const W = b.w * TS, H = b.h * TS + 6, wallTop = Math.round(H * 0.5), dx = b.door * TS, chimX = W - 16;
  return sprite(W, H, (x, y) => {
    const inset = Math.max(0, 7 - y * 0.6);
    if (y <= 10 && x >= chimX && x <= chimX + 7 && y >= 0) return y < 2 ? '#5a5e6b' : x === chimX ? '#d49364' : x === chimX + 7 ? '#8c3a30' : (y % 3 === 0 ? '#8c3a30' : '#b4473b');
    if (y < wallTop + 2 && x >= inset && x <= W - 1 - inset) {
      if (y >= wallTop) return b.roofD;
      if (y <= 1) return shadeHex(b.roof, 30);
      const row = Math.floor((y - 2) / 4), ly = (y - 2) % 4, sx = (x + row * 4) % 8;
      if (ly === 3) return b.roofD;
      if (sx === 0) return b.roofD;
      if (ly === 0 && sx < 4) return shadeHex(b.roof, 22);
      return b.roof;
    }
    if (y >= wallTop + 2 && x >= 2 && x <= W - 3) {
      if (x >= dx + 3 && x <= dx + 12 && y >= H - 15) { if (x === dx + 3 || x === dx + 12 || y === H - 15) return INK; if (x === dx + 10 && y === H - 8) return '#f9c776'; if (y === H - 1) return '#5a5e6b'; return (x - dx) % 3 === 0 ? '#9a6a3e' : '#c78659'; }
      if (x >= dx + 1 && x <= dx + 14 && y >= H - 26 && y <= H - 18) { if (y === H - 26 || y === H - 18 || x === dx + 1 || x === dx + 14) return INK; return signIcon(b.icon, x - dx - 2, y - (H - 25)) || '#e0a87a'; }
      for (const wx of [8, W - 22]) if (Math.abs(wx + 6 - (dx + 8)) > 12) {
        if (x >= wx && x <= wx + 11 && y >= wallTop + 7 && y <= wallTop + 16) {
          if (x === wx || x === wx + 11 || y === wallTop + 7 || y === wallTop + 16) return INK;
          if (x === wx + 6 || y === wallTop + 11) return '#fbf7ee';
          return (x - wx < 4 && y - wallTop < 10) ? '#ffffff' : (x - wx > 7 && y - wallTop > 12) ? '#7cc0d8' : '#a3def4';
        }
        if (x >= wx - 1 && x <= wx + 12 && y >= wallTop + 17 && y <= wallTop + 20) { if (y === wallTop + 17) return '#9a6a3e'; return (x + y) % 3 === 0 ? ['#f29bb8', '#f9c776', '#fbf7ee'][hash(x, b.x) % 3] : (y === wallTop + 20 ? '#7a473f' : '#6aa04a'); }
      }
      if (y >= H - 4) return (Math.floor(x / 5) + (y === H - 3 ? 1 : 0)) % 2 ? '#bfb39a' : '#d8cfbb';
      if (y <= wallTop + 3) return '#c9bda4';
      if (x <= 4 || x >= W - 6) return x <= 4 ? '#c78659' : '#9a6a3e';
      return (y - wallTop) % 5 === 0 ? '#e3dccb' : (x > W - 14 ? '#efe8d8' : '#fbf7ee');
    }
    return null;
  });
}

/* ---------- ground: organic edges, noise shading, dithering ---------- */
const ground = document.createElement('canvas'); ground.width = MW * TS; ground.height = MH * TS;
const GW_ = MW * TS, GH_ = MH * TS, TER = new Uint8Array(GW_ * GH_);
(function drawGround() {
  const g = ground.getContext('2d'), img = g.createImageData(GW_, GH_), D = img.data;
  const rawAt = (px, py) => G[Math.min(MH - 1, Math.max(0, Math.floor(py / TS)))][Math.min(MW - 1, Math.max(0, Math.floor(px / TS)))];
  for (let py = 0; py < GH_; py++) for (let px = 0; px < GW_; px++) {
    const raw = rawAt(px, py);
    let t = raw;
    if (raw !== STONE && raw !== PIER) { const j = (vnoise(px, py, 9, 1) - 0.5) * 7, k = (vnoise(px, py, 9, 2) - 0.5) * 7; const w2 = rawAt(px + j, py + k); t = (w2 === STONE || w2 === PIER) ? raw : w2; }
    TER[py * GW_ + px] = t;
  }
  // distance from the shore for the pond's depth
  const dist = new Int16Array(GW_ * GH_).fill(999), q = [];
  for (let i = 0; i < TER.length; i++) if (TER[i] !== WATER) { dist[i] = 0; q.push(i); }
  for (let h = 0; h < q.length; h++) { const i = q[h], x = i % GW_, y = (i / GW_) | 0; for (const [dx, dy] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) { const nx = x + dx, ny = y + dy; if (nx < 0 || ny < 0 || nx >= GW_ || ny >= GH_) continue; const j = ny * GW_ + nx; if (dist[j] > dist[i] + 1) { dist[j] = dist[i] + 1; q.push(j); } } }
  const near = (x, y, r, type) => { for (let dy = -r; dy <= r; dy++) for (let dx = -r; dx <= r; dx++) { const nx = x + dx, ny = y + dy; if (nx >= 0 && ny >= 0 && nx < GW_ && ny < GH_ && TER[ny * GW_ + nx] === type) return true; } return false; };
  const GRS = ['#8fbf5a', '#9fca6d', '#aed287', '#bcdb92', '#c9e2a3'], DIRT = ['#d6b68e', '#e0c49f', '#e9d2b1', '#f2e2c6'], WAT = ['#7cc0d8', '#8fcfe8', '#a3def4'];
  const STONES = ['#e3dccb', '#ddd4c0', '#e9e3d5', '#d6ccb6'];
  for (let y = 0; y < GH_; y++) for (let x = 0; x < GW_; x++) {
    const i = y * GW_ + x, t = TER[i]; let c;
    if (t === GRASS) {
      if (near(x, y, 2, WATER)) c = near(x, y, 1, WATER) ? '#d6c49a' : '#e2d3ae';
      else if (near(x, y, 1, PATH)) c = GRS[0];
      else { const v = vnoise(x, y, 26, 3) * 0.7 + vnoise(x, y, 7, 4) * 0.3 + (dith(x, y) - 0.5) * 0.22; c = ramp((v - 0.18) / 0.66, GRS.slice(1)); }
    } else if (t === PATH) {
      if (near(x, y, 1, GRASS)) c = '#c9a67c';
      else { const v = vnoise(x, y, 11, 5) * 0.7 + vnoise(x, y, 3, 6) * 0.3 + (dith(x, y) - 0.5) * 0.2; c = ramp((v - 0.15) / 0.7, DIRT); }
    } else if (t === STONE) {
      const edge = near(x, y, 1, GRASS) || near(x, y, 1, PATH) || near(x, y, 1, WATER);
      if (edge) c = '#bfae8c';
      else {
        const row = Math.floor(y / 7), ly = y % 7, off = row % 2 ? 4 : 0, col = Math.floor((x + off) / 9), lx = (x + off) % 9;
        if (lx === 0 || ly === 0) c = '#c8b998';
        else if (lx === 1 || ly === 1) c = '#f3eee3';
        else if (lx === 8 || ly === 6) c = '#cfc3a8';
        else c = STONES[hash(col, row, 3) % 4];
      }
    } else if (t === WATER) {
      const d = dist[i] + (dith(x, y) - 0.5) * 3;
      if (dist[i] <= 1) c = '#f2fbff'; else if (dist[i] === 2) c = '#cdeef9'; else c = d < 7 ? WAT[2] : d < 13 ? WAT[1] : WAT[0];
      if (near(x, y, 2, PIER) && (TER[(y - 2) * GW_ + x] === PIER || TER[y * GW_ + x - 2] === PIER)) c = '#6aaecb';
    } else if (t === SOIL) {
      const r = y % 5; c = r === 0 ? '#7d5532' : r === 1 ? '#b9875a' : (hash(x, y, 7) % 9 === 0 ? '#b9875a' : '#9a6a3e');
    } else if (t === PIER) {
      const row = Math.floor(y / 4), ly = y % 4, tx = Math.floor(x / TS), lx = x % TS;
      const leftEdge = rawAt(x - 1, y) !== PIER, rightEdge = rawAt(x + 1, y) !== PIER;
      if (leftEdge || rightEdge) c = INK;
      else if (ly === 3) c = '#6e4a2c';
      else if ((lx === 2 || lx === 13) && ly === 1) c = '#5a3a2a';
      else if ((x * 7 + row * 13) % 11 === 0) c = '#a8683f';
      else c = ['#c78659', '#bf7d52', '#cf9064'][hash(row, tx, 2) % 3];
    }
    const n = parseInt(c.slice(1), 16), k = i * 4; D[k] = n >> 16; D[k + 1] = (n >> 8) & 255; D[k + 2] = n & 255; D[k + 3] = 255;
  }
  g.putImageData(img, 0, 0);
  const p = (x, y, c, w = 1, h = 1) => { g.fillStyle = c; g.fillRect(x, y, w, h); };
  // grass blades, flower clumps with stems, pebbles on paths
  for (let ty = 1; ty < MH - 1; ty++) for (let tx = 1; tx < MW - 1; tx++) {
    for (let k = 0; k < 4; k++) {
      const x = tx * TS + hash(tx, ty, k) % 15, y = ty * TS + hash(tx, ty, k + 9) % 15;
      const t = TER[y * GW_ + x];
      if (t === GRASS && !near(x, y, 2, WATER)) { p(x, y - 2, '#7cae55', 1, 2); p(x - 1, y - 1, '#7cae55'); p(x + 1, y - 1, '#7cae55'); p(x, y - 3, '#c9e2a3'); }
      if (t === PATH && k < 2) { p(x, y, '#b89c78', 3, 2); p(x, y, '#f3eee3'); p(x + 1, y, '#efe3cc'); }
    }
  }
  for (let i = 0; i < 90; i++) {
    const x = 24 + hash(i, 3) % (GW_ - 48), y = 24 + hash(i, 9) % (GH_ - 48);
    if (TER[y * GW_ + x] !== GRASS || B[Math.floor(y / TS)][Math.floor(x / TS)] || near(x, y, 3, WATER)) continue;
    const col = ['#f29bb8', '#fbf7ee', '#f9c776', '#a5bbe8', '#f5777d'][i % 5];
    for (let f = 0; f < 3; f++) { const fx = x + (f - 1) * 3, fy = y + (f % 2) * 2; p(fx, fy + 1, '#4e7d36', 1, 2); p(fx, fy - 1, col); p(fx - 1, fy, col); p(fx + 1, fy, col); p(fx, fy + 0, '#f9c776'); }
  }
  for (let tx = 26; tx <= 33; tx++) for (const ty of [8, 9]) if (G[ty][tx] === GRASS) for (let k = 0; k < 4; k++) { const x = tx * TS + 2 + (k % 2) * 8, y = ty * TS + 2 + (k >> 1) * 8; p(x + 1, y + 3, '#4e7d36', 1, 2); const c = k % 2 ? '#f29bb8' : '#f5777d'; p(x + 1, y, c); p(x, y + 1, c); p(x + 2, y + 1, c); p(x + 1, y + 2, c); p(x + 1, y + 1, '#f9c776'); }
})();
const terrainAt = (x, y) => (x < 0 || y < 0 || x >= GW_ || y >= GH_) ? GRASS : TER[(y | 0) * GW_ + (x | 0)];

/* ---------- props (y-sorted with the people) ---------- */
const PROPS = [], DECALS = [], CHIMNEYS = [];
const prop = (img, x, y, ox, oy, shadow) => PROPS.push({img, x, y, ox, oy, shadow});
BUILDINGS.forEach(b => { prop(house(b), b.x * TS, (b.y + b.h) * TS, 0, b.h * TS + 6, 0); PROPS[PROPS.length - 1].house = b; CHIMNEYS.push([b.x * TS + b.w * TS - 12, (b.y + b.h) * TS - (b.h * TS + 6)]); });
prop(FOUNTAIN, 19.5 * TS, 15 * TS, 32, 54, 26); block(18, 12, 21, 14);
const trees = [];
for (let x = 1; x < MW - 1; x += 2) { trees.push([x, 1]); trees.push([x, MH - 2]); }
for (let y = 3; y < MH - 2; y += 2) { trees.push([1, y]); trees.push([MW - 2, y]); }
trees.push([10, 9], [24, 4], [36, 9], [15, 22], [23, 25], [36, 16], [2, 10]);
trees.forEach(([tx, ty]) => { if (G[ty][tx] === PATH) return; const h = hash(tx, ty); const img = h % 5 === 0 ? PINE : h % 4 === 1 ? BLOSSOM : OAK; prop(img, tx * TS + 8, (ty + 1) * TS - 1, img === PINE ? 13 : 17, img === PINE ? 43 : 40, 12); block(tx, ty, tx, ty); });
[[15, 10], [22, 10], [15, 17]].forEach(([tx, ty]) => { prop(BENCH, tx * TS + 16, (ty + 1) * TS - 2, 16, 16); block(tx, ty, tx + 1, ty); });
[[4, 12], [12, 12], [26, 12], [35, 12], [4, 15], [35, 15]].forEach(([tx, ty]) => { prop(LAMP, tx * TS + 8, (ty + 1) * TS - 2, 6, 34); block(tx, ty, tx, ty); });
prop(STALL, 23 * TS + 2, 17 * TS + 14, 0, 44); block(23, 15, 25, 17);
prop(SIGN, 21 * TS + 8, 12 * TS - 2, 9, 20); block(21, 11, 21, 11);
[[11, 16], [13, 19], [3, 16], [22, 23]].forEach(([tx, ty]) => { prop(ROCK, tx * TS + 8, ty * TS + 12, 7, 9); block(tx, ty, tx, ty); });
// shop clutter
[[9, 8, BARREL], [10, 8, CRATE], [2, 8, BARREL], [18, 7, CRATE], [10, 7, BARREL]].forEach(([tx, ty, img]) => { if (B[ty][tx] || G[ty][tx] === PATH) return; prop(img, tx * TS + 8, (ty + 1) * TS - 1, img.width / 2, img.height - 1); block(tx, ty, tx, ty); });
[[26, 8, 0], [33, 8, 1], [26, 9, 2], [33, 9, 0], [8, 8, 1]].forEach(([tx, ty, v]) => { if (B[ty][tx]) return; prop(POT[v], tx * TS + 8, (ty + 1) * TS - 2, 6, 15); });
// greenery
const greenSpots = [];
for (let i = 0; i < 140; i++) { const tx = 2 + hash(i, 41) % (MW - 4), ty = 2 + hash(i, 43) % (MH - 4); if (G[ty][tx] !== GRASS || B[ty][tx]) continue; greenSpots.push([tx, ty, i]); }
greenSpots.forEach(([tx, ty, i]) => {
  const x = tx * TS + 4 + hash(i, 1) % 8, y = ty * TS + 8 + hash(i, 2) % 7;
  if (terrainAt(x, y) !== GRASS) return;
  if (i % 7 === 0) { prop(BUSH[i % 3], x, y + 2, 11, 15); block(tx, ty, tx, ty); }
  else if (i % 7 === 3) prop(MUSHROOM, x, y, 5, 9);
  else prop(TUFT[i % 2], x, y, 8, 14);
});
// pond life and the boat
[[4, 20, 0], [10, 22, 1], [5, 23, 0], [11, 20, 0], [9, 24, 1]].forEach(([tx, ty, v]) => { if (G[ty][tx] === WATER) DECALS.push({img: LILY[v], x: tx * TS + 2, y: ty * TS + 4}); });
[[2, 19], [12, 18], [3, 24], [12, 23], [13, 21]].forEach(([tx, ty]) => { if (G[ty][tx] !== WATER && !B[ty][tx]) prop(REEDS, tx * TS + 8, (ty + 1) * TS - 4, 7, 21); });
DECALS.push({img: BOAT, x: 9 * TS + 2, y: 19 * TS + 6});
// garden
for (let tx = 26; tx <= 36; tx++) { if (tx === 30 || tx === 31) continue; prop(FENCE_H, tx * TS + 8, 18 * TS + 14, 8, 14); block(tx, 18, tx, 18); }
for (let tx = 26; tx <= 36; tx++) prop(FENCE_H, tx * TS + 8, 26 * TS + 4, 8, 14);
for (let ty = 19; ty <= 25; ty++) { prop(FENCE_V, 26 * TS + 4, ty * TS + 16, 4, 18); prop(FENCE_V, 36 * TS + 12, ty * TS + 16, 4, 18); block(26, ty, 26, ty); block(36, ty, 36, ty); }
for (const ty of [20, 22, 24]) for (let tx = 27; tx <= 35; tx++) prop((tx + ty) % 3 ? CABBAGE : CARROT, tx * TS + 8, ty * TS + 12, 6, 9);

/* ---------- ambient life ---------- */
const PETALS = Array.from({length: 16}, (_, i) => ({ph: i * 0.37, sx: hash(i, 77) % 1000 / 1000, sy: hash(i, 78) % 1000 / 1000, c: i % 3 ? '#f29bb8' : '#fdc9ca'}));
const FLIES = [[29, 10, '#f9c776'], [31, 21, '#fbf7ee'], [7, 11, '#a5bbe8']].map(([tx, ty, c], i) => ({x: tx * TS, y: ty * TS, c, i}));
function drawAmbient(ctx, t, camX, camY, VW, VH) {
  // drifting water glints
  for (let i = 0; i < 26; i++) {
    const x = (hash(i, 11) % (14 * TS)) + TS + Math.sin(t * 0.6 + i) * 3, y = 17 * TS + (hash(i, 12) % (9 * TS)) + ((t * 3 + i * 5) % 6);
    if (terrainAt(x, y) === WATER && terrainAt(x + 3, y) === WATER && terrainAt(x, y + 3) === WATER) { ctx.fillStyle = (i + Math.floor(t * 2)) % 3 ? '#e6f6fc' : '#ffffff'; ctx.fillRect(Math.round(x), Math.round(y), 3, 1); }
  }
  // chimney smoke
  for (const [cx, cy] of CHIMNEYS) for (let k = 0; k < 4; k++) {
    const ph = (t * 0.35 + k / 4) % 1, r = 1.5 + ph * 3.2;
    ctx.fillStyle = `rgba(251,247,238,${0.85 * (1 - ph)})`; ctx.beginPath(); ctx.arc(cx + Math.sin(ph * 5 + k) * 3 + ph * 6, cy - 2 - ph * 22, r, 0, Math.PI * 2); ctx.fill();
  }
  // petals drifting across the view
  for (const p of PETALS) {
    const x = camX + ((p.sx * VW + t * 14 + Math.sin(t + p.ph * 9) * 8) % (VW + 20)) - 10, y = camY + ((p.sy * VH + t * 9 + p.ph * 40) % (VH + 20)) - 10;
    ctx.fillStyle = p.c; ctx.fillRect(Math.round(x), Math.round(y), 2, 1); if (Math.floor(t * 4 + p.ph * 10) % 2) ctx.fillRect(Math.round(x) + 1, Math.round(y) + 1, 1, 1);
  }
  // butterflies
  for (const f of FLIES) {
    const x = f.x + Math.sin(t * 0.7 + f.i * 2) * 26, y = f.y + Math.sin(t * 1.3 + f.i) * 12 - 6, open = Math.floor(t * 8 + f.i) % 2;
    ctx.fillStyle = f.c; ctx.fillRect(Math.round(x) - (open ? 2 : 1), Math.round(y), open ? 2 : 1, 2); ctx.fillRect(Math.round(x) + 1, Math.round(y), open ? 2 : 1, 2);
    ctx.fillStyle = INK; ctx.fillRect(Math.round(x), Math.round(y), 1, 2);
  }
}

/* ---------- people ---------- */
const LISTS = {hair:HAIRS, hairColor:HAIR_COLORS, face:FACES, skin:SKINS, facialHair:FACIAL_HAIR, facialWear:FACIAL_WEAR, hat:HATS, outfit:OUTFITS, dye:DYES, weapon:WEAPONS, offhand:OFFHANDS, neck:NECKWEAR, portraitBg:PORTRAIT_BG, eyeColor:EYE_COLORS, pet:PETS, body:BODIES, eyeShape:EYE_SHAPES};
function toIdx(l) { const o = Object.assign({}, l); for (const k in LISTS) o[k] = Math.max(0, byId(LISTS[k], l[k] == null ? LISTS[k][0].id : l[k])); o.tier = l.tier || 1; o.emote = 0; o.portraitTilt = FRONT_TILT; return o; }
const preset = (list, name) => list.find(p => p.name === name).look;
// who lives where, what they say in passing, what they think, and what they tell you
const PEOPLE = [
  {name: 'Baker', look: preset(TOWN, 'Baker'), at: [5, 9], r: 2, say: ['Fresh bread!', 'Mind the crumbs!'], think: ['heart', 'Honey loaf...'],
    talk: [['n', 'smile', "Morning! The ovens have been on since before the roosters."], ['n', 'happy', "Try the honey loaf. Grandpa says it's why he still has his teeth."], ['p', 'laugh', "I'll take two."], ['n', 'wink', 'Smart choice.']]},
  {name: 'Chef', look: preset(TOWN, 'Chef'), at: [8, 10], r: 2, say: ['Soup is on!', 'Needs more...'], think: ['question', 'Salt? No...'],
    talk: [['n', 'concerned', "Something's missing from my stew. Not salt. Not pepper."], ['n', 'surprised', 'Wait. Did someone take my spoon?'], ['n', 'sad', "...Oh. It's in my hand."], ['p', 'smile', 'Happens to the best of us.']]},
  {name: 'Florist', look: preset(TOWN, 'Florist'), at: [30, 10], r: 2, say: ['Tulips are in!', 'Smell these!'], think: ['heart', 'sparkle'],
    talk: [['n', 'happy', 'Welcome! Every flower here has a meaning, you know.'], ['n', 'wink', 'Yellow means friendship. Red means... well. Ask the Bard.'], ['n', 'smile', 'Take a daisy. It looks good on everyone.']]},
  {name: 'Gardener', look: preset(TOWN, 'Gardener'), at: [29, 21], r: 2, say: ['Grow, little ones!'], think: ['rain', 'music'],
    talk: [['n', 'smile', 'The carrots are almost ready. I sing to them in the mornings.'], ['n', 'concerned', 'The Farmer says that is silly. His carrots are smaller, though.']]},
  {name: 'Farmer', look: preset(TOWN, 'Farmer'), at: [33, 23], r: 2, say: ['Good soil today.'], think: ['sleep', 'Rain soon?'],
    talk: [['n', 'neutral', "Sun's up, so I'm up. That's the whole secret."], ['n', 'laugh', 'She sings to her carrots. I just ask mine nicely.']]},
  {name: 'Fisher', look: preset(TOWN, 'Fisher'), at: [7, 21], r: 0, face: 'down', say: ['...nothing yet.', 'Shh!'], think: ['dots', 'Big one...'],
    talk: [['n', 'sleepy', "Shh. The big one's down there. I can feel it."], ['n', 'surprised', 'Was that a bite?!'], ['n', 'sad', '...It was my boot.']]},
  {name: 'Sailor', look: preset(TOWN, 'Sailor'), at: [11, 17], r: 1, say: ['Ahoy!', 'Fair winds!'], think: ['star', 'The sea...'],
    talk: [['n', 'excited', "Ahoy! This pond is the smallest sea I've ever sailed."], ['n', 'smile', "Someday I'll follow the river all the way to the real ocean."]]},
  {name: 'Pirate', look: preset(TOWN, 'Pirate'), at: [4, 16], r: 1, say: ['Arr...', 'Treasure!'], think: ['idea', 'X marks...'],
    talk: [['n', 'wink', "Psst. Rumor says there's treasure under the fountain."], ['n', 'concerned', "Don't tell the Knight I said that."], ['p', 'surprised', 'Is there really?'], ['n', 'laugh', "No idea! That's what makes it a rumor."]]},
  {name: 'Grandma', look: preset(TOWN, 'Grandma'), at: [15, 11], r: 0, face: 'down', say: ['Lovely day.', 'Hello, dear!'], think: ['heart', 'Tea time...'],
    talk: [['n', 'smile', "Oh, hello dear. You've grown since last spring."], ['n', 'happy', 'When I was young this square was just a well and three chickens.'], ['n', 'wink', 'Two of the chickens were very rude.']]},
  {name: 'Grandpa', look: preset(TOWN, 'Grandpa'), at: [16, 11], r: 0, face: 'down', say: ['Back in my day...'], think: ['sleep', 'Zzz'],
    talk: [['n', 'sleepy', "Mm? Oh. I wasn't sleeping. I was resting my eyes."], ['n', 'laugh', "The Baker's honey loaf. That's my secret."]]},
  {name: 'Barista', look: preset(TOWN, 'Barista'), at: [24, 18], r: 0, face: 'down', say: ['Hot cocoa!', 'Coffee?'], think: ['music', 'Marshmallows'],
    talk: [['n', 'smile', "One cocoa, extra marshmallows? It's on the house for new faces."], ['n', 'excited', 'Word is a traveler from beyond the hills is coming to the guild.']]},
  {name: 'Bard', look: preset(JOBS, 'Bard'), at: [22, 12], r: 1, say: ['La la la!', 'A song?'], think: ['music', 'Rhymes with cheese'],
    talk: [['n', 'happy', 'A song for you? I only know one, and it is about cheese.'], ['n', 'excited', 'Oh cheddar, my cheddar, you never let me down...'], ['p', 'laugh', 'Bravo!'], ['n', 'love', 'You are too kind.']]},
  {name: 'Knight', look: preset(JOBS, 'Knight'), at: [14, 9], r: 1, say: ['All clear.', 'Halt!'], think: ['alert', 'Stay sharp'],
    talk: [['n', 'neutral', 'Halt! ...Sorry. I always wanted to say that.'], ['n', 'smile', 'The guild is recruiting. Bring a sword, or at least a stick.']]},
  {name: 'Black Mage', look: preset(JOBS, 'Black Mage'), at: [11, 10], r: 2, say: ['A small spell...', 'Oops.'], think: ['idea', 'sparkle'],
    talk: [['n', 'concerned', "I'm practicing a small spell. Very small. Please step back."], ['n', 'surprised', '...Oh! That was supposed to be a candle.']]},
  {name: 'White Mage', look: preset(JOBS, 'White Mage'), at: [17, 9], r: 2, say: ['Stay healthy!'], think: ['heart', 'Bandages?'],
    talk: [['n', 'smile', 'Scraped knee? Hiccups? Broken heart? I can help with two of those.'], ['p', 'concerned', 'Which two?'], ['n', 'wink', 'Come back with one and find out.']]},
  {name: 'Berserker', look: preset(JOBS, 'Berserker'), at: [12, 11], r: 1, say: ['HRRAH!', 'Strong!'], think: ['anger', 'Lunch?'],
    talk: [['n', 'angry', 'WHO TOUCHED MY AXE?'], ['n', 'happy', 'Oh, it was you? Good grip. You may keep touching it.']]},
  {name: 'Samurai', look: preset(JOBS, 'Samurai'), at: [24, 6], r: 1, say: ['...', 'Breathe.'], think: ['sparkle', 'Calm'],
    talk: [['n', 'neutral', 'A calm mind cuts cleaner than a sharp blade.'], ['n', 'wink', 'But a sharp blade also helps.']]},
  {name: 'Druid', look: preset(JOBS, 'Druid'), at: [16, 21], r: 2, say: ['Hello, little ones.'], think: ['heart', 'leaves'],
    talk: [['n', 'happy', "This is Mochi. She's a slime, but she's very polite."], ['n', 'smile', 'The forest east of town is waking up. Can you feel it too?']]},
  {name: 'Thief', look: preset(JOBS, 'Thief'), at: [10, 7], r: 1, say: ['...'], think: ['dots', 'Shiny...'],
    talk: [['n', 'wink', "You didn't see me."], ['n', 'surprised', 'Wait. You can see me?']]},
  {name: 'Monk', look: preset(JOBS, 'Monk'), at: [27, 15], r: 2, say: ['Hup! Hup!', 'Ninety-nine!'], think: ['sweat', 'One hundred'],
    talk: [['n', 'excited', 'Ninety-eight! Ninety-nine! ...Hello! One hundred!'], ['n', 'laugh', 'Join me tomorrow at dawn. Bring water.']]},
  {name: 'Boy', look: preset(TOWN, 'Boy'), at: [17, 16], r: 4, fast: true, say: ['Tag!', 'Catch me!'], think: ['star', 'Adventure!'],
    talk: [['n', 'excited', 'Are you a real adventurer? Can I hold your stuff?'], ['p', 'smile', 'Maybe when you are older.'], ['n', 'sad', '...Not even the stick?']]},
  {name: 'Girl', look: preset(TOWN, 'Girl'), at: [21, 17], r: 4, fast: true, say: ["You're it!", 'Rawr!'], think: ['heart', 'Dragons!'],
    talk: [['n', 'laugh', "We're playing knights and dragons! I'm the dragon."], ['n', 'angry', 'RAWR.'], ['p', 'surprised', 'Terrifying.']]},
];
const SMALL_TALK = [['Lovely day!', "Isn't it?"], ['Heard the news?', 'The bread?'], ['Nice hat!', 'Thank you!'], ['Seen the Fisher?', 'Still fishing.'], ['Busy day?', 'Always!'], ['Tea later?', 'Yes please!']];
const CAST = PEOPLE.map(p => p.name);
/* ---------- training dummies ---------- */
const DUMMY_IMG = sprite(18, 30, (x, y) => {
  if (x >= 8 && x <= 9 && y >= 20) return x === 8 ? '#c78659' : '#9a6a3e';
  if (y >= 3 && y <= 8 && inEll(x, y, 9, 6, 5, 4)) return inEll(x, y, 9, 6, 2.2, 1.8) ? '#db614f' : inEll(x, y, 9, 6, 3.6, 3) ? '#fbf7ee' : '#e9cfb5';
  if (y >= 9 && y <= 21 && x >= 3 && x <= 14) { if (y === 13 || y === 14) return x % 2 ? '#c78659' : '#9a6a3e'; return x <= 4 ? '#f9c776' : x >= 13 ? '#c99a3a' : (x + y) % 4 === 0 ? '#e0a94e' : '#f2c35c'; }
  if (y >= 11 && y <= 13 && (x <= 2 || x >= 15) && x >= 0 && x <= 17) return '#9a6a3e';
  return null;
});
const whiteOf = img => { const c = document.createElement('canvas'); c.width = img.width; c.height = img.height; const x = c.getContext('2d'); x.drawImage(img, 0, 0); x.globalCompositeOperation = 'source-in'; x.fillStyle = '#ffffff'; x.fillRect(0, 0, c.width, c.height); return c; };
const DUMMY_FLASH = whiteOf(DUMMY_IMG);
const dummies = [[29, 16], [32, 15], [35, 16]].map(([tx, ty]) => { block(tx, ty, tx, ty); return {kind: 'dummy', x: tx * TS + 8, y: ty * TS + 14, hit: 0, wob: 0}; });
export {PAL, compose, ACTIONS, EMOTES, EMOTE_COLORS, FACES, HAIRS, HATS, WEAPONS, OUTFITS, composePortraitHF, portraitBg, TOWN, JOBS, byId, toIdx, PEOPLE, SMALL_TALK, ground, PROPS, DECALS, drawAmbient, sprite, inEll, C, INK, TS, MW, MH, DUMMY_IMG, dummies, FRONT_TILT, LISTS, OAK, BLOSSOM, PINE, REEDS, MUSHROOM, BARREL, CRATE, BOAT, BENCH, LAMP, STALL, FENCE_H, FENCE_V, CABBAGE, CARROT, SIGN, ROCK, POT, BUSH, TUFT, LILY, house, hash, vnoise, dith, ramp, shadeHex, FOUNTAIN};
